'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name corePermissoes
   * @description
   *
   */

  angular.module('corePermissoes', ['headerModule', 'stateUrlModule', 'ngCookies', 'ui.router', 'ui.bootstrap', 'blockUI', 'flash', 'angular-confirm', 'angularMoment', 'daterangepicker', 'compartilhamentos', 'perfis', 'usuarios', 'uos', 'ui.select', 'ngSanitize', 'v3gWebComponents', 'restangular', 'newsModule', 'ngStomp', 'importacaoMotorista', 'importacaoPontoReferencia', 'veiculos', 'VfiltroModule', 'uppercased', 'expurgo', 'histExpurgo', 'ui.utils.masks', 'VtabelaModule', 'enumModule', 'FeatureFlagModule', 'camadaValor', 'pascalprecht.translate', 'angulartics', 'angulartics.google.analytics', 'urlConfigModule', 'httpServiceV3gModule', 'ConstantModule', 'v3gVeiculoModule', 'motoristaModule', 'documentoModule', 'filtroAlertaModule', 'diagnosticoModule', 'sidebarMenuToggleModule', 'uoModule', 'uoArvoreNivelModule', 'linkOnboardingModule', 'v3gValidatorModule', 'modalInfoConfirmModule', 'v3gTrimbleFilters', 'v3gAuthenticatorModule', 'v3gHeaderModule', 'AlertasModule', 'SolucoesModule', 'errorPageModule']).run(configureRestAngular).run(function (Authenticator, $translate, StateUrlService) {
    Authenticator.getUser().then(function (user) {
      $translate.use(user.idioma.toLowerCase());
      $translate.fallbackLanguage('pt_br');
    });
    StateUrlService.initInterceptBloqueioSolucao();
  }).run(['$rootScope', '$state', 'StateUrlService', 'Authenticator', function ($rootScope, $state, StateUrlService) {
    var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, to, toParams, from) {
      $state.previous = from;
    }),
        locationChangeSuccess = $rootScope.$on('$stateChangeSuccess', function () {
      StateUrlService.onPageLoad();
    });

    $rootScope.$on('$destroy', locationChangeSuccess);
    $rootScope.$on('$destroy', stateChangeStart);
  }]).factory('Usuarios', function (Restangular) {
    return Restangular.service('auth/usuario');
  }).config(configI18n);

  function configI18n($translateProvider) {
    $translateProvider.useStaticFilesLoader({
      prefix: 'https://vfleets-i18n.s3.sa-east-1.amazonaws.com/latest/',
      suffix: '.json'
    });
    $translateProvider.useSanitizeValueStrategy('sceParameters');
    $translateProvider.forceAsyncReload(true);
  }

  function configureRestAngular(Restangular, UrlConfigService, Authenticator) {
    Restangular.setBaseUrl(UrlConfigService.getApiGatewayUrl());
    Restangular.setDefaultHttpFields({
      withCredentials: true
    });
    Restangular.setFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
      headers.Authorization = 'Bearer ' + Authenticator.keycloak.token;
      return {
        element: element,
        params: params,
        headers: headers,
        httpConfig: httpConfig
      };
    });
  }
})();
angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuarios/cadastrar/cadastrar-usuario.tpl.html',
    '<div class="modal-header"><h3 class="modal-title">{{ \'core-permissoes.organizacao.usuarios.addUser\' | translate }} </h3></div><div class="modal-body"><form name="cadastroUsuario" class="form-container"><div class="form-group"><label for="uo">{{ \'core-permissoes.organizacao.usuarios.popup.organizationalUnit\' | translate }}</label><ui-select style="width: 100%" ng-model="cadastrarUsuario.uoSelecionada" close-on-select="true" name="uo" id="uo" ng-required="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.selectOu\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="uo as uo in (cadastrarUsuario.uosFiltradas | filter: $select.search | limitTo: cadastrarUsuario.limit) track by uo.id" scroll-detector="cadastrarUsuario.loadMore()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select><span ng-if="cadastroUsuario.uo.$error.required &amp;&amp; cadastroUsuario.uo.$dirty" class="help-block">Selecione a Unidade Organizacional</span></div><div ng-class="{\'has-error\':emailError()!==\'\' &amp;&amp; cadastroUsuario.email.$dirty}" class="form-group"><label for="email">{{ \'core-permissoes.organizacao.usuarios.popup.email\' | translate }}<div uib-tooltip="{{ \'core-permissoes.organizacao.usuarios.popup.emailTooltip\' | translate }}" class="fa fa-info-circle fa-icon-left"></div></label><input type="text" id="email" name="email" ng-required="true" ng-minlength="3" ng-maxlength="50" ng-model="cadastrarUsuario.usuario.login" v3g-validator="emailError" class="form-control"/><span ng-if="emailError()!==\'\' &amp;&amp; cadastroUsuario.email.$dirty" translate="{{emailError()}}" translate-values="{minCaracteres: cadastrarUsuario.minCaracteres, maxCaracteres: cadastrarUsuario.maxCaracteres}" class="help-block"></span></div><div ng-class="{\'has-error\':senhaError()!==\'\' &amp;&amp; cadastroUsuario.senha.$dirty}" ng-if="cadastrarUsuario.usuario.perfil.id === cadastrarUsuario.perfilIntegracao ||        cadastrarUsuario.user.perfil.id === cadastrarUsuario.perfilAdminVeltec" class="form-group"><label for="senha">{{ \'core-permissoes.organizacao.usuarios.popup.password\' | translate }}</label><input type="password" id="senha" name="senha" placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.password\' | translate }}" ng-model="cadastrarUsuario.usuario.senha" v3g-validator="senhaError" class="form-control"/><span ng-if="senhaError()!==\'\' &amp;&amp; cadastroUsuario.senha.$dirty" translate="{{senhaError()}}" class="help-block"></span></div><div class="form-group"><div class="col-sm-12"><div class="checkbox enable-2fa"><input type="checkbox" id="enable2fa" ng-model="cadastrarUsuario.usuario.otpEnabled"/>{{ \'core-permissoes.organizacao.usuarios.popup.enableTwoFactorAuthentication\' | translate }}</div></div></div><div ng-class="{\'has-error\':nomeError()!==\'\' &amp;&amp; cadastroUsuario.nome.$dirty}" class="form-group"><label for="nome">{{ (cadastrarUsuario.isNaOu ? \'core-permissoes.organizacao.usuarios.popup.firstName\' : \'core-permissoes.organizacao.usuarios.popup.fullName\') | translate }}</label><input type="text" id="nome" name="nome" ng-required="true" ng-minlength="{{cadastrarUsuario.isNaOu ? 0 : 3}}" ng-maxlength="50" ng-model="cadastrarUsuario.usuario.nome" v3g-validator="nomeError" class="form-control"/><span ng-if="nomeError()!==\'\' &amp;&amp; cadastroUsuario.nome.$dirty" translate="{{nomeError()}}" translate-values="{minCaracteres: cadastrarUsuario.minCaracteres, maxCaracteres: cadastrarUsuario.maxCaracteres}" class="help-block"></span></div><div ng-if="cadastrarUsuario.isNaOu" ng-class="{\'has-error\':lastNameError()!==\'\' &amp;&amp; cadastroUsuario.lastName.$dirty}" class="form-group"><label for="lastName">{{ \'core-permissoes.organizacao.usuarios.popup.lastName\' | translate }}</label><input type="text" id="lastName" name="lastName" ng-required="true" ng-maxlength="50" ng-model="cadastrarUsuario.usuario.lastName" v3g-validator="lastNameError" class="form-control"/><span ng-if="lastNameError()!==\'\' &amp;&amp; cadastroUsuario.lastName.$dirty" translate="{{lastNameError()}}" translate-values="{maxCaracteres: cadastrarUsuario.maxCaracteres}" class="help-block"></span></div><div ng-class="{\'has-error\':perfilError()!==\'\' &amp;&amp; cadastroUsuario.perfil.$dirty}" class="form-group"><label for="perfil">{{ \'core-permissoes.organizacao.usuarios.popup.profile\' | translate }}</label><select id="perfil" name="perfil" ng-options="perfil.nome for perfil in cadastrarUsuario.perfis track by perfil.id" ng-required="true" ng-model="cadastrarUsuario.usuario.perfil" v3g-validator="perfilError" class="form-control"></select><span ng-if="perfilError()!==\'\' &amp;&amp; cadastroUsuario.perfil.$dirty" translate="{{perfilError()}}" class="help-block"></span></div><div ng-class="{\'has-error\': cadastroUsuario.pais.$error.required &amp;&amp; cadastroUsuario.pais.$dirty}" class="form-group"><label for="pais">{{ \'core-permissoes.organizacao.usuarios.popup.country\' | translate }}</label><ui-select style="width: 100%" ng-model="cadastrarUsuario.usuario.pais" close-on-select="true" name="pais" id="pais" ng-required="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.selectTheCountry\' | translate }}">{{\'core-permissoes.organizacao.usuarios.popup.countries.\' + $select.selected.code.toLowerCase() | translate}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="pais as pais in (cadastrarUsuario.paises | filter: $select.search) track by pais.code"><span ng-bind-html="(\'core-permissoes.organizacao.usuarios.popup.countries.\' + pais.code.toLowerCase() | translate) | highlight: $select.search"></span></ui-select-choices></ui-select><span ng-if="cadastroUsuario.pais.$error.required &amp;&amp; cadastroUsuario.pais.$dirty" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.selectCountry\' | translate }}</span></div><div class="form-group"><label for="idioma">{{ \'core-permissoes.organizacao.usuarios.popup.language\' | translate }}</label><select id="idioma" name="idioma" ng-options="idioma.value for idioma in cadastrarUsuario.idiomasEnum.getAllIdiomas()" ng-required="true" ng-model="cadastrarUsuario.usuario.idioma" class="form-control"></select></div><div ng-if="cadastrarUsuario.isMeasurementSystemEnabled" ng-class="{\'has-error\': cadastroUsuario.measurementSystem.$error.required &amp;&amp; cadastroUsuario.measurementSystem.$dirty}" class="form-group"><label for="measurementSystem">{{ \'core-permissoes.organizacao.usuarios.popup.measurementSystem\' | translate }}</label><select id="measurementSystem" name="measurementSystem" ng-options="system.key as (system.label | translate) for system in cadastrarUsuario.measurementSystemEnum.getAllSystems()" ng-required="true" ng-model="cadastrarUsuario.usuario.measurementSystem" class="form-control"></select></div><div class="form-group"><label for="paisTelefone" ng-class="{\'error-label\': cadastrarUsuario.labelError(cadastroUsuario)}">{{ \'core-permissoes.organizacao.usuarios.popup.telephone\' | translate }}</label><span class="opcional">&nbsp;- {{ \'core-permissoes.organizacao.usuarios.popup.optional\' | translate }}</span><div class="row"><div class="col-sm-3"><ui-select style="width: 100%" ng-model="cadastrarUsuario.usuario.paisTelefone" close-on-select="true" name="paisTelefone" ng-class="{\'error-border\': cadastrarUsuario.ddiError(cadastroUsuario) ||                                          cadastrarUsuario.dddDdiError(cadastroUsuario)}" id="paisTelefone"><ui-select-match placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.countryCode\' | translate }}"><img ng-src="{{cadastrarUsuario.mapBandeiras.get($select.selected.code)}}" class="bandeira-input bandeira-selected"/><span>+{{$select.selected.ddi}}</span></ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="pais as pais in (cadastrarUsuario.paises | filter: $select.search) track by pais.code"><img ng-src="{{cadastrarUsuario.mapBandeiras.get(pais.code)}}" class="bandeira-input bandeira-choice"/><span ng-bind-html="&quot;+&quot; + pais.ddi  | highlight: $select.search"></span></ui-select-choices></ui-select><span ng-class="{\'error-label\': true}" ng-if="cadastrarUsuario.ddiError(cadastroUsuario)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInCountryCode\' | translate }}</span></div><div class="col-sm-2"><input type="text" id="ddd" placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.areaCode\' | translate }}" maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" name="ddd" ng-model="cadastrarUsuario.usuario.ddd" ng-class="{\'error-border\': cadastrarUsuario.dddError(cadastroUsuario) ||                                          cadastrarUsuario.dddDdiError(cadastroUsuario)}" class="form-control"/><span ng-class="{\'error-label\': true}" ng-if="cadastrarUsuario.dddError(cadastroUsuario)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInAreaCode\' | translate }}</span></div><div class="col-sm-7"><input type="text" id="telefone" placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.number\' | translate }}" maxlength="15" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" name="telefone" ng-model="cadastrarUsuario.usuario.telefone" ng-class="{\'error-border\': cadastrarUsuario.telefoneError(cadastroUsuario)}" class="form-control"/><span ng-class="{\'error-label\': true}" ng-if="cadastrarUsuario.telefoneError(cadastroUsuario)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.requiredField\' | translate }}</span></div></div><span ng-class="{\'error-label\': true}" ng-if="cadastrarUsuario.dddDdiError(cadastroUsuario)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInAreaCodeAndCountryCode\' | translate }}</span></div><div class="form-group"><label for="cargo">{{ \'core-permissoes.organizacao.usuarios.popup.jobTitle\' | translate }}</label><span class="opcional">&nbsp;- {{ \'core-permissoes.organizacao.usuarios.popup.optional\' | translate }}</span><input type="text" id="cargo" name="cargo" ng-model="cadastrarUsuario.usuario.cargo" class="form-control"/></div><div ng-class="{\'error-label\': cadastrarUsuario.responsavelError(cadastroUsuario)}" class="form-group"><label>{{ \'core-permissoes.organizacao.usuarios.cadastro.responsavelPassivel\' | translate }}</label><span class="passivel-descricao">{{ \'core-permissoes.organizacao.usuarios.cadastro.descricaoResponsavel\' | translate }}</span><div class="radio"><label><input id="isResponsavelPassiveis" name="isResponsavelPassiveis" ng-model="cadastrarUsuario.usuario.isResponsavelPassiveis" required="true" type="radio" value="true"/>{{ \'common.sim\' | translate }}</label></div><div class="radio"><label><input id="isResponsavelPassiveisNot" name="isResponsavelPassiveis" ng-model="cadastrarUsuario.usuario.isResponsavelPassiveis" required="true" type="radio" value="false"/>{{ \'common.nao\' | translate }}</label></div><span ng-class="{\'error-label\': true}" ng-if="cadastrarUsuario.responsavelError(cadastroUsuario)" class="help-block">{{ \'v3gwc.validacao.campoObrigatorio\' | translate }}</span></div><div ng-if="cadastrarUsuario.userCanEditOU()" class="form-group"><label>{{ \'core-permissoes.organizacao.usuarios.cadastro.trocaUo\' | translate }}</label><span class="troca-uo-descricao">{{ \'core-permissoes.organizacao.usuarios.cadastro.descricaoTrocaUo\' | translate }}</span><div class="radio"> <label><input id="acessoTrocaUo" name="acessoTrocaUo" ng-model="cadastrarUsuario.usuario.acessoTrocaUo" type="radio" value="true"/>{{ \'common.sim\' | translate }}</label></div><div class="radio"><label><input id="acessoTrocaUoNot" name="acessoTrocaUo" ng-model="cadastrarUsuario.usuario.acessoTrocaUo" type="radio" value="false"/>{{ \'common.nao\' | translate }}</label></div></div></form></div><div flash-message="5000"></div><div class="modal-footer"><button type="button" ng-click="cadastrarUsuario.ok(cadastroUsuario)" class="btn btn-success">OK</button><button type="button" ng-click="cadastrarUsuario.cancel()" class="btn btn-default">{{ \'core-permissoes.organizacao.usuarios.popup.cancel\' | translate }}</button></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuarios/editar/editar-usuario.tpl.html',
    '<div class="modal-header"><h3 class="modal-title">{{ \'core-permissoes.organizacao.usuarios.popup.editUser\' | translate }}</h3></div><div class="modal-body"><form name="edicaoUsuarioForm" class="form-container"><div class="alerta-2fa-aqui"></div><div class="form-group"><label>{{ \'core-permissoes.organizacao.usuarios.popup.organizationalUnit\' | translate }}</label><ui-select style="width: 100%" name="uo" id="uo" ng-model="editarUsuario.uoSelecionada" close-on-select="true" ng-required="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.selectOu\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="uo as uo in (editarUsuario.uoArvore | filter: $select.search | limitTo: editarUsuario.limit) track by uo.id" scroll-detector="editarUsuario.loadMore()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select></div><div class="form-group"><label for="login">{{ \'core-permissoes.organizacao.usuarios.popup.email\' | translate }}</label><input type="text" id="login" name="login" placeholder="Login" readonly="readonly" ng-model="editarUsuario.usuario.login" class="form-control"/></div><div ng-if="editarUsuario.perfilSelecionado.id === editarUsuario.perfilIntegracao ||       editarUsuario.user.perfil.id === editarUsuario.perfilAdminVeltec" class="form-group"><label for="senha">{{ \'core-permissoes.organizacao.usuarios.popup.password\' | translate }}</label><input type="password" id="senha" placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.password\' | translate }}" ng-model="editarUsuario.usuario.senha" class="form-control"/></div><div ng-if="editarUsuario.canChange2fa" class="form-group"><div class="col-sm-12"><div class="checkbox enable-2fa"><input type="checkbox" id="enable2fa" ng-change="editarUsuario.change2fa()" ng-model="editarUsuario.enable2fa"/>{{ \'core-permissoes.organizacao.usuarios.popup.enableTwoFactorAuthentication\' | translate }}</div></div></div><div ng-class="{\'has-error\':nomeError()!==\'\' &amp;&amp; edicaoUsuarioForm.nome.$dirty}" class="form-group"><label for="nome">{{ (editarUsuario.isNaOu ? \'core-permissoes.organizacao.usuarios.popup.firstName\' : \'core-permissoes.organizacao.usuarios.popup.fullName\') | translate }}</label><input type="text" name="nome" ng-required="true" ng-minlength="3" ng-maxlength="50" ng-model="editarUsuario.usuario.nome" v3g-validator="nomeError" class="form-control"/><span ng-if="nomeError()!==\'\' &amp;&amp; edicaoUsuarioForm.nome.$dirty" translate="{{nomeError()}}" translate-values="{minCaracteres: editarUsuario.minCaracteres, maxCaracteres: editarUsuario.maxCaracteres}" class="help-block"></span></div><div ng-if="editarUsuario.isNaOu" ng-class="{\'has-error\':lastNameError()!==\'\' &amp;&amp; edicaoUsuarioForm.lastName.$dirty}" class="form-group"><label for="lastName">{{ \'core-permissoes.organizacao.usuarios.popup.lastName\' | translate }}</label><input type="text" id="lastName" name="lastName" ng-maxlength="50" ng-model="editarUsuario.usuario.lastName" v3g-validator="lastNameError" class="form-control"/><span ng-if="lastNameError()!==\'\' &amp;&amp; edicaoUsuarioForm.lastName.$dirty" translate="{{lastNameError()}}" translate-values="{maxCaracteres: editarUsuario.maxCaracteres}" class="help-block"></span></div><div ng-class="{\'has-error\':perfilError()!==\'\' &amp;&amp; edicaoUsuarioForm.perfil.$dirty}" class="form-group"><label for="perfil">{{ \'core-permissoes.organizacao.usuarios.popup.profile\' | translate }}</label><select id="perfil" name="perfil" ng-required="true" ng-options="perfil.nome for perfil in editarUsuario.perfis track by perfil.id" ng-model="editarUsuario.perfilSelecionado" v3g-validator="perfilError" class="form-control"></select><span ng-if="perfilError()!==\'\' &amp;&amp; edicaoUsuarioForm.perfil.$dirty" translate="{{perfilError()}}" class="help-block"></span></div><div ng-class="{\'has-error\': edicaoUsuarioForm.pais.$error.required &amp;&amp; edicaoUsuarioForm.pais.$dirty}" class="form-group"><label for="pais">{{ \'core-permissoes.organizacao.usuarios.popup.country\' | translate }}</label><ui-select style="width: 100%" ng-model="editarUsuario.usuario.pais" close-on-select="true" name="pais" id="pais" ng-required="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.selectTheCountry\' | translate }}">{{\'core-permissoes.organizacao.usuarios.popup.countries.\' + $select.selected.code.toLowerCase() | translate}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="pais as pais in (editarUsuario.paises | filter: $select.search) track by pais.code"><span ng-bind-html="(\'core-permissoes.organizacao.usuarios.popup.countries.\' + pais.code.toLowerCase() | translate) | highlight: $select.search"></span></ui-select-choices></ui-select><span ng-if="edicaoUsuarioForm.pais.$error.required &amp;&amp; edicaoUsuarioForm.pais.$dirty" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.selectCountry\' | translate }}</span></div><div ng-class="{\'has-error\': edicaoUsuarioForm.usuario.idioma.$error.required &amp;&amp; edicaoUsuarioForm.usuario.idioma.$dirty}" class="form-group"><label for="idioma">{{ \'core-permissoes.organizacao.usuarios.popup.language\' | translate }}</label><select id="idioma" name="idioma" ng-options="idioma.value for idioma in editarUsuario.idiomasEnum.getAllIdiomas()" ng-required="true" ng-model="editarUsuario.idiomaSelecionado" class="form-control"><span ng-if="edicaoUsuarioForm.usuario.idioma.$error.required &amp;&amp; edicaoUsuarioForm.usuario.idioma.$dirty" class="help-block">Selecione o Idioma</span></select></div><div ng-if="editarUsuario.isMeasurementSystemEnabled" ng-class="{\'has-error\': edicaoUsuarioForm.measurementSystem.$error.required &amp;&amp; edicaoUsuarioForm.measurementSystem.$dirty}" class="form-group"><label for="measurementSystem">{{ \'core-permissoes.organizacao.usuarios.popup.measurementSystem\' | translate }}</label><select id="measurementSystem" name="measurementSystem" ng-options="system.key as (system.label | translate) for system in editarUsuario.measurementSystemEnum.getAllSystems()" ng-required="true" ng-model="editarUsuario.usuario.measurementSystem" class="form-control"></select></div><div class="form-group"><label for="paisTelefone" ng-class="{\'error-label\': editarUsuario.labelError(edicaoUsuarioForm)}">{{ \'core-permissoes.organizacao.usuarios.popup.telephone\' | translate }}</label><span ng-if="!editarUsuario.telefoneCadastrado" class="opcional">&nbsp;- {{ \'core-permissoes.organizacao.usuarios.popup.optional\' | translate }}</span><div class="row"><div class="col-sm-3"><ui-select style="width: 100%" ng-model="editarUsuario.usuario.paisTelefone" close-on-select="true" name="paisTelefone" ng-class="{\'error-border\': editarUsuario.ddiError(edicaoUsuarioForm) ||                                          editarUsuario.dddDdiError(edicaoUsuarioForm)}" id="paisTelefone"><ui-select-match placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.countryCode\' | translate }}"><img ng-src="{{editarUsuario.mapBandeiras.get($select.selected.code)}}" class="bandeira-input bandeira-selected"/><span>+{{$select.selected.ddi}}</span></ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="pais as pais in (editarUsuario.paises | filter: $select.search) track by pais.code"><img ng-src="{{editarUsuario.mapBandeiras.get(pais.code)}}" class="bandeira-input bandeira-choice"/><span ng-bind-html="&quot;+&quot; + pais.ddi  | highlight: $select.search"></span></ui-select-choices></ui-select><span ng-class="{\'error-label\': true}" ng-if="editarUsuario.ddiError(edicaoUsuarioForm)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInCountryCode\' | translate }}</span></div><div class="col-sm-2"><input type="text" id="ddd" placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInAreaCode\' | translate }}" maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" name="ddd" ng-model="editarUsuario.usuario.ddd" ng-class="{\'error-border\': editarUsuario.dddError(edicaoUsuarioForm) ||                                          editarUsuario.dddDdiError(edicaoUsuarioForm)}" class="form-control"/><span ng-class="{\'error-label\': true}" ng-if="editarUsuario.dddError(edicaoUsuarioForm)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInAreaCode\' | translate }}</span></div><div class="col-sm-7"><input type="text" id="telefone" placeholder="{{ \'core-permissoes.organizacao.usuarios.popup.number\' | translate }}" maxlength="15" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" name="telefone" ng-model="editarUsuario.usuario.telefone" ng-required="editarUsuario.telefoneCadastrado" v3g-validator="telefoneError" ng-class="{\'error-border\': editarUsuario.telefoneError(edicaoUsuarioForm)}" class="form-control"/><span ng-class="{\'error-label\': true}" ng-if="editarUsuario.telefoneError(edicaoUsuarioForm)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.requiredField\' | translate }}</span></div></div></div><span ng-class="{\'error-label\': true}" ng-if="editarUsuario.dddDdiError(edicaoUsuarioForm)" class="help-block">{{ \'core-permissoes.organizacao.usuarios.popup.mustFillInAreaCodeAndCountryCode\' | translate }}</span><div class="form-group"><label for="cargo">{{ \'core-permissoes.organizacao.usuarios.popup.jobTitle\' | translate }}</label><span class="opcional">&nbsp;- {{ \'core-permissoes.organizacao.usuarios.popup.optional\' | translate }}</span><input type="text" id="cargo" name="cargo" ng-model="editarUsuario.usuario.cargo" class="form-control"/></div><div ng-if="editarUsuario.perfilSelecionado.id !== editarUsuario.perfilIntegracao" class="form-group"><label>{{ \'core-permissoes.organizacao.usuarios.popup.actions\' | translate }}</label><button ng-click="editarUsuario.novaSenha()" class="btn btn-default form-control"><i class="glyphicon glyphicon-envelope margin-r-5"></i>{{ \'core-permissoes.organizacao.usuarios.popup.sendEmailForNewPasswordRegistration\' | translate }}</button></div><div ng-class="{\'error-label\': editarUsuario.responsavelError(edicaoUsuarioForm)}" class="form-group"><label>{{ \'core-permissoes.organizacao.usuarios.cadastro.responsavelPassivel\' | translate }}</label><span class="passivel-descricao">{{ \'core-permissoes.organizacao.usuarios.cadastro.descricaoResponsavel\' | translate }}</span><div class="radio"><label><input id="isResponsavelPassiveis" name="isResponsavelPassiveis" ng-model="editarUsuario.isResponsavelPassiveis" required="true" type="radio" value="true"/>{{ \'common.sim\' | translate }}</label></div><div class="radio"><label><input id="isResponsavelPassiveisNot" name="isResponsavelPassiveis" ng-model="editarUsuario.isResponsavelPassiveis" required="true" type="radio" value="false"/>{{ \'common.nao\' | translate }}</label></div><span ng-class="{\'error-label\': true}" ng-if="editarUsuario.responsavelError(edicaoUsuarioForm)" class="help-block">{{ \'v3gwc.validacao.campoObrigatorio\' | translate }}</span></div><div ng-if="editarUsuario.loginIsThirdParty(editarUsuario.usuario.login) &amp;&amp; editarUsuario.domainEditAccessOU" class="form-group"><label>{{ \'core-permissoes.organizacao.usuarios.cadastro.trocaUo\' | translate }}</label><span class="troca-uo-descricao">{{ \'core-permissoes.organizacao.usuarios.cadastro.descricaoTrocaUo\' | translate }}</span><div class="radio"> <label><input id="acessoTrocaUo" name="acessoTrocaUo" ng-model="editarUsuario.acessoTrocaUo" type="radio" value="true"/>{{ \'common.sim\' | translate }}</label></div><div class="radio"><label><input id="acessoTrocaUoNot" name="acessoTrocaUo" ng-model="editarUsuario.acessoTrocaUo" type="radio" value="false"/>{{ \'common.nao\' | translate }}</label></div></div></form><div flash-message="5000"></div></div><div class="modal-footer"><button type="button" ng-click="editarUsuario.ok(edicaoUsuarioForm)" class="btn btn-success">OK</button><button type="button" ng-click="editarUsuario.cancel()" class="btn btn-default">{{ \'core-permissoes.organizacao.usuarios.popup.cancel\' | translate }}</button></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('uos/confirm-import-modal/confirm-import-ttc-modal.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'core-permissoes.organizacao.uos.confirmImportModal.title\' | translate }}</h3></div><form name="importTtcModal" class="form-group"><div class="modal-body"><p>{{ \'core-permissoes.organizacao.uos.confirmImportModal.confirmMessage\' | translate }}</p></div><div class="modal-footer"><button type="button" ng-click="ctrl.cancel()" class="btn btn-default">{{ \'core-permissoes.organizacao.usuarios.popup.cancel\' | translate }}</button><button type="button" ng-click="ctrl.confirmar()" class="btn btn-success">{{ \'core-permissoes.organizacao.uos.confirmImportModal.yes\' | translate }}</button></div></form>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('expurgo/hist-expurgo/hist-expurgo.tpl.html',
    '<vtabela id="expurgos" grid-options="ctrl.vtabela" analytics-category="Relatorios" analytics-label="expurgos"></vtabela>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('expurgo/confirm-expurgo-modal/confirm-expurgo-modal.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{\'core-permissoes.popUp.dismissalPopUp.confirmDismissal\' | translate}}</h3></div><form name="clonarPerfilForm" class="form-group"><div class="modal-body"><p>{{\'core-permissoes.popUp.dismissalPopUp.confirmDismissalMessage\' | translate}} &nbsp;<strong>{{ctrl.evento.descricao | translate}}</strong>?</p></div><div class="modal-footer"><button type="button" ng-click="ctrl.cancel()" class="btn btn-default">{{\'core-permissoes.popUp.dismissalPopUp.cancel\' | translate}}</button><button type="button" ng-click="ctrl.confirmar()" class="btn btn-success">{{\'core-permissoes.popUp.dismissalPopUp.dismiss\' | translate}}</button></div></form>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('compartilhamentos/confirm-delete-modal/confirm-delete-modal.tpl.html',
    '<div class="modal-header bg-green"><h3 class="modal-title">{{ \'core-permissoes.organizacao.compartilhamentos.confirmDeleteModal.title\' | translate }}</h3></div><form name="clonarPerfilForm" class="form-group"><div class="modal-body"><p>{{ \'core-permissoes.organizacao.compartilhamentos.confirmDeleteModal.messagePrefix\' | translate }}<strong>{{ctrl.compartilhamento.tipoEntidade.nome}}</strong>{{ \'core-permissoes.organizacao.compartilhamentos.confirmDeleteModal.messageSuffix\' | translate }}</p></div><div class="modal-footer"><button type="button" ng-click="ctrl.cancel()" class="btn btn-default">{{ \'core-permissoes.organizacao.usuarios.popup.cancel\' | translate }}</button><button type="button" ng-click="ctrl.confirmar()" class="btn btn-success">{{ \'core-permissoes.organizacao.compartilhamentos.shareButton.delete\' | translate }}</button></div></form>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('camada-valor/informativo/camada-valor-informativo.tpl.html',
    '<div id="informativo"><div class="info flex-1"><h1>{{ \'core-permissoes.organizacao.camadaValor.informativo.title\' | translate }}</h1><div class="descricao">{{ \'core-permissoes.organizacao.camadaValor.informativo.description\' | translate }}</div><ul class="funcionalidades"><li class="funcionalidade"><i class="fa fa-check-circle"></i><span>{{ \'core-permissoes.organizacao.camadaValor.informativo.feature1\' | translate }}</span></li><li class="funcionalidade"><i class="fa fa-check-circle"></i><span>{{ \'core-permissoes.organizacao.camadaValor.informativo.feature2\' | translate }}</span></li></ul><button id="contatar-comercial" type="button" ng-click="camadaValorInformativo.navegaLink()" class="btn btn-primary">{{ \'core-permissoes.organizacao.camadaValor.informativo.contactSales\' | translate }}</button><button id="ver-planos" type="button" ng-click="camadaValorInformativo.navegaPlanoSolucoes()" class="btn">{{ \'core-permissoes.organizacao.camadaValor.informativo.viewPlans\' | translate }}</button></div><div class="imagem flex-1"><img ng-src="https://vfleets-imagens.s3-sa-east-1.amazonaws.com/permissoes/trilha-desenvolvimento.png"/></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('camada-valor/home/camada-valor-home.tpl.html',
    '<div id="camada-valor-home-element"></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('camada-valor/cadastro/camada-valor-cadastro.tpl.html',
    '<div id="camada-valor-stepper-cadastro"></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('veiculos/veiculos.tpl.html',
    '<div class="box compartilhamento-cadastro"><div class="box-header with-border"><form ng-submit="veiculosCtrl.salvar()" name="cadastroForm" class="form-horizontal"><div class="box-body"><div class="form-group"><label class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.originOU\' | translate }}</label><div class="col-sm-7"><ui-select style="width: 100%" on-select="veiculosCtrl.carregarVeiculos()" ng-model="veiculosCtrl.selecao.origem" ng-disabled="!veiculosCtrl.roleCadastrar" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.selectOriginOU\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="uo as uo in (veiculosCtrl.uos | filter: $select.search | limitTo: veiculosCtrl.limitOrigem ) track by uo.id" scroll-detector="veiculosCtrl.loadMoreOrigem()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.vehicles\' | translate }}</label><div class="col-sm-7"><div><small ng-if="veiculosCtrl.veiculos.length === 0">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.noOUmessage\' | translate }}</small><small ng-if="veiculosCtrl.veiculos.length === 1">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.selectVehicleToBeTransferred\' | translate }}</small><small ng-if="veiculosCtrl.veiculos.length &gt; 1">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.selectVehiclesToBeTransferred\' | translate }}<strong> ({{ veiculosCtrl.selecionados.length }}/{{ veiculosCtrl.veiculos.length }} {{ (\'core-permissoes.organizacao.transferenciaDeVeiculos.vehicles\' | translate) | lowercase }})</strong></small><ui-select id="entidadesSelect" style="width: 100%" ng-model="veiculosCtrl.selecionados" ng-disabled="veiculosCtrl.todasAsEntidades === true || !veiculosCtrl.roleCadastrar" ng-paste="veiculosCtrl.setItens($select)" append-to-body="true" multiple="multiple" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.provideVehiclesMessage\' | translate }}">{{ $item.placa }} - {{ $item.prefixo }}</ui-select-match><ui-select-choices repeat="d in veiculosCtrl.veiculos | filter: $select.search"><div ng-bind-html="d.placa+&quot; - &quot;+d.prefixo | highlight: $select.search"></div></ui-select-choices></ui-select></div><div ng-if="veiculosCtrl.listFail.length &gt; 0"><strong>{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.vehiclesWithRegistrationIssues\' | translate }}</strong><a href="#" ng-click="veiculosCtrl.listFail = []"> {{ \'core-permissoes.organizacao.transferenciaDeVeiculos.deleteAll\' | translate }}</a><div><span ng-repeat="item in veiculosCtrl.listFail track by $index" class="badge bg-red fa-icon-right"><span>{{item}}</span><i ng-click="veiculosCtrl.removeInvalidItem($index)" class="fa fa-times fa-icon-left cursor-pointer"></i></span></div></div><input id="todosVeiculos" type="checkbox" ng-model="veiculosCtrl.todasAsEntidades" ng-disabled="!veiculosCtrl.roleCadastrar" ng-change="veiculosCtrl.todosVeiculos()"/><label for="todosVeiculos">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.selectAll\' | translate }}</label><button id="limparSelecao" ng-click="veiculosCtrl.limparSelecao()" ng-if="veiculosCtrl.roleCadastrar" ng-class="{ \'btn-default\': veiculosCtrl.selecionados.length === 0, \'btn-primary\': veiculosCtrl.selecionados.length &gt; 0 }" ng-disabled="veiculosCtrl.selecionados.length === 0" class="btn pull-right">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.clearSelection\' | translate }}</button></div></div><div class="form-group"><label class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.destinationOU\' | translate }}:</label><div class="col-sm-7"><ui-select style="width: 100%" ng-model="veiculosCtrl.selecao.destino" ng-disabled="!veiculosCtrl.roleCadastrar" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.transferenciaDeVeiculos.selectDestionationOU\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="uo as uo in (veiculosCtrl.uosDaMesmaArvore | filter: $select.search | limitTo: veiculosCtrl.limitDestino) track by uo.id" scroll-detector="veiculosCtrl.loadMoreDestino()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select></div></div></div><div class="box-footer"><div class="col-sm-offset-2 col-sm-10"><button type="submit" ng-disabled="!(veiculosCtrl.selecao.destino &amp;&amp; veiculosCtrl.selecionados.length &gt; 0 &amp;&amp; veiculosCtrl.selecao.origem.id !== veiculosCtrl.selecao.destino.id)" ng-if="veiculosCtrl.roleCadastrar" class="btn btn-primary">{{ \'core-permissoes.organizacao.common.save\' | translate }}</button></div></div><div class="box-fotter"><div class="col-sm-offset-2 col-sm-6"><div role="alert" ng-if="veiculosCtrl.alert.display" ng-class="veiculosCtrl.alert.alertClass" class="alert alert-dismissible"><button type="button" ng-click="veiculosCtrl.alert.display = false" class="close"><span aria-hidden="true">&times;</span></button>{{ veiculosCtrl.alert.alertMessage }}</div></div></div></form></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuarios/usuarios.tpl.html',
    '<div class="alerta-aqui"></div><vtabela id="vtabela-usuarios" grid-options="usuarios.vtabela" analytics-category="Relatorios" analytics-label="vtabela-usuarios"><button ng-click="usuarios.cadastrarUsuario()" ng-if="usuarios.roleCadastrar" class="btn btn-primary">{{ \'core-permissoes.organizacao.usuarios.addUser\' | translate }}</button></vtabela>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuarios/excluir-usuario.tpl.html',
    '<div class="modal-header"><h3 class="modal-title">{{ \'core-permissoes.organizacao.usuarios.deletion.title\' | translate }}</h3></div><div class="modal-body"><p><strong>{{ \'core-permissoes.organizacao.usuarios.deletion.userDeletionDialog\' | translate }}</strong></p><p>{{ excluirUsuario.usuario.login }}</p><div flash-message="5000"></div></div><div class="modal-footer"><button type="button" ng-click="excluirUsuario.ok()" class="btn btn-danger">{{ \'core-permissoes.organizacao.usuarios.deletion.delete\' | translate }}</button><button type="button" ng-click="excluirUsuario.cancel()" class="btn btn-default">{{ \'core-permissoes.organizacao.usuarios.deletion.cancel\' | translate }}</button></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('uos/uos.tpl.html',
    '<div class="box"><div class="box-body"><div class="btn-group"><a v3g-has-permission="UO_REGRA" ui-sref="root.parceira" ng-if="uos.roleAdminVeltec" class="btn btn-primary"><i class="fa fa-edit"></i>{{ \'core-permissoes.organizacao.uos.parceria\' | translate }}</a></div><div class="btn-group"><a v3g-has-permission="UO_REGRA" ui-sref="root.uoCadastro({uoId: 0, uoPai: false})" ng-if="uos.roleCadastrar" class="btn btn-primary"><i class="fa fa-edit"></i>{{ \'core-permissoes.organizacao.uos.novaUo\' | translate }}</a></div><div ng-if="uos.roleVisualizar" class="pull-right col-md-4"><div class="filtro"><label for="filtro-uo">{{ \'core-permissoes.organizacao.uos.filtro\' | translate }}:</label><input id="filtro-uo" type="text" name="filtroUos" ng-model="uos.filtro" ng-minlength="3" placeholder="{{\'core-permissoes.organizacao.uos.minimoCaracteres\' | translate }}" class="form-control"/></div></div><div class="alerta-aqui"></div><div ng-if="uos.roleVisualizar" class="uo-grid-header"><div ng-if="uos.roleCadastrar" class="opcao-column uo-titulo">{{ \'core-permissoes.organizacao.uos.opcao\' | translate }}</div><div uib-tooltip="{{ \'core-permissoes.organizacao.uos.qtdVeiculosLiberados\' | translate }}" class="veiculo-count uo-titulo">{{ \'core-permissoes.organizacao.uos.veiculos\' | translate }}</div><div class="parceiro-column uo-titulo">{{ \'core-permissoes.organizacao.uos.parceiros\' | translate }}</div><div class="cliente-column uo-titulo">{{ \'core-permissoes.organizacao.uos.clienteSavId\' | translate }}</div><div class="uo-id uo-titulo">{{ \'core-permissoes.organizacao.uos.uoId\' | translate }}</div><div class="clearfix"></div></div><div scroll-detector="uos.loadMore()" class="listagem-uos"><div ng-repeat="uo in uos.uos | filter: uos.filtro | limitTo: uos.limit track by uo.id" style="padding-left: {{30 * uo.arvoreNivel}}px" ng-show="uo.show" class="uo-grid-linha"><button type="button" ng-click="uos.toggleFilhas(uo)" ng-if="uo.temFilhas" class="btn btn-default btn-xs btn-primary white"><i ng-class="{&quot;glyphicon-plus&quot;: !uo.open, &quot;glyphicon-minus&quot;: uo.open}" class="glyphicon"></i></button><button type="button" ng-if="!uo.temFilhas" class="btn btn-default btn-xs disabled"><i class="glyphicon glyphicon-chevron-right"></i></button><div class="opcao-column"><a ui-sref="root.uoCadastro({uoId: uo.id, uoPai: uo.id === uos.pai})" ng-has-permission="UO_REGRA" ng-if="uos.roleCadastrar" class="btn btn-primary btn-xs"><i class="glyphicon glyphicon-pencil"></i></a></div><div class="veiculo-count">{{uos.veiculos[uo.id] && uos.veiculos[uo.id].LIBERADO || 0}}</div><div class="parceiro-column">{{uo.parceiras}}</div><div class="cliente-column">{{uo.idSav}}</div><div class="uo-id">{{uo.id}}</div><div ng-class="{ \'uo-titulo\': uo.temFilhas }" class="uo-nome-grid">{{uo.nome}}</div></div></div></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('uos/parceira.tpl.html',
    '<div class="box box-info"><div class="box-header with-border"><h3 class="box-title">{{ \'core-permissoes.organizacao.uos.parceiro.title\' | translate }}</h3><form novalidate="novalidate" ng-submit="parceiraCtrl.salvar()" name="cadastroForm" class="form-horizontal"><div class="box-body"><div class="form-group"><label for="selectUo" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.parceiro.ouLabel\' | translate }}</label><div class="col-sm-7"><ui-select id="selectUo" ng-required="true" style="width: 100%" ng-model="parceiraCtrl.parceira.uo" ng-change="parceiraCtrl.parceira.uoParceira = null" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.uos.select\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="u in (parceiraCtrl.uos | filter: $select.search | limitTo: parceiraCtrl.limitUo ) track by u.id" scroll-detector="parceiraCtrl.loadMoreUos()"><span style="padding-left: {{15 * u.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="u.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ u.id }}</span></span></ui-select-choices></ui-select><p ng-show="cadastroForm.uo.$invalid &amp;&amp; cadastroForm.submitted" class="text-danger">{{ \'core-permissoes.organizacao.uos.parceiro.ouRequired\' | translate }}</p></div></div><div ng-if="parceiraCtrl.parceira.uo != null" class="form-group"><label for="selectParceiro" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.parceiro.partnerLabel\' | translate }}</label><div class="col-sm-7"><ui-select id="selectParceiro" style="width: 100%" ng-required="true" ng-model="parceiraCtrl.parceira.uoParceira" ng-init="parceiraCtrl.parceira.uoParceira = parceiraCtrl.parceira.uoParceira" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.uos.select\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="u in (parceiraCtrl.uos | filter: {id : (parceiraCtrl.parceira.uo) ? \'!\' + parceiraCtrl.parceira.uo.id : defined} | filter: $select.search | limitTo: parceiraCtrl.limitParceira) track by u.id " scroll-detector="parceiraCtrl.loadMoreParceiras()"><span style="padding-left: {{15 * u.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="u.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ u.id }}</span></span></ui-select-choices></ui-select><p ng-show="cadastroForm.parceira.$invalid &amp;&amp; cadastroForm.submitted" class="text-danger">{{ \'core-permissoes.organizacao.uos.parceiro.partnerRequired\' | translate }}</p></div></div><div class="alerta-aqui"></div></div><div class="box-footer"><div class="col-sm-offset-2 col-sm-10"><button type="submit" ng-disabled="cadastroForm.$invalid" class="btn btn-primary">{{ \'core-permissoes.organizacao.uos.save\' | translate }}</button><a onclick="window.history.back();" class="btn btn-default">{{ \'core-permissoes.organizacao.uos.back\' | translate }}</a></div></div></form></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('uos/cadastrar-uo.tpl.html',
    '<div class="box box-default"><div class="box-header with-border"><h3 class="box-title"><div class="row"><div class="col-sm-9 import-ttc"><button type="button" ng-click="cadastrarUoCtrl.ok(&quot;motorista&quot;)" ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.customerAccountUuid" class="btn btn-primary">{{ \'core-permissoes.organizacao.uos.importDriver\' | translate }}</button><button type="button" ng-click="cadastrarUoCtrl.ok(&quot;veiculos&quot;)" ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.customerAccountUuid" class="btn btn-primary">{{ \'core-permissoes.organizacao.uos.importVehicle\' | translate }}</button><button type="button" ng-click="cadastrarUoCtrl.ok(&quot;usuarios&quot;)" ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.customerAccountUuid" class="btn btn-primary">{{ \'core-permissoes.organizacao.uos.importUsers\' | translate }}</button></div></div><div class="col-sm-offset-2 col-sm-6 alerta-aqui"></div></h3><form ng-submit="cadastrarUoCtrl.salvar()" name="cadastroForm" class="form-horizontal"><div class="box-body"><div ng-if="cadastrarUoCtrl.uoPaiSetado === \'false\'" class="form-group"><label for="selectUo" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.parentOu\' | translate }}:</label><div class="col-sm-7"><ui-select id="selectUo" style="width: 100%" ng-model="cadastrarUoCtrl.uoBloqueioWrapper.uo.uoPai" ng-change="cadastrarUoCtrl.onUoPaiChange()" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.uos.select\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="u in (cadastrarUoCtrl.uos | filter: $select.search | limitTo: cadastrarUoCtrl.limit) track by u.id" scroll-detector="cadastrarUoCtrl.loadMore()"><span style="padding-left: {{15 * u.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="u.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ u.id }}</span></span></ui-select-choices></ui-select></div></div><div class="form-group"><label for="inputNome" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.name\' | translate }}:</label><div class="col-sm-7"><input type="text" id="inputNome" name="inputNome" placeholder="{{ \'core-permissoes.organizacao.uos.name\' | translate }}" required="true" pattern=".{3,100}" title="{{ \'core-permissoes.organizacao.uos.enterBetween3And100Characters\' | translate }}" ng-model="cadastrarUoCtrl.uoBloqueioWrapper.uo.nome" uppercased="uppercased" class="form-control"/><p ng-if="cadastroForm.inputNome.$error" class="text-danger"><span ng-if="cadastroForm.inputNome.$error.required">{{ \'core-permissoes.organizacao.uos.nameRequired\' | translate }}</span></p></div></div><div class="form-group"><label for="inputSite" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.site\' | translate }}:</label><div class="col-sm-7"><input type="url" id="inputSite" placeholder="{{ \'core-permissoes.organizacao.uos.site\' | translate }}" pattern=".{0,600}" title="{{ \'core-permissoes.organizacao.uos.enterTheOuSite\' | translate }}" ng-model="cadastrarUoCtrl.uoBloqueioWrapper.uo.site" class="form-control"/></div></div><div class="form-group"><label for="selectSegmento" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.segmento\' | translate }}:</label><div class="col-sm-7"><ui-select id="selectSegmento" style="width: 100%" ng-model="cadastrarUoCtrl.segmentoSelecionado" ng-disabled="!cadastrarUoCtrl.podeEditarSegmento" name="inputSegmento" close-on-select="true" ng-required="cadastrarUoCtrl.isSegmentRequired" required="required"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.organizacao.uos.select\' | translate }}">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="segmento in (cadastrarUoCtrl.segmentosTraduzidos | filter: $select.search) track by segmento.key"><span ng-bind-html="segmento.value | highlight: $select.search"></span></ui-select-choices></ui-select><p ng-if="cadastroForm.inputSegmento.$error" class="text-danger"><span ng-if="cadastroForm.inputSegmento.$error.required">{{ \'core-permissoes.organizacao.uos.segmentRequired\' | translate }}</span></p></div></div><div ng-if="cadastrarUoCtrl.isAdminVeltec" class="form-group"><label for="inputCustomerUuid" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.customerUuid\' | translate }}:</label><div class="col-sm-7"><input type="text" id="inputCustomerUuid" name="inputCustomerUuid" placeholder="{{ \'core-permissoes.organizacao.uos.customerAccountUuid\' | translate }}" title="{{ \'core-permissoes.organizacao.uos.customerAccountUuid\' | translate }}" vuuidmask="vuuidmask" ng-model="cadastrarUoCtrl.uoBloqueioWrapper.uo.customerAccountUuid" class="form-control"/><p ng-show="cadastroForm.inputCustomerUuid.$invalid" class="text-danger">{{ \'core-permissoes.organizacao.uos.invalidUuid\' | translate }}</p></div></div><div ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.id &gt; 0" class="form-group"><div class="col-sm-4"><div class="checkbox pull-right"><input type="checkbox" id="checkboxBloqueioUO" ng-model="cadastrarUoCtrl.uoBloqueada"/>{{ \'core-permissoes.organizacao.uos.blockUserAccessInVfleets\' | translate }}:</div></div><div ng-if="cadastrarUoCtrl.enableNaFeatures" data-testid="checkBoxNaFeature" class="col-sm-4"><div class="checkbox pull-right"><input type="checkbox" id="checkboxVehicleRegistration" ng-model="cadastrarUoCtrl.vehicleRegistration"/>{{ \'core-permissoes.organizacao.uos.enableNaFeatures\' | translate }}</div></div></div><div ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.id &gt; 0" class="form-group"><label for="textareaMensagemBloqueio" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.message\' | translate }}:</label><div class="col-sm-7"><textarea id="textareaMensagemBloqueio" title="{{ \'core-permissoes.organizacao.uos.blockingMessage\' | translate }}" placeholder="{{ \'core-permissoes.organizacao.uos.writeYourMessageHere\' | translate }}" ng-disabled="!cadastrarUoCtrl.uoBloqueada" ng-required="cadastrarUoCtrl.uoBloqueada" ng-model="cadastrarUoCtrl.mensagemBloqueio" maxlength="250" rows="4" class="form-control"></textarea><span class="help-block text-right">{{cadastrarUoCtrl.mensagemBloqueio.length || 0}}/250</span></div></div><div ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.id &gt; 0 &amp;&amp; cadastrarUoCtrl.enableNaFeatures &amp;&amp; cadastrarUoCtrl.vehicleRegistration" class="form-group"><div class="form-group"><label for="auth0OrgId" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.orion.auth0OrgId\' | translate }}:</label><div class="col-sm-7"><input type="text" id="auth0OrgId" ng-model="cadastrarUoCtrl.auth0OrgId" placeholder="{{ \'core-permissoes.organizacao.uos.orion.auth0OrgId\' | translate }}" class="form-control"/></div></div><div class="form-group"><label for="orionDeploymentId" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.orion.orionDeploymentId\' | translate }}:</label><div class="col-sm-7"><input type="text" id="orionDeploymentId" ng-model="cadastrarUoCtrl.orionDeploymentId" ng-change="cadastrarUoCtrl.onOrionDeploymentIdChange()" placeholder="{{ \'core-permissoes.organizacao.uos.orion.orionDeploymentId\' | translate }}" class="form-control"/></div></div></div><div ng-if="cadastrarUoCtrl.uoBloqueioWrapper.uo.id &gt; 0 &amp;&amp; cadastrarUoCtrl.enableNaFeatures &amp;&amp; cadastrarUoCtrl.vehicleRegistration &amp;&amp; !cadastrarUoCtrl.hideSubdomainField" class="form-group"><label for="psviOrionSubdomain" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.uos.orion.psviOrionSubdomain\' | translate }}:</label><div class="col-sm-7"><div class="input-group"><input type="text" id="psviOrionSubdomain" name="psviOrionSubdomain" ng-model="cadastrarUoCtrl.psviOrionSubdomain" ng-pattern="cadastrarUoCtrl.PSVI_SUBDOMAIN_REGEX" ng-disabled="cadastrarUoCtrl.subdomainFromParent" maxlength="63" placeholder="subdomain" class="form-control"/><span class="input-group-addon">.platformscience.com</span></div><span ng-show="cadastroForm.psviOrionSubdomain.$error.pattern" class="help-block text-danger">{{ \'core-permissoes.organizacao.uos.orion.psviOrionSubdomainInvalid\' | translate }}</span><span ng-show="cadastrarUoCtrl.vehicleRegistration &amp;&amp; !cadastroForm.psviOrionSubdomain.$error.pattern &amp;&amp; !cadastrarUoCtrl.subdomainFromParent" class="help-block text-warning">{{ \'core-permissoes.organizacao.uos.orion.psviOrionSubdomainApplyToChildren\' | translate }}</span><span ng-show="cadastrarUoCtrl.subdomainFromParent &amp;&amp; cadastrarUoCtrl.subdomainAlreadyApplied" class="help-block text-info">{{ \'core-permissoes.organizacao.uos.orion.psviOrionSubdomainAlreadyApplied\' | translate }}</span><span ng-show="cadastrarUoCtrl.subdomainFromParent &amp;&amp; !cadastrarUoCtrl.hideSubdomainField &amp;&amp; !cadastrarUoCtrl.subdomainAlreadyApplied" class="help-block text-warning">{{ \'core-permissoes.organizacao.uos.orion.psviOrionSubdomainSaveToApply\' | translate }}</span></div></div></div><div class="box-footer"><div class="col-sm-offset-2 col-sm-10"><button type="submit" ng-disabled="cadastroForm.$invalid" class="btn btn-primary">{{ \'core-permissoes.organizacao.uos.save\' | translate }}</button><a ui-sref="root.uos" class="btn btn-default">{{ \'core-permissoes.organizacao.uos.back\' | translate }}</a></div><div class="col-sm-offset-2 col-sm-6 alerta-aqui"></div></div></form></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('perfis/perfis.tpl.html',
    '<div id="perfis-element"></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('importacao-ponto-referencia/importacao-ponto-referencia.tpl.html',
    '<div class="box box-info"><div class="box-header with-border"><!-- Controle de mensagens--><h3 class="box-title"><div ng-show="importacaoPontoReferencia.msgSucesso" class="alert alert-success alert-dismissible"><button type="button" ng-click="importacaoPontoReferencia.clearMensagens()" class="close">×</button><h4><i class="icon fa fa-check">{{importacaoPontoReferencia.msgSucesso}}</i></h4></div><div ng-show="importacaoPontoReferencia.msgErro" class="alert alert-success alert-dismissible"><button type="button" ng-click="importacaoPontoReferencia.clearMensagens()" class="close">×</button><h4><i class="icon fa fa-check">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.error\' | translate }}</i></h4>{{importacaoPontoReferencia.msgErro}}</div></h3><div class="box-body with-border"><form role="search" name="relatorioImportacoes" ng-submit="importacaoPontoReferencia.carregarRelatorio()" class="form-horizontal"><div class="form-group input-group"><input id="periodoInput" date-range-picker="date-range-picker" type="text" ng-model="importacaoPontoReferencia.periodoFiltro" class="form-control date-range-picker-input"/><span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span><button ng-disabled="!importacaoPontoReferencia.uo" ng-click="importacaoPontoReferencia.mostrarImportar = !importacaoPontoReferencia.mostrarImportar" type="button" class="btn btn-success"><span aria-hidden="true" class="glyphicon glyphicon-plus"></span></button><label for="selectUo" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.destinationOu\' | translate }}</label><span class="col-sm-7"><select id="selectUo" ng-model="importacaoPontoReferencia.uo" ng-options="u.nome for u in importacaoPontoReferencia.uos | orderBy:\'nome\' track by u.id" required="true" name="uo" class="form-control"><option value="">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.selectOu\' | translate }}</option></select></span><button type="submit" class="btn btn-primary">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.show\' | translate }}<span aria-hidden="true" class="glyphicon glyphicon-search"></span></button></div></form><div class="box-body"><div class="form-group"></div><form ng-submit="importacaoPontoReferencia.importar()" name="importarForm" ng-show="importacaoPontoReferencia.mostrarImportar &amp;&amp; importacaoPontoReferencia.uo" class="form-horizontal"><div class="form-group"><label for="inputArquivo" ng-show="importacaoPontoReferencia.mostrarImportar" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.file\' | translate }}</label><div class="col-sm-7"><input type="file" name="file" id="inputArquivo" onchange="angular.element(this).scope().uploadedFile(this)" required="true" ng-show="importacaoPontoReferencia.mostrarImportar" class="form-control"/><input type="hidden" name="uo" ng-model="importacaoPontoReferencia.uo"/></div></div><div ng-show="importacaoPontoReferencia.mostrarImportar" class="box-footer"><div class="col-sm-offset-2 col-sm-10"><button type="submit" ng-show="importacaoPontoReferencia.mostrarImportar" class="btn btn-primary">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.import\' | translate }}</button></div></div></form></div><table id="historicoTable" st-table="importacaoPontoReferencia.ImportacaoRelatorio" ng-show="importacaoPontoReferencia.ImportacaoRelatorio.length &gt; 0" class="table table-hover"><thead><tr><th>{{ \'core-permissoes.organizacao.importacaoPontoReferencia.fileNameColumn\' | translate }}</th><th>{{ \'core-permissoes.organizacao.importacaoPontoReferencia.destinationOuColumn\' | translate }}</th><th>{{ \'core-permissoes.organizacao.importacaoPontoReferencia.importDateColumn\' | translate }}</th><th>{{ \'core-permissoes.organizacao.importacaoPontoReferencia.statusColumn\' | translate }}</th></tr></thead><tbody><tr ng-repeat="row in importacaoPontoReferencia.ImportacaoRelatorio"><td>{{row.nomeArquivo}}</td><td>{{row.uoDestinoId}}</td><td>{{row.dataInicio | date:\'dd/MM/yy HH:mm\'}}</td><td><span ng-click="importacaoPontoReferencia.mostrarMotivoImportacao(row)" ng-class="{\'label-success\': row.statusImportacao==\'CONCLUIDO\', \'label-warning btn\': row.statusImportacao==\'CONCLUIDO_COM_FALHAS\', \'label-danger btn\': row.statusImportacao==\'ERRO\', \'label-primary\': row.statusImportacao==\'IMPORTANDO\'}" class="label">{{row.statusImportacao}}</span></td></tr></tbody></table><div ng-show="importacaoPontoReferencia.ImportacaoRelatorio.length == 0" class="panel"><div class="panel-body text-muted">{{ \'core-permissoes.organizacao.importacaoPontoReferencia.noResultsFound\' | translate }}</div></div></div></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('importacao-ponto-referencia/importacao-motivo.tpl.html',
    '<div class="modal-header"><h3 class="modal-title">Resultado da importação do arquivo:<span ng-bind="importacaoMotivo.importacaoRegistro.nomeArquivo"></span></h3></div><div class="modal-body my-modal-class"><div ng-repeat="msg in importacaoMotivo.importacaoRegistro.mensagens track by $index">{{msg}}</div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('importacao-motorista/importacao-motorista.tpl.html',
    '<div class="box box-info"><div class="box-header with-border"><h3 class="box-title"></h3><div ng-show="importacaoMotorista.msgSucessoComErro" class="alert alert-info alert-dismissible"><button type="button" ng-click="importacaoMotorista.clearMensagens()" class="close">×</button><h5><i class="icon fa fa-check">{{ \'core-permissoes.organizacao.importacaoMotorista.partialSuccessWithErrors\' | translate }}</i></h5><div ng-repeat="msg in importacaoMotorista.msgSucessoComErro.mensagens">{{msg}}</div></div><div ng-show="importacaoMotorista.msgSucesso" class="alert alert-success alert-dismissible"><button type="button" ng-click="importacaoMotorista.clearMensagens()" class="close">×</button><h4><i class="icon fa fa-check">{{ \'core-permissoes.organizacao.importacaoMotorista.success\' | translate }}</i></h4>{{importacaoMotorista.msgSucesso}}</div><div ng-show="importacaoMotorista.msgErro" class="alert alert-success alert-dismissible"><button type="button" ng-click="importacaoMotorista.clearMensagens()" class="close">×</button><h4><i class="icon fa fa-check">{{ \'core-permissoes.organizacao.importacaoMotorista.error\' | translate }}</i></h4>{{importacaoMotorista.msgErro}}</div><form ng-submit="importacaoMotorista.importar()" name="importarForm" class="form-horizontal"><div class="box-body"><div class="form-group"><label for="selectUo" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.importacaoMotorista.destinationOu\' | translate }}</label><div class="col-sm-7"><select id="selectUo" ng-model="importacaoMotorista.uo" ng-options="u.nome for u in importacaoMotorista.uos | orderBy:\'nome\' track by u.id" required="true" name="uo" class="form-control"><option value="">{{ \'core-permissoes.organizacao.importacaoMotorista.selectOu\' | translate }}</option></select></div></div><div class="form-group"><label for="inputArquivo" class="col-sm-2 control-label">{{ \'core-permissoes.organizacao.importacaoMotorista.file\' | translate }}</label><div class="col-sm-7"><input type="file" name="file" id="inputArquivo" onchange="angular.element(this).scope().uploadedFile(this)" required="true" class="form-control"/></div></div></div><div class="box-footer"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-primary">{{ \'core-permissoes.organizacao.importacaoMotorista.import\' | translate }}</button><a href="/" class="btn btn-default">{{ \'core-permissoes.organizacao.uos.back\' | translate }}</a></div></div></form></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('expurgo/expurgo.tpl.html',
    '<div class="box expurgo-form"><div class="box-header with-border"><a ng-href="{{ expurgoCtrl.goToHist() }}" ng-show="expurgoCtrl.podeVerHistoricoAbono()" class="btn-historico"><span class="fa fa-id-card-o"></span>{{ \'core-permissoes.purge.viewHistory\' | translate }}</a><div ng-show="expurgoCtrl.podeFazerAbono()" class="col-sm-8"><form name="expurgoForm" class="form-horizontal"><div class="box-body"><div class="form-group"><div ng-class="{\'has-error\': expurgoCtrl.isEmpty(expurgoForm.uo)}" class="col-sm-12"><label class="control-label">{{ \'core-permissoes.purge.Ou\' | translate }}</label><ui-select style="width: 100%" on-select="expurgoCtrl.carregarVeiculos(); expurgoCtrl.carregarConfigEventos()" ng-model="expurgoCtrl.model.uo" name="uo" required="required" ng-change="expurgoCtrl.msgVeiculos()" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.purge.selectOriginVehicleOu\' | translate }}">{{$select.selected.nome}}</ui-select-match><ui-select-choices repeat="uo as uo in (expurgoCtrl.uos | filter: $select.search | limitTo: expurgoCtrl.limitUos ) track by uo.id" scroll-detector="expurgoCtrl.loadMoreUos()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select></div></div><div class="form-group"><div ng-class="{\'has-error\':  expurgoCtrl.isEmpty(expurgoForm.veiculos)}" class="col-sm-12"><label class="control-label">{{ \'core-permissoes.purge.vehicle\' | translate }}</label><ui-select style="width: 100%" required="required" name="veiculos" ng-disabled="!expurgoCtrl.veiculos.length" ng-model="expurgoCtrl.model.veiculo" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{expurgoCtrl.placeHolderVeiculos}}"> {{$select.selected && ($select.selected | prefixoPlaca) }}</ui-select-match><ui-select-choices repeat="veiculo in (expurgoCtrl.veiculos | veiculosFilter: { placa: $select.search, prefixo: $select.search } | limitTo: expurgoCtrl.limitVeiculos) track by $index" scroll-detector="expurgoCtrl.loadMoreAlertas()"><span>{{veiculo | prefixoPlaca}}</span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-12"><div class="row"><div ng-class="{\'has-error\': expurgoCtrl.isEmpty(expurgoForm.evento)}" class="col-sm-8"><label class="control-label">{{ \'core-permissoes.purge.eventType\' | translate }}</label><ui-select style="width: 100%" required="required" name="evento" ng-model="expurgoCtrl.model.alerta" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match placeholder="{{ \'core-permissoes.purge.selectEventDismiss\' | translate }}">{{ $select.selected.descricao | translate }}</ui-select-match><ui-select-choices repeat="alerta as alerta in (expurgoCtrl.alertas | filter: $select.search | limitTo: expurgoCtrl.limitVeiculos) track by alerta.id" scroll-detector="expurgoCtrl.loadMoreVeiculos()"><span>{{ alerta.descricao | translate }}</span></ui-select-choices></ui-select></div></div></div></div><div class="form-group"><div class="col-sm-12 no-padding"><label class="col-sm-12">{{ \'core-permissoes.purge.from\' | translate }}</label><div ng-class="{\'has-error\': expurgoCtrl.hasError(expurgoForm.dataInicio) || expurgoCtrl.isEmpty(expurgoForm.dataInicio)}" class="col-sm-4"><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-calendar"></i></span><input id="data-inicio" ng-model="expurgoCtrl.model.dataInicio" ui-validate="expurgoCtrl.dataInicioValidators" ng-change="expurgoCtrl.validarCamposDataHora()" required="required" type="date" name="dataInicio" aria-label="Data do Início" class="form-control"/></div><span ng-if="expurgoForm.dataInicio.$error.isDataFutura" class="help-block">{{ \'core-permissoes.purge.dateEarlierThanCurrent\' | translate }}</span></div><div ng-class="{\'has-error\': expurgoCtrl.hasError(expurgoForm.horaInicio) ||expurgoCtrl.isEmpty(expurgoForm.horaInicio)}" class="col-sm-4"><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-clock-o"></i></span><input id="hora-inicio" ng-model="expurgoCtrl.model.horaInicio" ng-change="expurgoCtrl.validarCamposDataHora()" ui-validate="expurgoCtrl.horaInicioValidators" required="required" type="time" name="horaInicio" aria-label="Hora do início" step="1" class="form-control"/></div><span ng-if="expurgoForm.horaInicio.$error.isHoraInicioFuturo" class="help-block">{{ \'core-permissoes.purge.startDateEarlierThanCurrent\' | translate }}</span></div></div></div><div class="form-group"><div class="col-sm-12 no-padding"><label class="col-sm-12">{{ \'core-permissoes.purge.to\' | translate }}</label><div ng-class="{\'has-error\': expurgoCtrl.hasError(expurgoForm.dataFim) || expurgoCtrl.isEmpty(expurgoForm.dataFim)}" class="col-sm-4"><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-calendar"></i></span><input id="data-fim" ng-model="expurgoCtrl.model.dataFim" ng-change="expurgoCtrl.validarCamposDataHora()" ui-validate="expurgoCtrl.dataFimValidators" required="required" type="date" name="dataFim" aria-label="Data do Fim" class="form-control"/></div><span ng-if="expurgoForm.dataFim.$error.isDataFutura" class="help-block">{{ \'core-permissoes.purge.dateEarlierThanCurrent\' | translate }}</span><span ng-if="expurgoForm.dataFim.$error.isIntervaloValido" class="help-block">{{ \'core-permissoes.purge.endDateLaterThanStart\' | translate }}</span><span ng-if="expurgoForm.dataFim.$error.isIntervaloAte30Dias" class="help-block">{{ \'core-permissoes.purge.intervalGreater30days\' | translate }}</span></div><div ng-class="{\'has-error\': expurgoCtrl.hasError(expurgoForm.horaFim) || expurgoCtrl.isEmpty(expurgoForm.horaFim)}" class="col-sm-4"><div class="input-group left input-group-vfiltro"><span class="input-group-addon"><i class="fa fa-clock-o"></i></span><input id="hora-fim" ng-model="expurgoCtrl.model.horaFim" ng-change="expurgoCtrl.validarCamposDataHora()" ui-validate="expurgoCtrl.horaFimValidators" required="required" type="time" name="horaFim" aria-label="Hora do fim" step="1" class="form-control"/></div><span ng-if="expurgoForm.horaFim.$error.isHoraFimValida" class="help-block">{{ \'core-permissoes.purge.endTimeLaterThanStart\' | translate }}</span><span ng-if="expurgoForm.horaFim.$error.isHoraFimFuturo" class="help-block">{{ \'core-permissoes.purge.endTimeLaterThanCurrent\' | translate }}</span></div></div></div><div class="form-group"><div ng-class="{\'has-error\': expurgoCtrl.isEmpty(expurgoForm.justificativa) || expurgoForm.justificativa.$error.minLengthTrim}" class="col-sm-12"><label>{{ \'core-permissoes.purge.justification\' | translate }}</label><textarea required="required" ui-validate="{minLengthTrim: expurgoCtrl.isValidJustificativa()}" name="justificativa" placeholder="{{\'core-permissoes.purge.enterYourJustification\' | translate}}" ng-model="expurgoCtrl.model.justificativa" maxlength="150" rows="2" class="form-control"></textarea><span ng-if="expurgoForm.justificativa.$error.minLengthTrim" class="help-block">{{ \'core-permissoes.purge.requiredMinimunCharacters\' | translate }}</span></div></div></div></form><div class="box-footer"><div role="alert" ng-if="expurgoCtrl.alert.display" ng-class="expurgoCtrl.alert.alertClass" class="alert alert-dismissible"><button type="button" ng-click="expurgoCtrl.alert.display = false" class="close"><span aria-hidden="true">&times;</span></button>{{ expurgoCtrl.alert.alertMessage }}</div><div class="box-salvar"><button type="button" ng-click="expurgoCtrl.ok()" class="btn btn-primary">{{ \'core-permissoes.purge.dismiss\' | translate }}</button></div></div></div><div ng-if="expurgoForm.$error.required &amp;&amp; expurgoCtrl.flagSalvar" class="required-fields"><h5><i class="fa fa-exclamation-triangle"></i><strong>{{ \'core-permissoes.purge.requiredfields\' | translate }}</strong></h5><ul><li ng-if="expurgoForm.uo.$error.required">{{ \'core-permissoes.purge.Ou\' | translate }}</li><li ng-if="expurgoForm.veiculos.$error.required">{{ \'core-permissoes.purge.vehicle\' | translate }}</li><li ng-if="expurgoForm.evento.$error.required">{{ \'core-permissoes.purge.eventType\' | translate }}</li><li ng-if="expurgoForm.dataInicio.$error.required">{{ \'core-permissoes.purge.startDate\' | translate }}</li><li ng-if="expurgoForm.horaInicio.$error.required">{{ \'core-permissoes.purge.startTime\' | translate }}</li><li ng-if="expurgoForm.dataFim.$error.required">{{ \'core-permissoes.purge.endDate\' | translate }}</li><li ng-if="expurgoForm.horaFim.$error.required">{{ \'core-permissoes.purge.endTime\' | translate }}</li><li ng-if="expurgoForm.justificativa.$error.required ||\n' +
    '          expurgoForm.justificativa.$error.minLengthTrim">{{ \'core-permissoes.purge.justification\' | translate }}</li></ul></div></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('compartilhamentos/compartilhamentos.tpl.html',
    '<div class="box"><div class="box-body"><div class="alerta-aqui"></div><div class="pull-right"><a ng-has-permission="UO_COMPARTILHAR" ui-sref="root.cadastro" ng-if="compartilhamentos.roleCadastrar" class="btn btn-primary pull-right">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.menuLabel\' | translate}}</a></div><div class="clearfix"></div><div ng-repeat="uoCompartilhamento in compartilhamentos.compartilhamentos"><span class="text-primary"><strong>{{uoCompartilhamento.uo.nome}}</strong></span><table ng-if="uoCompartilhamento.compartilhamentoRealizadoLista.length &gt; 0 || uoCompartilhamento.compartilhamentoRecebidoLista.length &gt; 0" class="table table-hover table-condensed"><thead><tr><th width="5%"></th><th width="15%">{{\'core-permissoes.organizacao.compartilhamentos.ou\' | translate}}</th><th width="15%">{{\'core-permissoes.organizacao.compartilhamentos.entity\' | translate}}</th><th width="8%">{{\'core-permissoes.organizacao.compartilhamentos.editing\' | translate}}</th><th width="8%">{{\'core-permissoes.organizacao.compartilhamentos.delegation\' | translate}}</th><!-- th(width=\'23%\') Período--><!-- th(width=\'27%\') Dias da Semana--><!-- th(width=\'10%\') Horário--><th width="10%" ng-if="compartilhamentos.roleCadastrar">{{\'core-permissoes.organizacao.compartilhamentos.option\' | translate}}</th></tr></thead><tbody ng-if="uoCompartilhamento.compartilhamentoRealizadoLista.length &gt; 0"><tr><td class="text-center"></td><td colspan="7" class="text-orange"><span><strong>{{\'core-permissoes.organizacao.compartilhamentos.sharingSent\' | translate}}</strong></span></td></tr><tr ng-repeat="compartilhamento in uoCompartilhamento.compartilhamentoRealizadoLista"><td class="text-center"><span aria-hidden="true" class="fa fa-lg fa-arrow-circle-up text-orange"></span></td><td><span ng-if="compartilhamento.uoCompartilhada != null">{{compartilhamento.uoCompartilhada.nome}}</span><span ng-if="compartilhamento.uoCompartilhada == null">{{\'core-permissoes.organizacao.compartilhamentos.allChildUos\' | translate}}</span></td><td><span ng-if="compartilhamento.tipoEntidade != null &amp;&amp; compartilhamento.tipoEntidade.nome">{{translateTipoEntidade(compartilhamento.tipoEntidade.nome)}}<span ng-if="compartilhamento.entidades != null">[{{compartilhamento.entidades.length}}]</span><span ng-if="compartilhamento.entidades == null">{{\'core-permissoes.organizacao.compartilhamentos.all\' | translate}}</span></span><span ng-if="compartilhamento.tipoEntidade == null || !compartilhamento.tipoEntidade.nome">{{\'core-permissoes.organizacao.compartilhamentos.allEntities\' | translate}}</span></td><td><span ng-if="compartilhamento.edicao">{{\'core-permissoes.organizacao.compartilhamentos.yes\' | translate}}</span><span ng-if="!compartilhamento.edicao">{{\'core-permissoes.organizacao.compartilhamentos.no\' | translate}}</span></td><td><span ng-if="compartilhamento.delegacaoTotal">{{\'core-permissoes.organizacao.compartilhamentos.yes\' | translate}}</span><span ng-if="!compartilhamento.delegacaoTotal">{{\'core-permissoes.organizacao.compartilhamentos.no\' | translate}}</span></td><td><a ui-sref="root.cadastro({id: compartilhamento.id})" aria-label="Left Align" ng-if="compartilhamentos.roleCadastrar" class="btn btn-primary btn-xs"><span aria-hidden="true" class="glyphicon glyphicon-search"></span></a></td></tr><!--td\n' +
    '  span(ng-if=\'compartilhamento.periodoInicio != null\')\n' +
    '    | {{compartilhamento.periodoInicio | date:\'dd/MM/yy\'}} à {{compartilhamento.periodoFim | date:\'dd/MM/yy\'}}\n' +
    '  span(ng-if=\'compartilhamento.periodoInicio == null\') Indeterminado\n' +
    'td\n' +
    '  span.label.label-primary(\n' +
    '  ng-repeat=\'dia in compartilhamento.diasDaSemana\'\n' +
    '  ng-if=\'compartilhamento.diasDaSemana.length > 0\'\n' +
    '  style=\'margin-left: 3px\')\n' +
    '    | {{dia.replace(\'_\', \'-\')}}\n' +
    '  span(ng-if=\'compartilhamento.diasDaSemana.length == 0\') Todos\n' +
    'td\n' +
    '  span(ng-if=\'compartilhamento.horaInicio != null\')\n' +
    '    | {{compartilhamento.horaInicio}} às {{compartilhamento.horaFim}}\n' +
    '  span(ng-if=\'compartilhamento.horaInicio == null\')\n' +
    '    | Indeterminado\n' +
    '--></tbody><tbody ng-if="uoCompartilhamento.compartilhamentoRecebidoLista.length &gt; 0"><tr><td></td><td colspan="6" class="text-green"><span><strong>{{\'core-permissoes.organizacao.compartilhamentos.sharingReceived\' | translate}}</strong></span></td></tr><tr ng-repeat="compartilhamento in uoCompartilhamento.compartilhamentoRecebidoLista"><td class="text-center"><span aria-hidden="true" class="fa fa-lg fa-arrow-circle-down text-green"></span></td><td>{{compartilhamento.uo.nome}}</td><td><span ng-if="compartilhamento.tipoEntidade != null &amp;&amp; compartilhamento.tipoEntidade.nome">{{translateTipoEntidade(compartilhamento.tipoEntidade.nome)}}<span ng-if="compartilhamento.entidades != null">[{{compartilhamento.entidades.length}}]</span><span ng-if="compartilhamento.entidades == null">{{\'core-permissoes.organizacao.compartilhamentos.all\' | translate}}</span></span><span ng-if="compartilhamento.tipoEntidade == null || !compartilhamento.tipoEntidade.nome">{{\'core-permissoes.organizacao.compartilhamentos.allEntities\' | translate}}</span></td><td><span ng-if="compartilhamento.edicao">{{\'core-permissoes.organizacao.compartilhamentos.yes\' | translate}}</span><span ng-if="!compartilhamento.edicao">{{\'core-permissoes.organizacao.compartilhamentos.no\' | translate}}</span></td><td><span ng-if="compartilhamento.delegacaoTotal">{{\'core-permissoes.organizacao.compartilhamentos.yes\' | translate}}</span><span ng-if="!compartilhamento.delegacaoTotal">{{\'core-permissoes.organizacao.compartilhamentos.no\' | translate}}</span></td><td></td></tr><!--td\n' +
    '  span(ng-if=\'compartilhamento.periodoInicio != null\')\n' +
    '    | {{compartilhamento.periodoInicio | date:\'dd/MM/yy\'}} à {{compartilhamento.periodoFim | date:\'dd/MM/yy\'}}\n' +
    '  span(ng-if=\'compartilhamento.periodoInicio == null\') Indeterminado\n' +
    'td\n' +
    '  span.label.label-primary(\n' +
    '  ng-repeat=\'dia in compartilhamento.diasDaSemana\'\n' +
    '  ng-if=\'compartilhamento.diasDaSemana.length > 0\'\n' +
    '  style=\'margin-left: 3px\')\n' +
    '    | {{dia.replace(\'_\', \'-\')}}\n' +
    '  span(ng-if=\'compartilhamento.diasDaSemana.length == 0\') Todos\n' +
    'td\n' +
    '  span(ng-if=\'compartilhamento.horaInicio != null\')\n' +
    '    | {{compartilhamento.horaInicio}} às {{compartilhamento.horaFim}}\n' +
    '  span(ng-if=\'compartilhamento.horaInicio == null\')\n' +
    '    | Indeterminado--></tbody></table><div ng-if="uoCompartilhamento.compartilhamentoRealizadoLista.length == 0 &amp;&amp; uoCompartilhamento.compartilhamentoRecebidoLista.length == 0" class="panel panel-default"><div class="panel-body text-muted">{{\'core-permissoes.organizacao.compartilhamentos.noSharedData\' | translate}}</div></div></div></div></div>');
}]);

angular.module('corePermissoes').run(['$templateCache', function($templateCache) {
  $templateCache.put('compartilhamentos/cadastro.tpl.html',
    '<div class="alerta-aqui"></div><div class="box compartilhamento-cadastro"><div class="box-header with-border"><h3 class="box-title">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.sharingSetup\' | translate}}</h3><form name="cadastroForm" class="form-horizontal"><div class="box-body"><div class="form-group"><label class="col-sm-2 control-label">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.originOU\' | translate}}</label><div class="col-sm-7"><ui-select ng-disabled="cadastro.isEdicao" style="width: 100%" ng-required="true" on-select="cadastro.carregarUoCompartilhamento()" ng-model="cadastro.compartilhamento.uo" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match ng-attr-placeholder="{{\'core-permissoes.organizacao.compartilhamentos.shareButton.select\' | translate}}">{{$select.selected.nome}}</ui-select-match><ui-select-choices ng-disaled="cadastro.isEdicao" repeat="uo as uo in (cadastro.uos | filter: $select.search | limitTo: cadastro.limitOrigem ) track by uo.id" scroll-detector="cadastro.loadMoreOrigem()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="col-sm-2 control-label">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.sharedOU\' | translate}}</label><div class="col-sm-7"><ui-select style="width: 100%" ng-disabled="cadastro.isEdicao" ng-required="true" ng-model="cadastro.compartilhamento.uoCompartilhada" ng-change="cadastro.todasFilhas = cadastro.compartilhamento.uoCompartilhada.nome == &quot;TODAS AS FILHAS&quot; ? true: false; cadastro.carregarTipoEntidades(); cadastro.compartilhamento.entidades = null;" close-on-select="true"><ui-select-required></ui-select-required><ui-select-match ng-attr-placeholder="{{\'core-permissoes.organizacao.compartilhamentos.shareButton.select\' | translate}}">{{$select.selected.nome}}</ui-select-match><ui-select-choices group-by="\'tipo\'" repeat="uo as uo in (cadastro.uosCompartilhamento | filter: $select.search | limitTo: cadastro.limitDestino) track by uo.id" scroll-detector="cadastro.loadMoreDestino()"><span style="padding-left: {{15 * uo.arvoreNivel}}px"><i class="fa fa-level-up fa-rotate-90 fa-icon-right"></i><span ng-bind-html="uo.nome  | highlight: $select.search"></span><span class="fa-icon-left pull-right text-muted">ID: {{ uo.id }}</span></span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="col-sm-2 control-label"></label><div class="col-sm-7"><div ng-if="cadastro.tipoPermiteEdicao()"><input id="edicaoCheck" type="checkbox" ng-model="cadastro.compartilhamento.edicao"/>          {{\'core-permissoes.organizacao.compartilhamentos.shareButton.allowEditing\' | translate}}</div><div ng-show="cadastro.compartilhamento.edicao &amp;&amp; cadastro.compartilhamento.tipoEntidade.enumEntidade === &quot;VEICULOS&quot;"><input id="delegacaoCheck" type="checkbox" ng-model="cadastro.compartilhamento.delegacaoTotal"/><strong>{{\'core-permissoes.organizacao.compartilhamentos.shareButton.fullDelegation\' | translate}}</strong><small> {{\'core-permissoes.organizacao.compartilhamentos.shareButton.fullDelegation2\' | translate}}</small></div></div></div><div class="form-group"><label for="selectTipoEntidade" class="col-sm-2 control-label">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.entity\' | translate}}</label><div class="col-sm-7"><select id="selectTipoEntidade" ng-disabled="cadastro.isEdicao" ng-model="cadastro.compartilhamento.tipoEntidade" ng-options="e as (\'core-permissoes.organizacao.compartilhamentos.shareButton.\' + cadastro.entidadeMap[e.nome] | translate) for e in cadastro.tipoEntidades | orderBy:\'id\' track by e.id" ng-change="cadastro.limparVariaveisControle()" class="form-control"></select></div></div><div ng-show="cadastro.exibirEntidades()" class="form-group"><label for="entidadesSelect" class="col-sm-2 control-label"></label><div class="col-sm-7"><input id="entidadeCheck" type="checkbox" ng-model="cadastro.todasAsEntidades" ng-change="cadastro.carregarEntidades()"/><label for="entidadeCheck">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.allEntity\' | translate}} {{translateTipoEntidade(cadastro.compartilhamento.tipoEntidade.nome)}}</label><div ng-if="cadastro.todasAsEntidades == false"><small>{{\'core-permissoes.organizacao.compartilhamentos.shareButton.informEntity\' | translate}} {{translateTipoEntidade(cadastro.compartilhamento.tipoEntidade.nome)}} {{\'core-permissoes.organizacao.compartilhamentos.shareButton.informEntity2\' | translate}}</small><div class="input-group"><ui-select id="entidadesSelect" style="width: 100%" ng-model="cadastro.compartilhamento.entidades" ng-paste="cadastro.setItens($select)" ng-required="!cadastro.todasAsEntidades" multiple="multiple"><ui-select-required></ui-select-required><ui-select-match placeholder="{{\'core-permissoes.organizacao.compartilhamentos.shareButton.enterEntities\' | translate}} {{translateTipoEntidade(cadastro.compartilhamento.tipoEntidade.nome)}} {{\'core-permissoes.organizacao.compartilhamentos.shareButton.enterEntities2\' | translate}}">{{ $item.descricao }}</ui-select-match><ui-select-choices repeat="d in (cadastro.entidades | filter: $select.search | limitTo: cadastro.limit) track by d.id" scroll-detector="cadastro.loadMore()"><div ng-bind-html="d.descricao | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="cadastro.compartilhamento.entidades.length &gt; 0" ng-click="cadastro.compartilhamento.entidades = []" class="input-group-addon"><div class="fa fa-trash"></div></div></div><div ng-if="cadastro.listFail.length &gt; 0"><strong>{{cadastro.compartilhamento.tipoEntidade}} {{\'core-permissoes.organizacao.compartilhamentos.shareButton.regIssue\' | translate}}</strong><a href="#" ng-click="cadastro.listFail = []"> {{\'core-permissoes.organizacao.compartilhamentos.shareButton.deleteAll\' | translate}}</a><div><span ng-repeat="item in cadastro.listFail track by $index" class="badge bg-red fa-icon-right"><span>{{item}}</span><i ng-click="cadastro.removeInvalidItem($index)" class="fa fa-times fa-icon-left cursor-pointer"></i></span></div></div></div></div></div><div class="alerta-aqui"></div></div><div class="box-footer"><div class="col-sm-offset-2 col-sm-10"><button type="submit" ng-disabled="cadastroForm.$invalid" ng-click="cadastro.salvar()" class="btn btn-primary">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.save\' | translate}}</button><button ng-click="cadastro.excluir()" ng-if="cadastro.stateParams.id &gt; 0" class="btn btn-danger">{{\'core-permissoes.organizacao.compartilhamentos.shareButton.delete\' | translate}}</button><a onclick="window.history.back();" class="btn btn-default"> {{\'core-permissoes.organizacao.compartilhamentos.shareButton.back\' | translate}}</a></div></div></form></div></div>');
}]);

'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var MILES_CONSTANT = 1.60934;

  var MeasurementUnitConverterService = function () {
    function MeasurementUnitConverterService() {
      _classCallCheck(this, MeasurementUnitConverterService);
    }

    _createClass(MeasurementUnitConverterService, [{
      key: 'getDateTimeFormat',
      value: function getDateTimeFormat(dateTimeFormat) {
        return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy HH:mm:ss' : 'MM/dd/yy HH:mm:ss';
      }
    }, {
      key: 'getDateFormat',
      value: function getDateFormat(dateTimeFormat) {
        return dateTimeFormat === 'BRITISH' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
      }
    }, {
      key: 'getFormattedDateTimeWithTwoDigitYear',
      value: function getFormattedDateTimeWithTwoDigitYear(dateTimeFormat) {
        return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy' : 'MM/dd/yy';
      }
    }, {
      key: 'getDistanceUnit',
      value: function getDistanceUnit(distanceMeasurement) {
        return distanceMeasurement === 'KM' ? 'Km' : 'mi';
      }
    }, {
      key: 'getSpeedUnit',
      value: function getSpeedUnit(speedMeasurement) {
        return speedMeasurement === 'KM' ? 'Km/h' : 'mph';
      }
    }, {
      key: 'getFuelUnit',
      value: function getFuelUnit(fuelMeasurement) {
        return fuelMeasurement === 'LITERS' ? 'L' : 'gal';
      }
    }, {
      key: 'getFuelEfficiencyUnit',
      value: function getFuelEfficiencyUnit(fuelMeasurement) {
        return fuelMeasurement === 'LITERS' ? 'Km/L' : 'mpg';
      }
    }, {
      key: 'getEnergyEfficiencyUnit',
      value: function getEnergyEfficiencyUnit(distanceMeasurement) {
        return distanceMeasurement === 'KM' ? 'Km/kWh' : 'mi/kWh';
      }
    }, {
      key: 'getKmhToMph',
      value: function getKmhToMph(kmh) {
        return Math.round(kmh / MILES_CONSTANT);
      }
    }, {
      key: 'getMphToKmh',
      value: function getMphToKmh(miles) {
        return (miles * MILES_CONSTANT).toFixed(0);
      }
    }]);

    return MeasurementUnitConverterService;
  }();

  angular.module('ModuleMeasurementUnitConverter', []).service('MeasurementUnitConverterService', MeasurementUnitConverterService);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */

  angular.module('usuarios', ['ui.router', 'ui.bootstrap.modal', 'flash', 'enumModule', 'ui.bootstrap.modal', 'flash', 'ui.tree', 'perfis', 'uoModule', 'uoArvoreNivelModule', 'v3gAuthenticatorModule', 'enumModule', 'FeatureFlagModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'alert-message', 'VtabelaModule']).constant('PerfilIntegracao', 1001).constant('PerfilAdminVeltec', 1).constant('UsuariosMessageMap', {
    'Senha deve ter ao menos 8 dígitos, uma letra maiúscula, uma letra minúscula, um número e um caractere especial': 'passwordValidationMessageError',
    'Login deve ser um email': 'loginValidationMessageError',
    'Senha deve ter ao menos 8 dígitos, uma letra maiúscula, uma letra minúscula, um número e um caractere especial, Login deve ser um email': 'loginAndPasswordValidationMessageError',
    'Email inválido para usuários com perfil Administrador PS': 'veltecEmailValidationMessageError'
  }).constant('SHARED_EMAIL_THIRD_PARTY', ['grparceria.com.br', 'trimble.com', 'platformscience.com']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CadastrarUsuarioCtrl = function () {
    function CadastrarUsuarioCtrl($uibModalInstance, Flash, PerfisPublic, UsuariosService, uoArvore, uoSelecionada, Uos, uoArvoreNivel, PerfilIntegracao, PerfilAdminVeltec, Authenticator, PaisService, IdiomasEnum, MeasurementSystemEnum, RolesEnum, $translate, UsuariosMessageMap, SHARED_EMAIL_THIRD_PARTY, $scope, isNaOu, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, CadastrarUsuarioCtrl);

      this.isNaOu = isNaOu;
      this.idiomasEnum = IdiomasEnum;
      this.measurementSystemEnum = MeasurementSystemEnum;
      this.isMeasurementSystemEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.MEASUREMENT_SYSTEM);
      this.rolesEnum = RolesEnum;
      this.modalInstance = $uibModalInstance;
      this.uoService = Uos;
      this.flash = Flash;
      this.perfisService = PerfisPublic;
      this.usuarioService = UsuariosService;
      this.uoArvore = uoArvore;
      this.paisService = PaisService;
      this.uoArvoreNivel = uoArvoreNivel;
      this.uosFiltradas = this.carregarUos(uoSelecionada);
      this.uoSelecionada = uoArvore.filter(function (uo) {
        return uo.id === uoSelecionada;
      })[0];
      this.perfilIntegracao = PerfilIntegracao;
      this.perfilAdminVeltec = PerfilAdminVeltec;
      this.limit = 10;
      this.paises = [];
      this.EMAIL_THIRD_PARTY = SHARED_EMAIL_THIRD_PARTY;
      this.usuario = { idioma: this.idiomasEnum[0], otpEnabled: false };
      this.mapBandeiras = new Map();
      this.minCaracteres = 3;
      this.maxCaracteres = 50;
      this.scope = $scope;
      Authenticator.getUser().then(function (user) {
        _this.user = user;
        var userLanguage = _this.idiomasEnum.getIdiomaByKey(user.idioma);
        _this.usuario.idioma = userLanguage || _this.idiomasEnum.getIdiomaByKey('PT_BR');
        _this.usuario.measurementSystem = user.measurementSystem || _this.measurementSystemEnum.getDefaultKeyForLanguage(_this.usuario.idioma.key);
        _this.carregarPaises();
        _this.carregarPerfis();
      });
      this.translate = $translate;
      this.usuariosMessageMap = UsuariosMessageMap;
      this.setupLanguageWatcher();
    }

    _createClass(CadastrarUsuarioCtrl, [{
      key: 'loadMore',
      value: function loadMore() {
        this.limit += 10;
      }
    }, {
      key: 'setupLanguageWatcher',
      value: function setupLanguageWatcher() {
        var _this2 = this;

        this.scope.$watch(function () {
          return _this2.usuario.idioma;
        }, function (newLanguage, oldLanguage) {
          if (newLanguage && newLanguage !== oldLanguage) {
            _this2.carregarPaises();
          }
        });
      }
    }, {
      key: 'getDefaultCountryCodeForLanguage',
      value: function getDefaultCountryCodeForLanguage(languageKey) {
        var countryCodes = {
          'EN_US': 'US',
          'EN_GB': 'GB',
          'DE_DE': 'DE',
          'FR_FR': 'FR',
          'IT_IT': 'IT',
          'NL_NL': 'NL',
          'PL_PL': 'PL',
          'ES_ES': 'ES'
        };
        return countryCodes[languageKey] || 'BR';
      }
    }, {
      key: 'carregarPaises',
      value: function carregarPaises() {
        var _this3 = this;

        var languageKey = this.usuario.idioma && this.usuario.idioma.key;
        this.paisService.getList({ idioma: languageKey }).then(function (paises) {
          _this3.paises = paises.plain();
          _this3.paises.forEach(function (pais) {
            _this3.mapBandeiras.set(pais.code, _this3.getLinkImgBandeira(pais.code));
          });
          var defaultCountry = _this3.paises.find(function (pais) {
            return pais.code === _this3.getDefaultCountryCodeForLanguage(languageKey);
          });
          if (defaultCountry) {
            _this3.usuario.pais = defaultCountry;
          }
        });
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos(uoSelecionada) {
        var _this4 = this;

        this.uoService.getFilhas(uoSelecionada).then(function (data) {
          return _this4.uosFiltradas = _this4.uoArvoreNivel.converterEmLista(data.plain());
        });
      }
    }, {
      key: 'carregarPerfis',
      value: function carregarPerfis() {
        var _this5 = this;

        this.perfisService.getList().then(function (perfis) {
          _this5.perfis = perfis.plain().filter(function (p) {
            return p.nome !== 'VDrivers';
          }).filter(function (p) {
            return p.id !== _this5.perfilIntegracao || _this5.user.perfil.id === _this5.perfilAdminVeltec;
          }).map(function (p) {
            if (_this5.rolesEnum.getDescricaoByDescricaoDB(p.nome)) {
              p.nome = _this5.translate.instant(_this5.rolesEnum.getDescricaoByDescricaoDB(p.nome));
            }
            return p;
          });
        });
      }
    }, {
      key: 'getLinkImgBandeira',
      value: function getLinkImgBandeira(code) {
        return 'https://vfleets-imagens.s3-sa-east-1.amazonaws.com/paises/' + code.toLowerCase() + '.png';
      }
    }, {
      key: 'errorValidarTelefone',
      value: function errorValidarTelefone(form) {
        return this.dddError(form) || this.ddiError(form) || this.dddDdiError(form) || this.telefoneError(form);
      }
    }, {
      key: 'numeroVazio',
      value: function numeroVazio(form) {
        return form.telefone.$viewValue === '' || !form.telefone.$viewValue;
      }
    }, {
      key: 'labelError',
      value: function labelError(form) {
        return this.comecouEdicaoTelefone(form) && (this.dddError(form) || this.ddiError(form) || this.telefoneError(form) || this.dddDdiError(form));
      }
    }, {
      key: 'dddError',
      value: function dddError(form) {
        return this.dddVazio(form) && (!this.ddiVazio(form) && !this.numeroVazio(form) || this.numeroVazio(form) && !this.ddiVazio(form));
      }
    }, {
      key: 'telefoneError',
      value: function telefoneError(form) {
        return this.numeroVazio(form) && (!this.ddiVazio(form) || !this.dddVazio(form));
      }
    }, {
      key: 'ddiError',
      value: function ddiError(form) {
        return this.ddiVazio(form) && (!this.dddVazio(form) && !this.numeroVazio(form) || !this.dddVazio(form) && this.numeroVazio(form));
      }
    }, {
      key: 'dddDdiError',
      value: function dddDdiError(form) {
        return this.dddVazio(form) && this.ddiVazio(form) && !this.numeroVazio(form);
      }
    }, {
      key: 'telefoneVazio',
      value: function telefoneVazio(form) {
        return (form.ddd.$viewValue === '' || !form.ddd.$viewValue) && (form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue) && (form.telefone.$viewValue === '' || !form.telefone.$viewValue);
      }
    }, {
      key: 'dddVazio',
      value: function dddVazio(form) {
        return form.ddd.$viewValue === '' || !form.ddd.$viewValue;
      }
    }, {
      key: 'ddiVazio',
      value: function ddiVazio(form) {
        return form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue;
      }
    }, {
      key: 'comecouEdicaoTelefone',
      value: function comecouEdicaoTelefone(form) {
        return form.telefone || form.ddd || form.paisTelefone;
      }
    }, {
      key: 'responsavelError',
      value: function responsavelError(form) {
        if (form.isResponsavelPassiveis.$dirty) {
          return form.isResponsavelPassiveis.$viewValue === '' || !form.isResponsavelPassiveis.$viewValue;
        }
        return false;
      }
    }, {
      key: 'loginIsThirdParty',
      value: function loginIsThirdParty(email) {
        var emailParts = email ? email.split('@') : [];
        if (emailParts.length < 2) {
          return false;
        }
        return this.EMAIL_THIRD_PARTY.includes(emailParts[1]) && this.perfilAdminVeltec === this.user.perfil.id;
      }
    }, {
      key: 'userCanEditOU',
      value: function userCanEditOU() {
        var emailMain = this.user.login ? this.user.login.split('@') : [];
        return (emailMain.length === 2 ? emailMain[1] === 'trimble.com' || emailMain[1] === 'platformscience.com' : false) && this.perfilAdminVeltec === this.user.perfil.id;
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this6 = this;

        var usuario = {
          id: 0,
          login: this.usuario.login,
          nome: this.usuario.nome,
          pais: this.usuario.pais,
          cargo: this.usuario.cargo,
          perfil: this.usuario.perfil,
          uo: this.uoSelecionada,
          senha: this.usuario.senha,
          idioma: this.usuario.idioma.key,
          otpEnabled: this.usuario.otpEnabled,
          isResponsavelPassiveis: this.usuario.isResponsavelPassiveis
        };
        if (this.isNaOu) {
          usuario.lastName = this.usuario.lastName;
        }
        if (this.isMeasurementSystemEnabled && this.usuario.measurementSystem) {
          usuario.measurementSystem = this.usuario.measurementSystem;
        }
        if (this.userCanEditOU() && this.loginIsThirdParty(this.usuario.login)) {
          usuario.acessoTrocaUo = this.usuario.acessoTrocaUo;
        }
        if (this.usuario.telefone) {
          usuario.ddd = this.usuario.ddd;
          usuario.telefone = this.usuario.telefone;
          usuario.paisTelefone = this.usuario.paisTelefone;
        }
        this.usuarioService.post(usuario).then(function () {
          return _this6.modalInstance.close(_this6.translate.instant('core-permissoes.organizacao.usuarios.popup.emailSent'));
        }, function (data) {
          var messageKey = _this6.usuariosMessageMap[data.data.message];
          var message = messageKey ? _this6.translate.instant('core-permissoes.organizacao.usuarios.popup.' + messageKey) : data.data.message;
          _this6.flash.create('error', message);
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss('cancel');
      }
    }, {
      key: 'ok',
      value: function ok(form) {
        if (form.$valid && !this.errorValidarTelefone(form)) {
          this.salvar();
        } else {
          form.uo.$setDirty();
          form.email.$setDirty();
          form.nome.$setDirty();
          if (this.isNaOu) {
            form.lastName.$setDirty();
          }
          form.perfil.$setDirty();
          form.pais.$setDirty();
          form.isResponsavelPassiveis.$setDirty();
        }
      }
    }]);

    return CadastrarUsuarioCtrl;
  }();

  angular.module('usuarios').controller('CadastrarUsuarioCtrl', CadastrarUsuarioCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var EditarUsuarioCtrl = function () {
    function EditarUsuarioCtrl(usuario, uoArvore, PerfisPublic, $uibModalInstance, UsuariosService, Flash, PerfilIntegracao, PerfilAdminVeltec, Authenticator, PaisService, IdiomasEnum, MeasurementSystemEnum, RolesEnum, AlertMessage, $translate, UsuariosMessageMap, SHARED_EMAIL_THIRD_PARTY, isNaOu, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, EditarUsuarioCtrl);

      this.isNaOu = isNaOu;
      this.idiomasEnum = IdiomasEnum;
      this.measurementSystemEnum = MeasurementSystemEnum;
      this.isMeasurementSystemEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.MEASUREMENT_SYSTEM);
      this.rolesEnum = RolesEnum;
      this.usuario = _.cloneDeep(usuario);
      this.perfisService = PerfisPublic;
      this.modalInstance = $uibModalInstance;
      this.usuariosService = UsuariosService;
      this.uoArvore = uoArvore;
      this.alertMessage = AlertMessage;
      this.paisService = PaisService;
      this.perfilSelecionado = this.usuario.perfil;
      this.idiomaSelecionado = this.idiomasEnum.getIdiomaByKey(this.usuario.idioma) || this.idiomasEnum.getIdiomaByKey('PT_BR');
      this.usuario.measurementSystem = this.usuario.measurementSystem || this.measurementSystemEnum.getDefaultKeyForLanguage(this.idiomaSelecionado.key);
      this.isResponsavelPassiveis = this.getIsReponsavelPassiveis(this.usuario.isResponsavelPassiveis);
      this.acessoTrocaUo = this.getAcessoTrocaUo(this.usuario.acessoTrocaUo);
      this.uoSelecionada = uoArvore.filter(function (uo) {
        return uo.id === _this.usuario.uoId;
      })[0];
      this.flash = Flash;
      this.perfilIntegracao = PerfilIntegracao;
      this.perfilAdminVeltec = PerfilAdminVeltec;
      this.limit = 10;
      this.paises = [];
      this.mapBandeiras = new Map();
      this.minCaracteres = 3;
      this.maxCaracteres = 50;
      // Para usuário com telefone cadastrado vai ser obrigatório o campo de telefone
      this.telefoneCadastrado = Boolean(this.usuario.telefone);
      this.keycloakUser = null;
      this.canChange2fa = false;
      this.translate = $translate;
      this.usuariosMessageMap = UsuariosMessageMap;
      this.EMAIL_THIRD_PARTY = SHARED_EMAIL_THIRD_PARTY;
      Authenticator.getUser().then(function (user) {
        _this.user = user;
        _this.carregarPaises();
        _this.carregarPerfis();
        _this.carregarKeycloakUser();
        var emailMain = _this.user.login ? _this.user.login.split('@') : [];
        _this.domainEditAccessOU = emailMain.length > 1 ? emailMain[1] === 'trimble.com' || emailMain[1] === 'platformscience.com' : false;
      });
    }

    _createClass(EditarUsuarioCtrl, [{
      key: 'loadMore',
      value: function loadMore() {
        this.limit += 10;
      }
    }, {
      key: 'carregarPaises',
      value: function carregarPaises() {
        var _this2 = this;

        var idioma = this.user && this.user.idioma || 'PT_BR';
        this.paisService.getList({ idioma: idioma }).then(function (paises) {
          _this2.paises = paises.plain();
          _this2.paises.forEach(function (pais) {
            if (_this2.usuario.pais && _this2.usuario.pais.code === pais.code) {
              _this2.usuario.pais = pais;
            }

            if (_this2.usuario.paisTelefone && _this2.usuario.paisTelefone.code === pais.code) {
              _this2.usuario.paisTelefone = pais;
            }

            _this2.mapBandeiras.set(pais.code, _this2.getLinkImgBandeira(pais.code));
          });
        });
      }
    }, {
      key: 'carregarPerfis',
      value: function carregarPerfis() {
        var _this3 = this;

        this.perfisService.getList().then(function (perfis) {
          _this3.perfis = perfis.plain().filter(function (p) {
            return p.nome !== 'VDrivers';
          }).filter(function (p) {
            return p.id !== _this3.perfilIntegracao || _this3.user.perfil.id === _this3.perfilAdminVeltec;
          }).map(function (p) {
            if (_this3.rolesEnum.getDescricaoByDescricaoDB(p.nome)) {
              p.nome = _this3.translate.instant(_this3.rolesEnum.getDescricaoByDescricaoDB(p.nome));
            }
            return p;
          });
        });
      }
    }, {
      key: 'carregarKeycloakUser',
      value: function carregarKeycloakUser() {
        var _this4 = this;

        this.usuariosService.one(this.usuario.id).one('keycloak').get().then(function (keycloakUser) {
          _this4.keycloakUser = keycloakUser;
          _this4.canChange2fa = !!keycloakUser.id;
          _this4.enable2fa = !!keycloakUser.totp || (keycloakUser.requiredActions ? keycloakUser.requiredActions.includes('CONFIGURE_TOTP') : false);
        });
      }
    }, {
      key: 'change2fa',
      value: function change2fa() {
        var _this5 = this;

        this.usuariosService.one(this.usuario.id).one('otp').one(this.enable2fa).customPUT().then(function () {
          _this5.alertMessage.create({
            type: 'success',
            message: 'Two Factor Authentication atualizado com sucesso!',
            appendTo: '.alerta-2fa-aqui'
          });
        }).catch(function () {
          _this5.enable2fa = !_this5.enable2fa;
          _this5.alertMessage.create({
            type: 'error',
            message: 'Ocorreu um erro ao atualizar o Two Factor Authentication',
            appendTo: '.alerta-2fa-aqui'
          });
        });
      }
    }, {
      key: 'getLinkImgBandeira',
      value: function getLinkImgBandeira(code) {
        return 'https://vfleets-imagens.s3-sa-east-1.amazonaws.com/paises/' + code.toLowerCase() + '.png';
      }
    }, {
      key: 'getIsReponsavelPassiveis',
      value: function getIsReponsavelPassiveis(isResponsavel) {
        if (angular.isDefined(isResponsavel) && isResponsavel !== null) {
          return String(isResponsavel);
        }
        return null;
      }
    }, {
      key: 'getAcessoTrocaUo',
      value: function getAcessoTrocaUo(canChangeOU) {
        if (angular.isDefined(canChangeOU) && canChangeOU !== null) {
          return String(canChangeOU);
        }
        return null;
      }
    }, {
      key: 'errorValidarTelefone',
      value: function errorValidarTelefone(form) {
        if (this.telefoneCadastrado) {
          return this.dddError(form) || this.ddiError(form) || this.dddDdiError(form) || this.telefoneError(form) || this.telefoneVazio(form);
        }
        return this.dddError(form) || this.ddiError(form) || this.dddDdiError(form || this.telefoneError(form));
      }
    }, {
      key: 'labelError',
      value: function labelError(form) {
        return this.comecouEdicaoTelefone(form) && (this.dddError(form) || this.ddiError(form) || this.telefoneError(form) || this.dddDdiError(form));
      }
    }, {
      key: 'dddError',
      value: function dddError(form) {
        return this.dddVazio(form) && (!this.ddiVazio(form) && !this.numeroVazio(form) || this.numeroVazio(form) && !this.ddiVazio(form));
      }
    }, {
      key: 'telefoneError',
      value: function telefoneError(form) {
        return this.numeroVazio(form) && (!this.ddiVazio(form) || !this.dddVazio(form));
      }
    }, {
      key: 'ddiError',
      value: function ddiError(form) {
        return this.ddiVazio(form) && (!this.dddVazio(form) && !this.numeroVazio(form) || !this.dddVazio(form) && this.numeroVazio(form));
      }
    }, {
      key: 'dddDdiError',
      value: function dddDdiError(form) {
        return this.dddVazio(form) && this.ddiVazio(form) && !this.numeroVazio(form);
      }
    }, {
      key: 'telefoneVazio',
      value: function telefoneVazio(form) {
        return (form.ddd.$viewValue === '' || !form.ddd.$viewValue) && (form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue) && (form.telefone.$viewValue === '' || !form.telefone.$viewValue);
      }
    }, {
      key: 'dddVazio',
      value: function dddVazio(form) {
        return form.ddd.$viewValue === '' || !form.ddd.$viewValue;
      }
    }, {
      key: 'ddiVazio',
      value: function ddiVazio(form) {
        return form.paisTelefone.$viewValue === '' || !form.paisTelefone.$viewValue;
      }
    }, {
      key: 'numeroVazio',
      value: function numeroVazio(form) {
        return form.telefone.$viewValue === '' || !form.telefone.$viewValue;
      }
    }, {
      key: 'comecouEdicaoTelefone',
      value: function comecouEdicaoTelefone(form) {
        return form.telefone || form.ddd || form.paisTelefone;
      }
    }, {
      key: 'loginIsThirdParty',
      value: function loginIsThirdParty(email) {
        var emailParts = email ? email.split('@') : [];
        if (emailParts.length < 2) {
          return false;
        }
        return this.EMAIL_THIRD_PARTY.includes(emailParts[1]) && this.perfilAdminVeltec === this.user.perfil.id;
      }
    }, {
      key: 'responsavelError',
      value: function responsavelError(form) {
        if (form.isResponsavelPassiveis.$dirty) {
          return form.isResponsavelPassiveis.$viewValue === '' || !form.isResponsavelPassiveis.$viewValue;
        }
        return false;
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this6 = this;

        var mustKillSession = this.usuario.uo.id !== this.uoSelecionada.id;
        this.usuario.uo = this.uoSelecionada;
        this.usuario.perfil = this.perfilSelecionado;
        this.usuario.idioma = this.idiomaSelecionado.key;
        if (!this.isMeasurementSystemEnabled) {
          this.usuario.measurementSystem = this.measurementSystemEnum.getDefaultKeyForLanguage(this.idiomaSelecionado.key);
        }
        this.usuario.isResponsavelPassiveis = this.isResponsavelPassiveis;
        if (this.domainEditAccessOU && this.loginIsThirdParty(this.usuario.login)) {
          this.usuario.acessoTrocaUo = this.acessoTrocaUo;
        } else {
          delete this.usuario.acessoTrocaUo;
        }
        this.usuariosService.one(this.usuario.id).customPUT(this.usuario, undefined, { mustKillSession: mustKillSession }).then(function () {
          _this6.modalInstance.close();
          _this6.alertMessage.create({
            type: 'success',
            message: _this6.translate.instant('core-permissoes.organizacao.usuarios.popup.registrationEditedSuccessfully'),
            appendTo: '.alerta-aqui'
          });
        }, function (data) {
          var messageKey = _this6.usuariosMessageMap[data.data.message];
          var message = messageKey ? _this6.translate.instant('core-permissoes.organizacao.usuarios.popup.' + messageKey) : data.data.message;
          _this6.flash.create('error', message);
        });
      }
    }, {
      key: 'novaSenha',
      value: function novaSenha() {
        var _this7 = this;

        this.usuariosService.one(this.usuario.id).customPOST(null, 'nova-senha').then(function () {
          return _this7.flash.create('success', _this7.translate.instant('core-permissoes.organizacao.usuarios.popup.emailSentSuccessfully'));
        }, function () {
          return _this7.flash.create('error', _this7.translate.instant('core-permissoes.organizacao.usuarios.popup.errorSendingEmail'));
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss('cancel');
      }
    }, {
      key: 'ok',
      value: function ok(form) {
        if (form.$valid && !this.errorValidarTelefone(form)) {
          this.salvar();
        } else {
          form.uo.$setDirty();
          form.login.$setDirty();
          form.nome.$setDirty();
          if (this.isNaOu) {
            form.lastName.$setDirty();
          }
          form.perfil.$setDirty();
          form.pais.$setDirty();
          form.isResponsavelPassiveis.$setDirty();
        }
      }
    }]);

    return EditarUsuarioCtrl;
  }();

  angular.module('usuarios').controller('EditarUsuarioCtrl', EditarUsuarioCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name uos
   * @description
   *
   */

  angular.module('uos', ['ui.router', 'alert-message', 'ComponentsVfiltroModule', 'uoModule', 'uoArvoreNivelModule', 'v3gAuthenticatorModule', 'enumModule', 'vUuidMaskModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ConfirmImportTtcModalCtrl = function () {
    function ConfirmImportTtcModalCtrl($uibModalInstance) {
      _classCallCheck(this, ConfirmImportTtcModalCtrl);

      this.modalInstance = $uibModalInstance;
    }

    _createClass(ConfirmImportTtcModalCtrl, [{
      key: 'confirmar',
      value: function confirmar() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return ConfirmImportTtcModalCtrl;
  }();

  angular.module('uos').controller('ConfirmImportTtcModalCtrl', ConfirmImportTtcModalCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name histExpurgo
   * @description
   *
   */

  angular.module('histExpurgo', ['ui.router', 'angularMoment', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'pascalprecht.translate', 'ConstantVfiltroModule', 'VtabelaModule', 'AlertasModule']).factory('HistExpurgo', function (Restangular) {
    return Restangular.service('/expurgo/expurgos');
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('histExpurgo').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.histExpurgo', {
      url: '/historico-expurgo?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'expurgo/hist-expurgo/hist-expurgo.tpl.html',
          controller: 'HistExpurgoCtrl',
          controllerAs: 'ctrl'
        }
      },
      data: {
        titulo: 'core-permissoes.purge.dismissalHistory',
        role: 'ABONO_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var HistExpurgoCtrl = function () {
    function HistExpurgoCtrl($filter, HistExpurgo, ServiceVfiltro, FactoryVfiltro, Keys, VtabelaFactory, AlertasEnum, moment, $translate, Authenticator, MeasurementUnitConverterService) {
      var _this = this;

      _classCallCheck(this, HistExpurgoCtrl);

      this.histExpurgoService = HistExpurgo;
      this.keys = Keys;
      this.filter = $filter;
      this.vtabelaFactory = VtabelaFactory;
      this.serviceVfiltro = ServiceVfiltro;
      this.alertasEnum = AlertasEnum;
      this.moment = moment;
      this.translate = $translate;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator = Authenticator;
      this.authenticator.getUser().then(function (user) {
        _this.dateTimeFormat = _this.measurementUnitConverterService.getDateTimeFormat(user.measurementUnits.dateTimeFormat);
      });
      this.vtabela = null;
      this.serviceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.dateTime.name,
        time: true,
        maxDate: this.moment().endOf('day').format(),
        dateLimit: 30,
        defaultValues: {
          hoje: {
            active: true
          },
          ontem: {
            active: true
          },
          ultimos7dias: {
            active: true
          },
          ultimos30dias: {
            active: true
          }
        }
      }, {
        name: 'uoId',
        key: Keys.uo.name
      }, {
        name: 'veiculoIds',
        key: this.keys.veiculos.name,
        size: 6
      }, {
        name: 'tipo-evento',
        key: this.keys.tipo.name,
        size: 6,
        hasNivel: false
      }])).then(function (filtro) {
        _this.filtro = filtro;
        _this.consultar();
        _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), _this.serviceVfiltro.factoryVfiltro.user, 'expurgos');
      });
    }

    _createClass(HistExpurgoCtrl, [{
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          exportsCsv: false,
          enableSelectAll: false,
          showColumnFooter: true,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'veiculo',
            displayName: this.translate.instant('core-permissoes.purge.vehicle'),
            type: 'string',
            pinnedLeft: true,
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'uo',
            displayName: this.translate.instant('core-permissoes.purge.Ou'),
            enableHiding: false,
            filterCellFiltered: true,
            headerCellClass: 'icon-info-tooltip',
            headerTooltip: this.translate.instant('core-permissoes.purge.vehicleToolTip')
          }, {
            name: 'evento',
            displayName: this.translate.instant('core-permissoes.purge.eventType'),
            filterCellFiltered: true,
            enableHiding: false
          }, {
            name: 'dataHoraInicio',
            displayName: this.translate.instant('core-permissoes.purge.startDateTime'),
            type: 'date',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'dataHoraFim',
            displayName: this.translate.instant('core-permissoes.purge.endDateTime'),
            type: 'date',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'responsavel',
            displayName: this.translate.instant('core-permissoes.purge.responsible'),
            filterCellFiltered: true
          }, {
            name: 'justificativa',
            displayName: this.translate.instant('core-permissoes.purge.justification'),
            filterCellFiltered: true
          }]
        };
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          veiculo: this.getVeiculo(item.veiculo),
          uo: item.uo.nome,
          evento: this.getEvento(item.tipoEvento),
          dataHoraInicio: item.inicio,
          dataHoraFim: item.fim,
          responsavel: item.responsavel,
          justificativa: item.justificativa
        };
      }
    }, {
      key: 'getEvento',
      value: function getEvento(evento) {
        return this.translate.instant(this.alertasEnum.getAlerta(evento).descricao);
      }
    }, {
      key: 'getVeiculo',
      value: function getVeiculo(veiculo) {
        return veiculo.prefixo + ' - ' + veiculo.placa;
      }
    }, {
      key: 'consultar',
      value: function consultar() {
        var _this2 = this;

        this.histExpurgoService.one().get(this.serviceVfiltro.getFiltroBackendNovo(this.filtro)).then(function (data) {
          return _this2.setInfoTable(data);
        }).catch(function () {
          return _this2.vtabela.setError();
        });
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this3 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this3.getItemVtabela(i);
        }));
      }
    }]);

    return HistExpurgoCtrl;
  }();

  /**
   * @ngdoc object
   * @name expurgo.controller:HistExpurgoCtrl
   *
   * @description
   *
   */


  angular.module('histExpurgo').controller('HistExpurgoCtrl', HistExpurgoCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name expurgo
   * @description
   *
   */

  angular.module('expurgo', ['ui.router', 'ui.bootstrap.modal', 'httpServiceV3gModule', 'ConstantModule', 'angularMoment', 'uoModule', 'uoArvoreNivelModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'AlertasModule', 'veiculos', 'pascalprecht.translate']).filter('veiculosFilter', function () {
    return function (veiculos, props) {
      var veiculosFiltrados = [];
      if (angular.isArray(veiculos)) {
        veiculos.forEach(function (veiculo) {
          var veiculoMatches = false;

          var keys = Object.keys(props);

          keys.forEach(function (key) {
            var parametroDeBusca = props[key].toLowerCase(),
                keyContemParametroDeBusca = veiculo[key] ? veiculo[key].toLowerCase().includes(parametroDeBusca) : '';
            if (keyContemParametroDeBusca) {
              veiculoMatches = true;
              return;
            }
          });

          if (veiculoMatches) {
            veiculosFiltrados.push(veiculo);
          }
        });
      } else {
        veiculosFiltrados = veiculos;
      }

      return veiculosFiltrados;
    };
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ConfirmExpurgoModalCtrl = function () {
    function ConfirmExpurgoModalCtrl($uibModalInstance, evento) {
      _classCallCheck(this, ConfirmExpurgoModalCtrl);

      this.modalInstance = $uibModalInstance;
      this.evento = evento;
    }

    _createClass(ConfirmExpurgoModalCtrl, [{
      key: 'confirmar',
      value: function confirmar() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return ConfirmExpurgoModalCtrl;
  }();

  angular.module('expurgo').controller('ConfirmExpurgoModalCtrl', ConfirmExpurgoModalCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */

  angular.module('compartilhamentos', ['ui.router', 'ui.bootstrap.modal', 'restangular', 'alert-message', 'uoModule', 'uoArvoreNivelModule', 'ConstantVfiltroModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'angularMoment', 'modalInfoConfirmModule']).constant('EntidadeMap', {
    'Veículos': 'vehicles',
    'Usuários': 'users',
    'Pontos de Referência': 'landmarks',
    'Motoristas': 'drivers',
    'Grupos de Veículo': 'vehicleGroups',
    'Serviços': 'services',
    'Departamentos de motorista': 'driverDepartments',
    'Passageiros': 'passengers',
    'Cercas Eletrônicas': 'geofences',
    'TODAS AS ENTIDADES': 'allEntities'
  }).constant('VehiclesMap', {
    'Veículos': 'vehicles',
    'Usuários': 'users',
    'Pontos de Referência': 'landmarks',
    'Motoristas': 'drivers',
    'Grupos de Veículo': 'vehicleGroups',
    'Serviços': 'services',
    'Departamentos de motorista': 'driverDepartments',
    'Passageiros': 'passengers',
    'Cercas Eletrônicas': 'geofences'
  });
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ConfirmDeleteModalCtrl = function () {
    function ConfirmDeleteModalCtrl($uibModalInstance, compartilhamento) {
      _classCallCheck(this, ConfirmDeleteModalCtrl);

      this.modalInstance = $uibModalInstance;
      this.compartilhamento = compartilhamento;
    }

    _createClass(ConfirmDeleteModalCtrl, [{
      key: 'confirmar',
      value: function confirmar() {
        this.modalInstance.close();
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss();
      }
    }]);

    return ConfirmDeleteModalCtrl;
  }();

  angular.module('compartilhamentos').controller('ConfirmDeleteModalCtrl', ConfirmDeleteModalCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name camadaValor
   * @description
   *
   */

  angular.module('camadaValor', ['ui.router', 'restangular', 'v3gAuthenticatorModule']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CamadaValorInformativoCtrl = function () {
    function CamadaValorInformativoCtrl($stateParams, Restangular, $window) {
      _classCallCheck(this, CamadaValorInformativoCtrl);

      this.restangular = Restangular;
      this.window = $window;

      this.link = '';
      this.buscaLink($stateParams.uo);
    }

    _createClass(CamadaValorInformativoCtrl, [{
      key: 'navegaLink',
      value: function navegaLink() {
        this.window.open(this.link, '_blank');
      }
    }, {
      key: 'navegaPlanoSolucoes',
      value: function navegaPlanoSolucoes() {
        var _this = this;

        this.restangular.one('/auth/app-info').getList().then(function (data) {
          var urlVfleets = data.find(function (tipo) {
            return tipo.id === 'core-conducaoeconomica';
          }).url;
          _this.window.open(urlVfleets + '/planos-solucoes', '_blank');
        });
      }
    }, {
      key: 'buscaLink',
      value: function buscaLink(uoId) {
        var _this2 = this;

        this.restangular.one('configuracao/configuracoes/' + uoId + '/link-portal').get().then(function (res) {
          _this2.link = res.linkPlanosPortal;
        });
      }
    }]);

    return CamadaValorInformativoCtrl;
  }();

  angular.module('camadaValor').controller('CamadaValorInformativoCtrl', CamadaValorInformativoCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CamadaValorHomeCtrl = function () {
    function CamadaValorHomeCtrl(Authenticator) {
      _classCallCheck(this, CamadaValorHomeCtrl);

      this.auth = Authenticator;
      this.init();
    }

    _createClass(CamadaValorHomeCtrl, [{
      key: 'init',
      value: function init() {
        this.auth.getUser().then(function (user) {
          /* eslint-disable */
          var elementContainer = document.querySelector('#camada-valor-home-element'),
              camadaValorHomeElement = document.createElement('pwc-camada-valor-home');
          /* eslint-enable */

          if (camadaValorHomeElement) {
            camadaValorHomeElement.userUoId = user.plain().uo.id;
            camadaValorHomeElement.hasUpdatePermission = user.plain().permissoes.includes('CAMADA_VALOR_EDITAR');
            elementContainer.appendChild(camadaValorHomeElement);
          }
        });
      }
    }]);

    return CamadaValorHomeCtrl;
  }();

  angular.module('camadaValor').controller('CamadaValorHomeCtrl', CamadaValorHomeCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CamadaValorCadastroCtrl = function () {
    function CamadaValorCadastroCtrl(Authenticator) {
      _classCallCheck(this, CamadaValorCadastroCtrl);

      this.auth = Authenticator;
      this.init();
    }

    _createClass(CamadaValorCadastroCtrl, [{
      key: 'init',
      value: function init() {
        this.auth.getUser().then(function (user) {
          /* eslint-disable */
          var elementContainer = document.querySelector('#camada-valor-stepper-cadastro'),
              stepperCadastro = document.createElement('pwc-camada-valor-stepper-cadastro');
          /* eslint-enable */

          if (stepperCadastro) {
            stepperCadastro.uoId = user.plain().uo.id;
            elementContainer.appendChild(stepperCadastro);
          }
        });
      }
    }]);

    return CamadaValorCadastroCtrl;
  }();
  /**
   * @ngdoc object
   * @name camadaValor.controller:CamadaValorCadastroCtrl
   *
   * @description
   *
   */

  angular.module('camadaValor').controller('CamadaValorCadastroCtrl', CamadaValorCadastroCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */

  angular.module('veiculos', ['ui.router', 'uoModule', 'uoArvoreNivelModule', 'ServiceVfiltroModule', 'FactoryVfiltroModule', 'restangular']);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var VeiculosDonoService = function () {
    function VeiculosDonoService(Restangular) {
      _classCallCheck(this, VeiculosDonoService);

      this.restangular = Restangular;
    }

    _createClass(VeiculosDonoService, [{
      key: 'getVeiculos',
      value: function getVeiculos(uoId) {
        return this.restangular.all('veiculo/veiculos/permitidos/uoDona/' + uoId).getList();
      }
    }, {
      key: 'mover',
      value: function mover(veiculoIds, uoId) {
        return this.restangular.all('veiculo/veiculos/permitidos/uoDona/' + uoId + '/list').post(veiculoIds);
      }
    }]);

    return VeiculosDonoService;
  }();

  angular.module('veiculos').service('VeiculosDonoService', VeiculosDonoService);
})();
'use strict';

(function () {
  'use strict';

  angular.module('veiculos').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.veiculos', {
      url: '/veiculos',
      views: {
        'content@': {
          templateUrl: 'veiculos/veiculos.tpl.html',
          controller: 'VeiculosCtrl',
          controllerAs: 'veiculosCtrl'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.transferenciaDeVeiculos.menuLabel',
        tituloDescricao: '',
        role: 'VEICULO_PERMISSAO_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var VeiculosCtrl = function () {
    function VeiculosCtrl($timeout, Uos, UoArvoreNivel, VeiculosDonoService, ServiceVfiltro, FactoryVfiltro, $translate) {
      var _this = this;

      _classCallCheck(this, VeiculosCtrl);

      this.timeout = $timeout;
      this.veiculos = [];
      this.selecionados = [];
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.selecao = {};
      this.veiculosService = VeiculosDonoService;
      this.uos = [];
      this.listFail = [];
      this.uosDaMesmaArvore = [];
      this.todasAsEntidades = false;
      this.limitOrigem = 10;
      this.limitDestino = 10;
      this.translate = $translate;

      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('VEICULO_PERMISSAO_EDITAR');
        _this.init(ServiceVfiltro.factoryVfiltro.user);
      });
    }

    _createClass(VeiculosCtrl, [{
      key: 'loadMoreOrigem',
      value: function loadMoreOrigem() {
        this.limitOrigem += 10;
      }
    }, {
      key: 'loadMoreDestino',
      value: function loadMoreDestino() {
        this.limitDestino += 10;
      }
    }, {
      key: 'init',
      value: function init(user) {
        this.user = user;
        this.carregarUos(this.user.uo.id);
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos() {
        var _this2 = this;

        this.uoService.getFilhas(this.user.uo.id).then(function (data) {
          return _this2.uos = _this2.uoArvoreNivel.converterEmLista(data.plain());
        });
      }
    }, {
      key: 'recarregarVeiculos',
      value: function recarregarVeiculos() {
        var _this3 = this;

        this.selecionados = [];
        this.veiculos = [];
        this.veiculosService.getVeiculos(this.selecao.origem.id).then(function (data) {
          return _this3.veiculos = data.plain();
        });
      }
    }, {
      key: 'carregarVeiculos',
      value: function carregarVeiculos() {
        var _this4 = this;

        var service = this.uoService.getArvoreDaUo(this.selecao.origem.id);
        this.uosDaMesmaArvore = [];
        this.selecao.destino = null;
        this.todasAsEntidades = false;
        service.then(function (data) {
          return _this4.uosDaMesmaArvore = _this4.uoArvoreNivel.converterEmLista(data.plain());
        });
        this.recarregarVeiculos();
      }
    }, {
      key: 'todosVeiculos',
      value: function todosVeiculos() {
        if (this.todasAsEntidades) {
          this.selecionados = this.veiculos;
        } else {
          this.limparSelecao();
        }
      }
    }, {
      key: 'limparSelecao',
      value: function limparSelecao() {
        this.selecionados = [];
        this.todasAsEntidades = false;
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this5 = this;

        this.veiculosService.mover(this.selecionados.map(function (veiculo) {
          return veiculo.id;
        }), this.selecao.destino.id).then(function (response) {
          var erro = false;
          response.forEach(function (item) {
            var idVeiculo = Number(Object.keys(item)[0]);
            if (item[idVeiculo] === false) {
              erro = true;
            }
          });

          if (!erro) {
            _this5.alert = {
              display: true,
              alertClass: 'alert-success',
              alertMessage: _this5.translate.instant('core-permissoes.organizacao.transferenciaDeVeiculos.alertMessages.success')
            };
          } else {
            _this5.alert = {
              display: true,
              alertClass: 'alert-danger',
              alertMessage: _this5.translate.instant('core-permissoes.organizacao.transferenciaDeVeiculos.alertMessages.cannotBeTransferred')
            };
          }
          _this5.recarregarVeiculos();
        }, function () {
          _this5.recarregarVeiculos();
          _this5.alert = {
            display: true,
            alertClass: 'alert-warning',
            alertMessage: _this5.translate.instant('core-permissoes.organizacao.transferenciaDeVeiculos.alertMessages.defaultError')
          };
        });
      }
    }, {
      key: 'setItens',
      value: function setItens(e) {
        var _this6 = this;

        this.timeout(function () {
          var valueInput = angular.copy(e.search);
          _.uniq(_this6.buildItens(valueInput)).forEach(function (item) {
            e.select(item);
          });
          e.search = '';
        }, 100);
      }
    }, {
      key: 'buildItens',
      value: function buildItens(valueInput) {
        var _this7 = this;

        var regex = /(,|;)/;
        return valueInput.split(regex).filter(function (e) {
          return !regex.exec(e);
        }).filter(function (e) {
          return !!e;
        }).map(function (i) {
          var item = _this7.buildSearch(i),
              search = _this7.veiculos.find(function (x) {
            return _this7.buildSearch(x.prefixo + ' - ' + x.placa).includes(item);
          }),
              repetido = !_this7.selecionados.some(function (x) {
            return _this7.buildSearch(x.prefixo + ' - ' + x.placa).includes(item);
          });
          if (search && repetido) {
            return search;
          }
          if (!_this7.listFail.some(function (x) {
            return _this7.buildSearch(x).includes(item);
          }) && repetido) {
            _this7.listFail.push(i);
          }
          return null;
        }).filter(function (e) {
          return !!e;
        });
      }
    }, {
      key: 'buildSearch',
      value: function buildSearch(item) {
        return item.replace(/(\s|-)/g, '').toLowerCase();
      }
    }, {
      key: 'removeInvalidItem',
      value: function removeInvalidItem(index) {
        this.listFail = this.listFail.filter(function (item, i) {
          return i !== index;
        });
      }
    }]);

    return VeiculosCtrl;
  }();

  /**
   * @ngdoc object
   * @name veiculos.controller:VeiculosCtrl
   *
   * @description
   *
   */


  angular.module('veiculos').controller('VeiculosCtrl', VeiculosCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('vUuidMaskModule', []).directive('vuuidmask', function () {
    return {
      require: 'ngModel',
      link: function link(scope, element, attrs, ngModel) {
        element.attr('maxlength', 36);

        function formatUuid(value) {
          if (!value) return value;
          // Remove any non-hexadecimal characters (including dashes)
          var cleanedValue = value.replace(/[^0-9a-fA-F]/g, '').toLowerCase();

          if (cleanedValue.length > 8) {
            cleanedValue = cleanedValue.slice(0, 8) + '-' + cleanedValue.slice(8);
          }
          if (cleanedValue.length > 13) {
            cleanedValue = cleanedValue.slice(0, 13) + '-' + cleanedValue.slice(13);
          }
          if (cleanedValue.length > 18) {
            cleanedValue = cleanedValue.slice(0, 18) + '-' + cleanedValue.slice(18);
          }
          if (cleanedValue.length > 23) {
            cleanedValue = cleanedValue.slice(0, 23) + '-' + cleanedValue.slice(23);
          }

          return cleanedValue;
        }

        function validateUuid(value) {
          if (!value) {
            ngModel.$setValidity('uuid', true);
            return value;
          }
          var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
              valid = UUID_REGEX.test(value);
          ngModel.$setValidity('uuid', valid);
          return valid ? value : undefined;
        }

        ngModel.$parsers.push(function (value) {
          var formattedValue = formatUuid(value);
          ngModel.$setViewValue(formattedValue);
          ngModel.$render();
          return validateUuid(formattedValue);
        });

        ngModel.$formatters.push(function (value) {
          return formatUuid(value);
        });

        element.on('blur keyup change', function () {
          var formattedValue = formatUuid(element.val());
          ngModel.$setViewValue(formattedValue);
          ngModel.$render();
          scope.$apply();
        });
      }
    };
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('uppercased', []).directive('uppercased', function () {
    return {
      require: 'ngModel',
      link: function link(scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (input) {
          return input ? input.toUpperCase() : '';
        });
        element.css('text-transform', 'uppercase');
      }
    };
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('usuarios').service('UsuariosService', function (Restangular) {
    return Restangular.service('auth/usuarios');
  }).service('UsuariosServiceV2', function (Restangular) {
    return Restangular.service('auth/v2/usuarios');
  }).service('PaisService', function (Restangular) {
    return Restangular.service('auth/paises');
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('usuarios').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.usuarios', {
      url: '/usuarios?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'usuarios/usuarios.tpl.html',
          controller: 'UsuariosCtrl',
          controllerAs: 'usuarios'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.usuarios.title',
        role: 'USUARIO_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var UsuariosCtrl = function () {
    function UsuariosCtrl(UsuariosServiceV2, Uos, Flash, $uibModal, UoArvoreNivel, Keys, ServiceVfiltro, FactoryVfiltro, PerfilAdminVeltec, PerfilIntegracao, AlertMessage, VtabelaFactory, IdiomasEnum, MeasurementSystemEnum, RolesEnum, $translate, Authenticator, Restangular, FeaturehubJsSdk, FeatureHubConfigKeys) {
      var _this = this;

      _classCallCheck(this, UsuariosCtrl);

      this.usuariosServiceV2 = UsuariosServiceV2;
      this.uoService = Uos;
      this.restangular = Restangular;
      this.idiomasEnum = IdiomasEnum;
      this.measurementSystemEnum = MeasurementSystemEnum;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.rolesEnum = RolesEnum;
      this.uoArvoreNivel = UoArvoreNivel;
      this.flash = Flash;
      this.modalService = $uibModal;
      this.perfilAdminVeltec = PerfilAdminVeltec;
      this.vtabelaFactory = VtabelaFactory;
      this.perfilIntegracao = PerfilIntegracao;
      this.alertMessage = AlertMessage;
      this.roleCadastrar = false;
      this.uoArvore = [];
      this.PERFIL_VDRIVERS = 4;
      this.FIELDS_USUARIO = ['id', 'login', 'uoId', 'perfil.id', 'perfil.nome', 'uo.nome', 'ultimoAcesso', 'cargo', 'nome', 'lastName', 'pais', 'pais.code', 'pais.nome', 'telefone', 'paisTelefone.ddi', 'paisTelefone.nome', 'paisTelefone.code', 'ddd', 'pais', 'ddi', 'idioma', 'measurementSystem', 'isResponsavelPassiveis', 'acessoTrocaUo', 'email'];
      this.whiteList = ['veltec.com.br', 'trimble.com', 'grparceria.com.br', 'platformscience.com'];
      this.SUPPORT = 1800;
      this.translate = $translate;

      this.authenticator = Authenticator;
      this.authenticator.getUser().then(function (user) {
        _this.dateTimeFormat = user.measurementUnits.dateTimeFormat === 'BRITISH' ? 'dd/MM/yyyy HH:mm:ss' : 'MM/dd/yyyy HH:mm:ss';
      });

      this.vtabela = null;
      this.isNaOu = false;
      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: Keys.uo.name
      }])).then(function (filtro) {
        _this.uoId = filtro.find(function (x) {
          return x.key === Keys.uo.name;
        }).value.id;
        _this.user = ServiceVfiltro.factoryVfiltro.user;
        _this.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('USUARIO_EDITAR');
        _this.loadNaFeature(_this.uoId).then(function () {
          _this.vtabela = _this.vtabelaFactory.get(_this.initVtabela(), ServiceVfiltro.factoryVfiltro.user, 'usuarios', _this.getTableVersion());
          _this.carregarArvoreUoUsuario();
          _this.carregarUsuarios();
        });
      });
    }

    _createClass(UsuariosCtrl, [{
      key: 'loadNaFeature',
      value: function loadNaFeature(uoId) {
        var _this2 = this;

        return this.restangular.one('configuracao/configuracoes/' + uoId + '/feature-ou').get().then(function (featureOu) {
          return _this2.isNaOu = featureOu.plain().vi20ProductName === true;
        }).catch(function () {
          return _this2.isNaOu = false;
        });
      }
    }, {
      key: 'getTableVersion',
      value: function getTableVersion() {
        return this.isNaOu ? 'v2-na' : 'v2';
      }
    }, {
      key: 'initVtabela',
      value: function initVtabela() {
        var objVtabela = {
          appScopeProvider: this,
          enableRowSelection: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          exportsCsv: false,
          enableSelectAll: false,
          showColumnFooter: false,
          isRowSelectable: function isRowSelectable() {
            return false;
          },
          columnDefs: [{
            name: 'uo',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.ou'),
            type: 'string',
            pinnedLeft: true,
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'email',
            displayName: 'E-mail',
            pinnedLeft: true,
            type: 'string',
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'nome',
            displayName: this.translate.instant(this.isNaOu ? 'core-permissoes.organizacao.usuarios.firstName' : 'core-permissoes.organizacao.usuarios.name'),
            pinnedLeft: true,
            type: 'string',
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'perfil',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.role'),
            type: 'string',
            enableHiding: false,
            filterCellFiltered: true
          }, {
            name: 'pais',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.country'),
            type: 'string',
            filterCellFiltered: true
          }, {
            name: 'languageLabel',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.language'),
            type: 'string',
            filterCellFiltered: true
          }, {
            name: 'measurementSystem',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.popup.measurementSystem'),
            type: 'string',
            filterCellFiltered: true
          }, {
            name: 'telefone',
            type: 'string',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.phone'),
            filterCellFiltered: true
          }, {
            name: 'cargo',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.position'),
            type: 'string',
            filterCellFiltered: true
          }, {
            name: 'manutencao',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.maintenance'),
            type: 'string',
            filterCellFiltered: true
          }, {
            name: 'ultimoLogin',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.lastLogin'),
            type: 'date',
            cellFilter: 'date:\'' + this.dateTimeFormat + '\'',
            cellClass: 'text-center',
            filterCellFiltered: true
          }, {
            name: 'acoes',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.actions'),
            pinnedRight: true,
            enableSorting: false,
            enableHiding: false,
            enableFiltering: false,
            enableColumnResizing: false,
            visible: this.roleCadastrar,
            width: 100,
            cellTemplate: '\n                  <div class=\'ui-grid-cell-contents text-center\'>\n                    <button class="btn btn-info btn-xs" ng-click="grid.appScope.editarUsuario(row.entity.usuario)" ng-if="grid.appScope.allowEdit(row.entity.usuario)">\n                      <i class="fa fa-pencil"></i>\n                    </button>\n                    <button class="btn btn-danger btn-xs" ng-click="grid.appScope.excluirUsuario(row.entity.usuario)" ng-if="grid.appScope.allowEdit(row.entity.usuario)">\n                      <i class="fa fa-remove"></i>\n                    </button>\n                  </div>\n                '
          }]
        };
        if (this.isNaOu) {
          var indexNome = objVtabela.columnDefs.findIndex(function (column) {
            return column.name === 'nome';
          });
          objVtabela.columnDefs.splice(indexNome + 1, 0, {
            name: 'lastName',
            displayName: this.translate.instant('core-permissoes.organizacao.usuarios.lastName'),
            pinnedLeft: true,
            type: 'string',
            enableHiding: false,
            filterCellFiltered: true
          });
        }
        if (!this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.MEASUREMENT_SYSTEM)) {
          objVtabela.columnDefs = objVtabela.columnDefs.filter(function (column) {
            return column.name !== 'measurementSystem';
          });
        }
        return objVtabela;
      }
    }, {
      key: 'getItemVtabela',
      value: function getItemVtabela(item) {
        return {
          usuario: item,
          uo: item.uo.nome,
          email: item.login,
          nome: item.nome,
          lastName: item.lastName,
          perfil: this.getPerfil(item),
          pais: item.pais ? item.pais.nome : null,
          telefone: this.getTelefone(item),
          cargo: item.cargo,
          languageLabel: item.languageLabel,
          measurementSystem: this.getMeasurementSystem(item),
          manutencao: this.getIsReponsavelPassiveis(item.isResponsavelPassiveis),
          ultimoLogin: item.ultimoAcesso
        };
      }
    }, {
      key: 'getPerfil',
      value: function getPerfil(item) {
        if (item.perfil) {
          return this.rolesEnum.getDescricaoByDescricaoDB(item.perfil.nome) ? this.translate.instant(this.rolesEnum.getDescricaoByDescricaoDB(item.perfil.nome)) : item.perfil.nome;
        }
        return null;
      }
    }, {
      key: 'getMeasurementSystem',
      value: function getMeasurementSystem(user) {
        var key = user.measurementSystem || this.measurementSystemEnum.getDefaultKeyForLanguage(user.idioma);
        return this.translate.instant(this.measurementSystemEnum.getSystemByKey(key).label);
      }
    }, {
      key: 'getTelefone',
      value: function getTelefone(usuario) {
        if (usuario.telefone) {
          var ddi = usuario.paisTelefone ? '+' + usuario.paisTelefone.ddi : '';
          return '' + ddi + usuario.ddd + usuario.telefone;
        }
        return null;
      }
    }, {
      key: 'getIsReponsavelPassiveis',
      value: function getIsReponsavelPassiveis(isResponsavelPassiveis) {
        if (angular.isDefined(isResponsavelPassiveis)) {
          return this.translate.instant(isResponsavelPassiveis ? 'core-permissoes.organizacao.usuarios.yes' : 'core-permissoes.organizacao.usuarios.no');
        }
        return isResponsavelPassiveis;
      }
    }, {
      key: 'setInfoTable',
      value: function setInfoTable(data) {
        var _this3 = this;

        this.vtabela.setData(data.map(function (i) {
          return _this3.getItemVtabela(i);
        }));
      }
    }, {
      key: 'carregarArvoreUoUsuario',
      value: function carregarArvoreUoUsuario() {
        var _this4 = this;

        this.uoService.getFilhas(this.user.uoId).then(function (data) {
          return _this4.uoArvore = _this4.uoArvoreNivel.converterEmLista(data.plain());
        });
      }
    }, {
      key: 'carregarUsuarios',
      value: function carregarUsuarios() {
        var _this5 = this;

        var params = {
          uoPermissao: this.uoId,
          excludePerfilIds: this.PERFIL_VDRIVERS,
          fields: this.FIELDS_USUARIO,
          includeWithoutProfiles: true
        };
        this.usuariosServiceV2.getList(params).then(function (users) {
          _this5.usuarios = users.filter(function (usuario) {
            return _this5.user.perfil.id === _this5.perfilAdminVeltec || usuario.perfil === null || angular.isUndefined(usuario.perfil) || usuario.perfil.id !== _this5.perfilIntegracao;
          });
          _this5.usuarios.forEach(function (usuario) {
            return usuario.languageLabel = _this5.idiomasEnum.getIdiomaByKey(usuario.idioma).value;
          });
          _this5.setInfoTable(_this5.usuarios);
        }).catch(function () {
          return _this5.vtabela.setError();
        });
      }
    }, {
      key: 'editarUsuario',
      value: function editarUsuario(_usuario) {
        var _this6 = this;

        return this.modalService.open({
          templateUrl: 'usuarios/editar/editar-usuario.tpl.html',
          controller: 'EditarUsuarioCtrl',
          controllerAs: 'editarUsuario',
          size: 'md',
          resolve: {
            usuario: function usuario() {
              return _usuario;
            },
            uoArvore: function uoArvore() {
              return _this6.uoArvore;
            },
            isNaOu: function isNaOu() {
              return _this6.isNaOu;
            }
          }
        }).result.then(function () {
          return _this6.carregarUsuarios();
        });
      }
    }, {
      key: 'allowEdit',
      value: function allowEdit(usuarioDaLista) {
        var userWithPermissionToEdit = this.whiteList.includes(this.user.login.split('@')[1]);
        if (this.user.perfil.id === this.perfilAdminVeltec || userWithPermissionToEdit) {
          return true;
        }
        if (this.user.perfil.id === this.SUPPORT) {
          return usuarioDaLista.perfil === null || angular.isUndefined(usuarioDaLista.perfil) || usuarioDaLista.perfil && usuarioDaLista.perfil.id !== this.perfilAdminVeltec;
        }
        return usuarioDaLista.perfil === null || angular.isUndefined(usuarioDaLista.perfil) || usuarioDaLista.perfil.id !== this.perfilAdminVeltec && usuarioDaLista.perfil.id !== this.SUPPORT;
      }
    }, {
      key: 'excluirUsuario',
      value: function excluirUsuario(_usuario2) {
        var _this7 = this;

        return this.modalService.open({
          templateUrl: 'usuarios/excluir-usuario.tpl.html',
          controller: 'ExcluirUsuarioCtrl',
          controllerAs: 'excluirUsuario',
          size: 'sm',
          resolve: {
            usuario: function usuario() {
              return _usuario2;
            }
          }
        }).result.then(function () {
          return _this7.carregarUsuarios();
        });
      }
    }, {
      key: 'cadastrarUsuario',
      value: function cadastrarUsuario() {
        var _this8 = this;

        return this.modalService.open({
          templateUrl: 'usuarios/cadastrar/cadastrar-usuario.tpl.html',
          controller: 'CadastrarUsuarioCtrl',
          controllerAs: 'cadastrarUsuario',
          size: 'md',
          resolve: {
            uoSelecionada: function uoSelecionada() {
              return _this8.uoId;
            },
            uoArvore: function uoArvore() {
              return _this8.uoArvore;
            },
            uoArvoreNivel: function uoArvoreNivel() {
              return _this8.uoArvoreNivel;
            },
            isNaOu: function isNaOu() {
              return _this8.isNaOu;
            }
          }
        }).result.then(function (resp) {
          _this8.alertMessage.create({ type: 'success', message: resp, appendTo: '.alerta-aqui' });
          _this8.carregarUsuarios();
        });
      }
    }]);

    return UsuariosCtrl;
  }();

  var ExcluirUsuarioCtrl = function () {
    function ExcluirUsuarioCtrl(usuario, $uibModalInstance, Flash, UsuariosService, AlertMessage, $translate) {
      _classCallCheck(this, ExcluirUsuarioCtrl);

      this.usuario = usuario;
      this.alertMessage = AlertMessage;
      this.modalInstance = $uibModalInstance;
      this.flash = Flash;
      this.usuariosService = UsuariosService;
      this.translate = $translate;
    }

    _createClass(ExcluirUsuarioCtrl, [{
      key: 'ok',
      value: function ok() {
        var _this9 = this;

        this.usuariosService.one(this.usuario.id).remove().then(function () {
          _this9.modalInstance.close();
          _this9.alertMessage.create({
            type: 'success',
            message: _this9.translate.instant('core-permissoes.organizacao.usuarios.deletion.successMessage'),
            appendTo: '.alerta-aqui'
          });
        }, function (data) {
          return _this9.flash.create('error', data.data.message);
        });
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        this.modalInstance.dismiss('cancel');
      }
    }]);

    return ExcluirUsuarioCtrl;
  }();

  angular.module('usuarios').controller('UsuariosCtrl', UsuariosCtrl).controller('ExcluirUsuarioCtrl', ExcluirUsuarioCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('uos').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.uos', {
      url: '/uos',
      views: {
        'content@': {
          templateUrl: 'uos/uos.tpl.html',
          controller: 'UosCtrl',
          controllerAs: 'uos'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.uos.titulo',
        tituloDescricao: 'core-permissoes.organizacao.uos.tituloDescricaoConsulta'
      }
    }).state('root.uoCadastro', {
      url: '/uos/cadastro/:uoId/:uoPai',
      views: {
        'content@': {
          templateUrl: 'uos/cadastrar-uo.tpl.html',
          controller: 'CadastrarUoCtrl',
          controllerAs: 'cadastrarUoCtrl'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.uos.titulo',
        tituloDescricao: 'core-permissoes.organizacao.uos.tituloDescricaoCadastro',
        role: 'UO_EDITAR'
      }
    }).state('root.parceira', {
      url: '/uos/parceira/:uoId',
      views: {
        'content@': {
          templateUrl: 'uos/parceira.tpl.html',
          controller: 'ParceiraCtrl',
          controllerAs: 'parceiraCtrl'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.uos.parceiraTitulo',
        role: 'ADMIN_VELTEC'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var UosCtrl = function () {
    function UosCtrl($q, Restangular, Uos, AlertMessage, ServiceVfiltro, FactoryVfiltro, $translate) {
      var _this = this;

      _classCallCheck(this, UosCtrl);

      this.q = $q;
      this.restangular = Restangular;
      this.uoService = Uos;
      this.alertMessage = AlertMessage;
      this.veiculos = {};
      this.translate = $translate;

      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.roleVisualizar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('UO_VISUALIZAR');
        _this.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('UO_EDITAR');
        _this.roleAdminVeltec = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('ADMIN_VELTEC');
        _this.carregarUos();
      });
      this.limit = 20;
      this.pai = -1;
    }

    _createClass(UosCtrl, [{
      key: 'loadMore',
      value: function loadMore() {
        this.limit += 20;
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos() {
        var _this2 = this;

        if (this.roleVisualizar) {
          this.q.all([this.uoService.getFilhas(), this.restangular.one('/veiculo/contagem-veiculos/uos').get()]).then(function (data) {
            _this2.uos = _this2.converterEmLista(data[0]);
            _this2.pai = _this2.uos[0].id;
            _this2.veiculos = data[1];
          });
        } else {
          this.alertMessage.create({
            type: 'error',
            timeout: 60000,
            message: 'Você não possui permissão para este recurso do sistema!',
            appendTo: '.alerta-aqui'
          });
        }
      }
    }, {
      key: 'toggleFilhas',
      value: function toggleFilhas(uo) {
        uo.open = !uo.open;
        this.uos.forEach(function (item) {
          if (item.pais.indexOf(uo.id) >= 0) {
            item.show = uo.open;
          }
        });
      }
    }, {
      key: 'converterEmLista',
      value: function converterEmLista(uoArvore) {
        var uoLista = [];
        uoLista.push({
          id: uoArvore.id,
          nome: uoArvore.nome,
          arvoreNivel: 0,
          idSav: uoArvore.id_sav,
          parceiras: uoArvore.uosParceiras && uoArvore.uosParceiras.length || 0,
          temFilhas: angular.isDefined(uoArvore.uosfilhas) && uoArvore.uosfilhas.length > 0,
          open: angular.isDefined(uoArvore.uosfilhas) && uoArvore.uosfilhas.length > 0,
          pais: [],
          show: true
        });
        if (angular.isDefined(uoArvore.uosfilhas)) {
          uoLista = uoLista.concat(this.getFilhas(uoArvore, [], 1));
        }
        return uoLista;
      }
    }, {
      key: 'getFilhas',
      value: function getFilhas(uoArvore, pais, arvoreNivel) {
        var _this3 = this;

        var parents = pais.concat([uoArvore.id]);
        return [].concat.apply([], uoArvore.uosfilhas.sort(this.sortByName).map(function (u) {
          var filhasLista = [];
          filhasLista.push({
            id: u.id,
            nome: u.nome,
            arvoreNivel: arvoreNivel,
            idSav: u.id_sav,
            parceiras: u.uosParceiras && u.uosParceiras.length || 0,
            temFilhas: angular.isDefined(u.uosfilhas) && u.uosfilhas.length > 0,
            open: angular.isDefined(u.uosfilhas) && u.uosfilhas.length > 0,
            pais: parents,
            show: true
          });
          if (angular.isDefined(u.uosfilhas) && u.uosfilhas.length > 0) {
            filhasLista = filhasLista.concat(_this3.getFilhas(u, parents, arvoreNivel + 1));
          }
          return filhasLista;
        }));
      }
    }, {
      key: 'sortByName',
      value: function sortByName(uo1, uo2) {
        if (uo1.nome < uo2.nome) {
          return -1;
        }
        if (uo1.nome > uo2.nome) {
          return 1;
        }
        return 0;
      }
    }]);

    return UosCtrl;
  }();

  /**
   * @ngdoc object
   * @name uos.controller:UosCtrl
   *
   * @description
   *
   */


  angular.module('uos').controller('UosCtrl', UosCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('uos').factory('UoParceira', UoParceiraService);

  function UoParceiraService(Restangular) {
    return Restangular.service('/auth/uo-parceira');
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ParceiraCtrl = function () {
    function ParceiraCtrl($scope, $location, $stateParams, Uos, UoArvoreNivel, UoParceira, AlertMessage) {
      _classCallCheck(this, ParceiraCtrl);

      this.scope = $scope;
      this.location = $location;
      this.stateParams = $stateParams;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.uoParceiraService = UoParceira;
      this.alertMessage = AlertMessage;
      this.uos = [];
      this.carregarUos();
      this.limitUo = 10;
      this.limitParceira = 10;
    }

    _createClass(ParceiraCtrl, [{
      key: 'loadMoreUos',
      value: function loadMoreUos() {
        this.limitUo += 10;
      }
    }, {
      key: 'loadMoreParceiras',
      value: function loadMoreParceiras() {
        this.limitParceira += 10;
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos() {
        var _this = this;

        this.uoService.getFilhas().then(function (data) {
          _this.uos = _this.uoArvoreNivel.converterEmLista(data.plain());
          _this.selecionarUo();
        });
      }
    }, {
      key: 'selecionarUo',
      value: function selecionarUo() {
        var _this2 = this;

        if (this.stateParams.uoId > 0) {
          angular.forEach(this.uos, function (uo) {
            if (uo.id.toString() === _this2.stateParams.uoId) {
              _this2.parceira.uo = uo;
            }
          });
        }
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this3 = this;

        this.scope.cadastroForm.submitted = true;

        if (this.scope.cadastroForm.$valid) {
          this.uoParceiraService.post(this.parceira).then(function () {
            _this3.alertMessage.create({
              type: 'success',
              message: 'Parceiro salvo com sucesso.',
              appendTo: '.alerta-aqui'
            });
            _this3.location.path('/uos');
          }).catch(function (error) {
            _this3.alertMessage.create({
              type: 'error',
              message: error.data.erro,
              appendTo: '.alerta-aqui'
            });
          });
        }
      }
    }]);

    return ParceiraCtrl;
  }();

  /**
   * @ngdoc object
   * @name uos.controller:ParceiraCtrl
   *
   * @description
   *
   */


  angular.module('uos').controller('ParceiraCtrl', ParceiraCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var CadastrarUoCtrl = function () {
    function CadastrarUoCtrl($location, $stateParams, Uos, UoParceira, UoArvoreNivel, AlertMessage, Authenticator, SegmentosEnum, Restangular, $uibModal, $translate) {
      var _this = this;

      _classCallCheck(this, CadastrarUoCtrl);

      this.location = $location;
      this.stateParams = $stateParams;
      this.uoService = Uos;
      this.uoParceiraService = UoParceira;
      this.uoArvoreNivel = UoArvoreNivel;
      this.alertMessage = AlertMessage;
      this.segmentosEnum = SegmentosEnum;
      this.modalService = $uibModal;
      this.uos = [];
      this.uoBloqueioWrapper = {};
      this.uoPai = false;
      this.usuario = {};
      this.uoPaiSetado = this.stateParams.uoPai;
      this.limit = 10;
      this.podeEditarSegmento = false;
      this.isSegmentRequired = true;
      this.uoPaiChanged = false;
      this.EMAIL_REGEX = /^[a-zA-Z0-9\+\.\_\%\-\+]{1,256}\@[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9\-]{1,25})+$/;
      this.PSVI_SUBDOMAIN_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
      this.PSVI_DEFAULT_SUBDOMAIN = 'psvi';
      this.restangular = Restangular;
      this.translate = $translate;
      this.allowedEmailList = ['trimble.com', 'platformscience.com', 'grparceria.com.br', 'geoagri.com.br'];
      this.segmentosTraduzidos = [];
      this.segmentoSelecionado = null;
      Authenticator.getUser().then(function (user) {
        _this.user = user;
        if (_this.user.login) {
          _this.allowCreateOu = _this.allowedEmailList.includes(_this.user.login.split('@')[1]) && Authenticator.hasRole('UO_EDITAR');
        } else {
          _this.allowCreateOu = false;
        }
        _this.enableNaFeatures = Authenticator.hasRole('ADMIN_VELTEC');
        _this.init();
      });
    }

    _createClass(CadastrarUoCtrl, [{
      key: 'loadMore',
      value: function loadMore() {
        this.limit += 10;
      }
    }, {
      key: 'init',
      value: function init() {
        var _this2 = this;

        this.traduzirSegmentos();

        if (this.stateParams.uoId > 0) {
          this.uoService.getComDadosDeBloqueio(this.stateParams.uoId).then(function (uoBloqueioWrapper) {
            _this2.uoBloqueioWrapper = uoBloqueioWrapper;
            _this2.segmentoSelecionado = _this2.segmentosEnum.getSegmentoByKey(uoBloqueioWrapper.uo.segmento);
            if (_this2.segmentoSelecionado) {
              _this2.segmentoSelecionado.value = _this2.translate.instant(_this2.segmentoSelecionado.value);
            }
            _this2.orionDeploymentId = uoBloqueioWrapper.uo.orionDeploymentId;
            _this2.auth0OrgId = uoBloqueioWrapper.uo.auth0OrgId;
            _this2.podeEditarSegmento = _this2.allowCreateOu && angular.isUndefined(uoBloqueioWrapper.uo.id_sav);
            _this2.isSegmentRequired = angular.isUndefined(uoBloqueioWrapper.uo.id_sav);
            _this2.uoPaiIdInitialValue = _this2.uoBloqueioWrapper.uo.uoPai.id;
            _this2.uoBloqueada = angular.isDefined(uoBloqueioWrapper.uoBloqueio);
            _this2.vehicleRegistration = uoBloqueioWrapper.ouFeatureConfig && uoBloqueioWrapper.ouFeatureConfig.vehicleRegistration;
            _this2.psviOrionSubdomain = uoBloqueioWrapper.ouFeatureConfig && uoBloqueioWrapper.ouFeatureConfig.psviOrionSubdomain;
            _this2.storedSubdomain = _this2.psviOrionSubdomain;
            _this2.loadParentSubdomain(uoBloqueioWrapper.uo);
            _this2.mensagemBloqueio = _this2.uoBloqueada ? uoBloqueioWrapper.uoBloqueio.mensagem : '';
            _this2.loadUos();
          });
        } else {
          this.podeEditarSegmento = this.allowCreateOu;
          this.loadUos();
        }
      }
    }, {
      key: 'traduzirSegmentos',
      value: function traduzirSegmentos() {
        var _this3 = this;

        this.segmentosTraduzidos = this.segmentosEnum.getAllSegmentos().map(function (segmento) {
          return {
            key: segmento.key,
            value: _this3.translate.instant(segmento.value)
          };
        });
      }
    }, {
      key: 'loadUos',
      value: function loadUos() {
        var _this4 = this;

        this.uoService.getFilhas().then(function (data) {
          _this4.uos = _this4.uoArvoreNivel.converterEmListaSemFilhas(data.plain(), _this4.stateParams.uoId);
          if (_this4.stateParams.uoId > 0) {
            _.each(_this4.uos, function (uo) {
              if (uo.id === _this4.uoBloqueioWrapper.uo.uoPai.id) {
                _this4.uoBloqueioWrapper.uo.uoPai = uo;
              }
            });
          }
        });
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this5 = this;

        if (this.isCadastro()) {
          var uoCadastro = {
            id: 0,
            nome: this.uoBloqueioWrapper.uo.nome,
            uoPaiId: angular.isDefined(this.uoBloqueioWrapper.uo.uoPai) ? this.uoBloqueioWrapper.uo.uoPai.id : null,
            site: this.uoBloqueioWrapper.uo.site,
            segmento: this.getSegmento(this.segmentoSelecionado),
            customerAccountUuid: this.uoBloqueioWrapper.uo.customerAccountUuid,
            ativo: true
          };
          this.uoService.cadastrar(uoCadastro).then(this.showSucces.bind(this), this.showError.bind(this));
        } else if (this.uoPaiChanged) {
          /* eslint-disable */
          var dialogAvisoMovimentarUO = document.createElement('pwc-aviso-movimentar-uo'),
              bodyElement = document.querySelector('body');
          bodyElement.appendChild(dialogAvisoMovimentarUO);
          dialogAvisoMovimentarUO.addEventListener('onConfirmacaoMovimentarUO', function () {
            return _this5.atualizarUo();
          });
          /* eslint-enable */
        } else {
          this.atualizarUo();
        }
      }
    }, {
      key: 'atualizarUo',
      value: function atualizarUo() {
        this.uoBloqueioWrapper.uoBloqueio = this.getUoBloqueio();
        this.uoBloqueioWrapper.uo.segmento = this.getSegmento(this.segmentoSelecionado);
        this.uoBloqueioWrapper.uo.ativo = !this.uoBloqueada;
        this.uoBloqueioWrapper.uo.orionDeploymentId = this.orionDeploymentId;
        this.uoBloqueioWrapper.uo.auth0OrgId = this.auth0OrgId;
        this.uoBloqueioWrapper.ouFeatureConfig = this.getOuFeatureConfig();
        this.uoBloqueioWrapper.put().then(this.showSucces.bind(this), this.showError.bind(this));
      }
    }, {
      key: 'getSegmento',
      value: function getSegmento(segmento) {
        return segmento ? segmento.key : 'NAO_MAPEADO';
      }
    }, {
      key: 'getOuFeatureConfig',
      value: function getOuFeatureConfig() {
        return {
          ouId: this.uoBloqueioWrapper.uo.id,
          vehicleRegistration: this.vehicleRegistration,
          vehicleTable: this.vehicleRegistration,
          decoratedVideoPlayer: this.vehicleRegistration,
          deviceScreen: this.vehicleRegistration,
          alertSettings: this.vehicleRegistration,
          events: this.vehicleRegistration,
          trimbleLogo: this.vehicleRegistration,
          lastVisitedPageReload: this.vehicleRegistration,
          vi20ProductName: this.vehicleRegistration,
          psviOrionSubdomain: this.buildPsviOrionSubdomain()
        };
      }
    }, {
      key: 'buildPsviOrionSubdomain',
      value: function buildPsviOrionSubdomain() {
        if (!this.vehicleRegistration) {
          return null;
        }
        if (this.subdomainFromParent) {
          return this.psviOrionSubdomain || null;
        }
        if (this.orionDeploymentId && this.psviOrionSubdomain) {
          return this.psviOrionSubdomain;
        }
        return this.PSVI_DEFAULT_SUBDOMAIN;
      }
    }, {
      key: 'onOrionDeploymentIdChange',
      value: function onOrionDeploymentIdChange() {
        if (this.subdomainFromParent) {
          return;
        }
        this.hideSubdomainField = !this.orionDeploymentId;
      }
    }, {
      key: 'loadParentSubdomain',
      value: function loadParentSubdomain(uo) {
        var parentId = uo.uoPai && uo.uoPai.id,
            childSubdomain = this.storedSubdomain;
        if (!parentId || parentId === 1) {
          this.subdomainFromParent = false;
          this.subdomainAlreadyApplied = false;
          this.hideSubdomainField = !this.orionDeploymentId;
          if (this.orionDeploymentId && !this.psviOrionSubdomain) {
            this.psviOrionSubdomain = this.PSVI_DEFAULT_SUBDOMAIN;
          }
          return;
        }
        this.subdomainFromParent = true;
        this.hideSubdomainField = true;
        this.subdomainAlreadyApplied = false;
        this.resolveRootSubdomain(parentId, childSubdomain);
      }
    }, {
      key: 'resolveRootSubdomain',
      value: function resolveRootSubdomain(ancestorId, childSubdomain) {
        var _this6 = this;

        this.uoService.getComDadosDeBloqueio(ancestorId).then(function (wrapper) {
          var grandParentId = wrapper.uo && wrapper.uo.uoPai && wrapper.uo.uoPai.id;
          if (grandParentId && grandParentId !== 1 && grandParentId !== ancestorId) {
            _this6.resolveRootSubdomain(grandParentId, childSubdomain);
            return;
          }
          _this6.applyRootSubdomain(wrapper, childSubdomain);
        });
      }
    }, {
      key: 'applyRootSubdomain',
      value: function applyRootSubdomain(rootWrapper, childSubdomain) {
        var rootSubdomain = rootWrapper.ouFeatureConfig && rootWrapper.ouFeatureConfig.psviOrionSubdomain,
            rootOrionDeploymentId = rootWrapper.uo && rootWrapper.uo.orionDeploymentId,
            childHasCustom = childSubdomain && childSubdomain !== this.PSVI_DEFAULT_SUBDOMAIN;
        if (rootSubdomain && rootSubdomain !== this.PSVI_DEFAULT_SUBDOMAIN) {
          this.psviOrionSubdomain = rootSubdomain;
          this.hideSubdomainField = false;
          this.subdomainAlreadyApplied = rootSubdomain === childSubdomain;
        } else if (rootOrionDeploymentId) {
          this.psviOrionSubdomain = this.PSVI_DEFAULT_SUBDOMAIN;
          this.hideSubdomainField = false;
          this.subdomainAlreadyApplied = !childHasCustom;
        } else {
          this.psviOrionSubdomain = null;
          this.hideSubdomainField = true;
        }
      }
    }, {
      key: 'onUoPaiChange',
      value: function onUoPaiChange() {
        this.uoPaiChanged = this.uoBloqueioWrapper.uo.uoPai.id !== this.uoPaiIdInitialValue;
      }
    }, {
      key: 'getUoBloqueio',
      value: function getUoBloqueio() {
        if (this.uoBloqueada) {
          return {
            id: this.uoBloqueioWrapper.uoBloqueio && this.uoBloqueioWrapper.uoBloqueio.id ? this.uoBloqueioWrapper.uoBloqueio.id : 0,
            uoId: this.uoBloqueioWrapper.uo.id,
            usuarioId: this.user.id,
            mensagem: this.mensagemBloqueio
          };
        }
        return null;
      }
    }, {
      key: 'isCadastro',
      value: function isCadastro() {
        return angular.isUndefined(this.uoBloqueioWrapper.uo.id);
      }
    }, {
      key: 'showSucces',
      value: function showSucces(data) {
        this.location.path('/uos');
        this.alertMessage.create({ type: 'success', message: data.message, appendTo: '.alerta-aqui' });
      }
    }, {
      key: 'showError',
      value: function showError(error) {
        var _this7 = this;

        if (this.isPsviSubdomainError(error)) {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('core-permissoes.organizacao.uos.orion.psviOrionSubdomainUnreachable'),
            appendTo: '.alerta-aqui'
          });
          return;
        }
        if (error.data.length > 0) {
          var erros = error.data.map(function (e) {
            return e.message;
          });
          erros.forEach(function (e) {
            return _this7.alertMessage.create({ type: 'error', message: e, appendTo: '.alerta-aqui' });
          });
        } else if (error.data.message && angular.isUndefined(error.data.exception)) {
          this.alertMessage.create({ type: 'error', message: error.data.message, appendTo: '.alerta-aqui' });
        } else {
          this.alertMessage.create({ type: 'error', message: 'Erro ao salvar Unidade Organizacional, tente novamente.', appendTo: '.alerta-aqui' });
        }
      }
    }, {
      key: 'isPsviSubdomainError',
      value: function isPsviSubdomainError(error) {
        var data = error && error.data,
            raw = angular.isString(data) ? data : angular.toJson(data || '');
        return raw.indexOf('psviOrionSubdomain') !== -1;
      }
    }, {
      key: 'importarMotoristas',
      value: function importarMotoristas() {
        var _this8 = this;

        var accountId = this.uoBloqueioWrapper.uo.customerAccountUuid;
        if (accountId) {
          this.restangular.one('/motorista/ttc/hydrate?accountId=' + accountId).post().then(function () {
            return _this8.alertMessage.create({ type: 'success', message: 'Successfully imported drivers', appendTo: '.alerta-aqui' });
          }).catch(function () {
            return _this8.alertMessage.create({ type: 'error', message: 'Error when importing drivers', appendTo: '.alerta-aqui' });
          });
        }
      }
    }, {
      key: 'importarVeiculos',
      value: function importarVeiculos() {
        var _this9 = this;

        var uoId = this.uoBloqueioWrapper.uo.id;
        if (this.uoBloqueioWrapper.uo.customerAccountUuid) {
          this.restangular.one('/veiculo/v2/veiculos/sync-ttc-vehicle-to-v3g?uoId=' + uoId).post().then(function () {
            return _this9.alertMessage.create({ type: 'success', message: 'Successfully imported vehicles', appendTo: '.alerta-aqui' });
          }).catch(function () {
            return _this9.alertMessage.create({ type: 'error', message: 'Error when importing vehicles', appendTo: '.alerta-aqui' });
          });
        }
      }
    }, {
      key: 'importarUsuarios',
      value: function importarUsuarios() {
        var _this10 = this;

        var accountId = this.uoBloqueioWrapper.uo.customerAccountUuid;
        if (this.uoBloqueioWrapper.uo.customerAccountUuid) {
          this.restangular.one('/auth/ttc/hydrate?accountId=' + accountId).post().then(function () {
            return _this10.alertMessage.create({ type: 'success', message: 'Successfully imported users', appendTo: '.alerta-aqui' });
          }).catch(function () {
            return _this10.alertMessage.create({ type: 'error', message: 'Error when importing users', appendTo: '.alerta-aqui' });
          });
        }
      }
    }, {
      key: 'ok',
      value: function ok(tipoEvento) {
        var _this11 = this;

        this.modalService.open({
          templateUrl: 'uos/confirm-import-modal/confirm-import-ttc-modal.tpl.html',
          controller: 'ConfirmImportTtcModalCtrl',
          controllerAs: 'ctrl',
          size: 'md'
        }).result.then(function () {
          if (tipoEvento === 'motorista') {
            _this11.importarMotoristas();
          } else if (tipoEvento === 'usuarios') {
            _this11.importarUsuarios();
          } else {
            _this11.importarVeiculos();
          }
        });
      }
    }]);

    return CadastrarUoCtrl;
  }();

  /**
   * @ngdoc object
   * @name uos.controller:CadastrarUoCtrl
   *
   * @description
   *
   */


  angular.module('uos').controller('CadastrarUoCtrl', CadastrarUoCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */

  angular.module('perfis', ['ui.router', 'ui.bootstrap.modal', 'flash']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('perfis').factory('Perfis', PerfisService).factory('PerfisPublic', PerfisPublicService);

  function PerfisService(Restangular) {
    return Restangular.service('auth/perfis');
  }

  function PerfisPublicService(Restangular) {
    return Restangular.service('auth/perfis/public');
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('perfis').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.perfis', {
      url: '/perfis',
      views: {
        'content@': {
          templateUrl: 'perfis/perfis.tpl.html',
          controller: 'PerfisCtrl',
          controllerAs: 'perfis'
        }
      },
      data: {
        titulo: 'core-permissoes.configuracoes.perfisDeUsuario.menuLabel',
        role: 'PERFIL_USUARIO_VISUALIZAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var PerfisCtrl = function () {
    function PerfisCtrl(Authenticator, ServiceVfiltro, FactoryVfiltro) {
      _classCallCheck(this, PerfisCtrl);

      this.auth = Authenticator;
      this.init();

      ServiceVfiltro.init(FactoryVfiltro.get([]));
    }

    _createClass(PerfisCtrl, [{
      key: 'init',
      value: function init() {
        this.auth.getUser().then(function (user) {
          /* eslint-disable */
          var elementContainer = document.querySelector('#perfis-element'),
              perfisElement = document.createElement('pwc-perfis');
          /* eslint-enable */

          if (perfisElement) {
            perfisElement.userData = {
              solucaoIds: user.plain().solucoes.map(function (solucao) {
                return solucao.solucaoId;
              }),
              usuario: user.plain()
            };
          }
          elementContainer.appendChild(perfisElement);
        });
      }
    }]);

    return PerfisCtrl;
  }();

  angular.module('perfis').controller('PerfisCtrl', PerfisCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name importacaoPontoReferencia
   * @description
   *
   */

  angular.module('importacaoPontoReferencia', ['ui.router']).factory('PontoReferenciaResourceService', function (Restangular) {
    return Restangular.service('embarque/resources/ponto-referencia/importacoes');
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('importacaoPontoReferencia').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.importacaoPontoReferencia', {
      url: '/importacao-ponto-referencia',
      views: {
        'content@': {
          templateUrl: 'importacao-ponto-referencia/importacao-ponto-referencia.tpl.html',
          controller: 'ImportacaoPontoReferenciaCtrl',
          controllerAs: 'importacaoPontoReferencia'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.importacaoPontoReferencia.titulo',
        role: 'UO_EDITAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global FormData */

  var ImportacaoPontoReferenciaCtrl = function () {
    function ImportacaoPontoReferenciaCtrl(Uos, Flash, $scope, HttpServiceV3g, moment, PontoReferenciaResourceService, $uibModal) {
      var _this = this;

      _classCallCheck(this, ImportacaoPontoReferenciaCtrl);

      this.uoService = Uos;
      this.flash = Flash;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.uos = [];
      this.uo = null;
      this.files = [];
      this.moment = moment;
      this.PontoReferenciaResourceService = PontoReferenciaResourceService;
      this.ImportacaoRelatorio = null;
      this.table = null;
      this.httpStatus = 0;
      this.modalService = $uibModal;
      this.init();
      this.loadUos();

      this.scope.uploadedFile = function (element) {
        _this.scope.$apply(function (scope) {
          scope.files = element.files;
        });
      };
    }

    _createClass(ImportacaoPontoReferenciaCtrl, [{
      key: 'init',
      value: function init() {
        this.periodoFiltro = { startDate: this.moment().subtract(1, 'days'), endDate: this.moment() };
      }
    }, {
      key: 'loadUos',
      value: function loadUos() {
        var _this2 = this;

        this.uoService.getFilhasLista().then(function (data) {
          _this2.uos = data.plain();
        });
      }
    }, {
      key: 'importar',
      value: function importar() {
        var _this3 = this;

        var formData = new FormData();
        this.clearMensagens();
        formData.append('file', this.scope.files[0]);
        formData.append('uoId', this.uo.id);

        this.httpService.post('/embarque/resources/ponto-referencia/uploadCSVPontosParaUO', formData, {
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        }).success(function (data) {
          if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            _this3.msgSucessoComErro = data;
          } else {
            _this3.msgSucesso = 'Processo de importação iniciado';
          }
        }).error(function (data, status) {
          _this3.httpStatus = status;
          if (status === 409) {
            _this3.flash.create('error', 'Importação em andamento para esta UO. Aguarde a conclusão.');
          } else if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            _this3.flash.create('error', data.mensagens[0]);
          } else {
            _this3.flash.create('error', 'Erro ao importar.');
          }
        });
      }
    }, {
      key: 'carregarRelatorio',
      value: function carregarRelatorio() {
        var _this4 = this;

        this.PontoReferenciaResourceService.one().get(this.getParams()).then(function (data) {
          _this4.ImportacaoRelatorio = data.list;
        });
      }
    }, {
      key: 'getParams',
      value: function getParams() {
        return {
          inicio: this.periodoFiltro.startDate.toDate(),
          fim: this.periodoFiltro.endDate.toDate(),
          uoId: this.uo.id
        };
      }
    }, {
      key: 'clearMensagens',
      value: function clearMensagens() {
        this.msgErro = null;
        this.msgSucesso = null;
        this.msgSucessoComErro = null;
      }
    }, {
      key: 'mostrarMotivoImportacao',
      value: function mostrarMotivoImportacao(_importacaoRegistro) {
        if (_importacaoRegistro.statusImportacao === 'CONCLUIDO' || _importacaoRegistro.statusImportacao === 'IMPORTANDO') {
          return;
        }
        this.modalService.open({
          templateUrl: 'importacao-ponto-referencia/importacao-motivo.tpl.html',
          controller: 'ImportacaoMotivoCtrl',
          controllerAs: 'importacaoMotivo',
          size: 'md',
          resolve: {
            importacaoRegistro: function importacaoRegistro() {
              return _importacaoRegistro;
            }
          }
        });
      }
    }]);

    return ImportacaoPontoReferenciaCtrl;
  }();

  var ImportacaoMotivoCtrl = function ImportacaoMotivoCtrl(importacaoRegistro) {
    _classCallCheck(this, ImportacaoMotivoCtrl);

    this.importacaoRegistro = importacaoRegistro;
  };
  /**
   * @ngdoc object
   * @name importacaoPontoReferencia.controller:ImportacaoPontoReferenciaCtrl
   *
   * @description
   *
   */


  angular.module('importacaoPontoReferencia').controller('ImportacaoPontoReferenciaCtrl', ImportacaoPontoReferenciaCtrl).controller('ImportacaoMotivoCtrl', ImportacaoMotivoCtrl);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name importacaoMotorista
   * @description
   *
   */

  angular.module('importacaoMotorista', ['ui.router']);
})();
'use strict';

(function () {
  'use strict';

  angular.module('importacaoMotorista').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.importacaoMotorista', {
      url: '/importacao-motorista',
      views: {
        'content@': {
          templateUrl: 'importacao-motorista/importacao-motorista.tpl.html',
          controller: 'ImportacaoMotoristaCtrl',
          controllerAs: 'importacaoMotorista'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.importacaoMotorista.titulo',
        role: 'UO_EDITAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global FormData */

  var ImportacaoMotoristaCtrl = function () {
    function ImportacaoMotoristaCtrl(Uos, Flash, $scope, HttpServiceV3g) {
      var _this = this;

      _classCallCheck(this, ImportacaoMotoristaCtrl);

      this.uoService = Uos;
      this.flash = Flash;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.uos = [];
      this.uo = {};
      this.files = [];
      this.loadUos();

      this.scope.uploadedFile = function (element) {
        _this.scope.$apply(function (scope) {
          scope.files = element.files;
        });
      };
    }

    _createClass(ImportacaoMotoristaCtrl, [{
      key: 'loadUos',
      value: function loadUos() {
        var _this2 = this;

        this.uoService.getFilhasLista().then(function (data) {
          _this2.uos = data.plain();
        });
      }
    }, {
      key: 'importar',
      value: function importar() {
        var _this3 = this;

        var formData = new FormData();
        this.clearMensagens();
        formData.append('file', this.scope.files[0]);
        formData.append('uoId', this.uo.id);

        this.httpService.post('/motorista/motoristas/importar-csv', formData, {
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        }).success(function (data) {
          if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            _this3.msgSucessoComErro = data;
          } else {
            _this3.msgSucesso = 'Importação de motoristas realizada com sucesso!';
          }
        }).error(function (data) {
          if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            _this3.flash.create('error', data.mensagens[0]);
          } else {
            _this3.flash.create('error', 'Erro ao importar os motoristas.');
          }
        });
      }
    }, {
      key: 'clearMensagens',
      value: function clearMensagens() {
        this.msgErro = null;
        this.msgSucesso = null;
        this.msgSucessoComErro = null;
      }
    }]);

    return ImportacaoMotoristaCtrl;
  }();

  /**
   * @ngdoc object
   * @name importacaoMotorista.controller:ImportacaoMotoristaCtrl
   *
   * @description
   *
   */


  angular.module('importacaoMotorista').controller('ImportacaoMotoristaCtrl', ImportacaoMotoristaCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('expurgo').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.expurgo', {
      url: '/expurgo',
      views: {
        'content@': {
          templateUrl: 'expurgo/expurgo.tpl.html',
          controller: 'ExpurgoCtrl',
          controllerAs: 'expurgoCtrl'
        }
      },
      data: {
        titulo: 'core-permissoes.purge.dismissalInvalidities'
      }
    });
  }
})();
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var ExpurgoCtrl = function () {
    function ExpurgoCtrl($scope, HttpServiceV3g, $uibModal, moment, Uos, UoArvoreNivel, ServiceVfiltro, FactoryVfiltro, AlertasEnum, VeiculosDonoService, ConfigEventosService, $translate) {
      var _this = this;

      _classCallCheck(this, ExpurgoCtrl);

      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.veiculosService = VeiculosDonoService;
      this.configEventosService = ConfigEventosService;
      this.moment = moment;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.modalService = $uibModal;

      this.serviceVfiltro = ServiceVfiltro;
      this.translate = $translate;

      this.selecao = {};
      this.uos = [];
      this.veiculos = [];
      this.alertas = [];

      this.limitUos = 10;
      this.limitVeiculos = 10;
      this.limitAlertas = 10;
      this.flagSalvar = false;

      this.todasAsEntidades = false;
      this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.selectOuLoadVehicle');
      this.alertasTiposExpurgo = AlertasEnum.getTiposExpurgo();

      this.dataInicioValidators = {
        isDataFutura: this.isNotDataFutura(function () {
          return _this.scope.expurgoForm.dataInicio.$viewValue;
        })
      };
      this.dataFimValidators = {
        isDataFutura: this.isNotDataFutura(function () {
          return _this.scope.expurgoForm.dataFim.$viewValue;
        }),
        isIntervaloValido: this.isIntervaloValido(),
        isIntervaloAte30Dias: this.isIntervaloAte30Dias()
      };
      this.horaInicioValidators = {
        isHoraInicioFuturo: this.isNotHoraInicioFuturo()
      };
      this.horaFimValidators = {
        isHoraFimValida: this.isHoraFimValida(),
        isHoraFimFuturo: this.isNotHoraFimFuturo()
      };

      ServiceVfiltro.init(FactoryVfiltro.get([])).then(function () {
        _this.init(_this.serviceVfiltro.factoryVfiltro.user);
        _this.abonoVisualizar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ABONO_VISUALIZAR');
        _this.abonoEditar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('ABONO_EDITAR');
      });
    }

    _createClass(ExpurgoCtrl, [{
      key: 'init',
      value: function init(user) {
        this.user = user;
        this.carregarUos(this.user.uo.id);
      }
    }, {
      key: 'loadMoreUos',
      value: function loadMoreUos() {
        this.limitUos += 10;
      }
    }, {
      key: 'loadMoreVeiculos',
      value: function loadMoreVeiculos() {
        this.limitVeiculos += 10;
      }
    }, {
      key: 'loadMoreAlertas',
      value: function loadMoreAlertas() {
        this.limitAlertas += 10;
      }
    }, {
      key: 'podeVerHistoricoAbono',
      value: function podeVerHistoricoAbono() {
        return this.abonoVisualizar;
      }
    }, {
      key: 'goToHist',
      value: function goToHist() {
        return '/historico-expurgo?vfiltro=uo:' + (angular.isDefined(this.user) && this.user.uo.id ? this.user.uo.id : '');
      }
    }, {
      key: 'podeFazerAbono',
      value: function podeFazerAbono() {
        return this.abonoEditar;
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos() {
        var _this2 = this;

        this.uoService.getFilhas(this.user.uo.id).then(function (data) {
          return _this2.uos = _this2.uoArvoreNivel.converterEmLista(data.plain());
        });
      }
    }, {
      key: 'carregarVeiculos',
      value: function carregarVeiculos() {
        var _this3 = this;

        this.model.veiculo = null;
        this.veiculos = [];
        this.veiculosService.getVeiculos(this.model.uo.id).then(function (data) {
          _this3.veiculos = data;
          _this3.msgVeiculos();
        });
      }
    }, {
      key: 'carregarConfigEventos',
      value: function carregarConfigEventos() {
        var _this4 = this;

        this.configEventosService.getConfigEventosPorUo(this.model.uo.id).then(function (data) {
          _this4.alertas = _this4.alertasTiposExpurgo.filter(function (alerta) {
            return !data[alerta.descricao.split('.').pop()] || data[alerta.descricao.split('.').pop()].enabled;
          });
        });
      }
    }, {
      key: 'ok',
      value: function ok() {
        var _this5 = this;

        if (this.scope.expurgoForm.$valid) {
          this.modalService.open({
            templateUrl: 'expurgo/confirm-expurgo-modal/confirm-expurgo-modal.tpl.html',
            controller: 'ConfirmExpurgoModalCtrl',
            controllerAs: 'ctrl',
            size: 'md',
            resolve: {
              evento: function evento() {
                return _this5.model.alerta;
              }
            }
          }).result.then(function () {
            _this5.efetuarAbono();
          });
        } else {
          this.flagSalvar = this.scope.expurgoForm.$error.required;
        }
      }
    }, {
      key: 'efetuarAbono',
      value: function efetuarAbono() {
        var _this6 = this;

        var veiculoId = this.model.veiculo.id,
            tipoEvento = this.model.alerta.id,
            expurgo = {
          justificativa: this.model.justificativa,
          inicio: this.getDatahoraInicio().toISOString(),
          fim: this.getDatahoraFim().toISOString()
        };
        this.httpService.post('/expurgo/expurgos/veiculo/' + veiculoId + '/tipo-evento/' + tipoEvento, expurgo).then(function () {
          _this6.limpaCampos();
          _this6.alert = {
            display: true,
            alertClass: 'alert-success',
            alertMessage: _this6.translate.instant('core-permissoes.purge.dismissalRequest')
          };
        }, function (error) {
          if (error.status === 400 && error.data.message === 'Nenhum histórico de veículo encontrado.') {
            _this6.alert = {
              display: true,
              alertClass: 'alert-danger',
              alertMessage: _this6.translate.instant('core-permissoes.purge.noHistoryFoundVehicle')
            };
          } else {
            _this6.alert = {
              display: true,
              alertClass: 'alert-danger',
              alertMessage: _this6.translate.instant('core-permissoes.purge.errorRequest')
            };
          }
        });
      }
    }, {
      key: 'limpaCampos',
      value: function limpaCampos() {
        this.model = {};
        this.scope.expurgoForm.$setPristine();
      }
    }, {
      key: 'msgVeiculos',
      value: function msgVeiculos() {
        if (!this.model.uo) {
          this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.selectOuLoadVehicle');
        }
        if (!this.veiculos.length) {
          this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.noVehiclesOu');
        } else {
          this.placeHolderVeiculos = this.translate.instant('core-permissoes.purge.selectVehicleDismiss');
        }
      }
    }, {
      key: 'isNotDataFutura',
      value: function isNotDataFutura(dateSupplier) {
        var _this7 = this;

        return function () {
          var dataInput = _this7.moment(dateSupplier());
          if (dataInput.isValid()) {
            var dataValidation = dataInput.isBefore(_this7.moment().endOf('day'));
            if (dataValidation) {
              _this7.scope.expurgoForm.horaInicio.$validate();
              _this7.scope.expurgoForm.horaFim.$validate();
            }
            return dataValidation;
          }
          return true;
        };
      }
    }, {
      key: 'isIntervaloValido',
      value: function isIntervaloValido() {
        var _this8 = this;

        return function () {
          var inicio = _this8.moment(_this8.scope.expurgoForm.dataInicio.$viewValue, 'YYYY-MM-DD', true),
              fim = _this8.moment(_this8.scope.expurgoForm.dataFim.$viewValue, 'YYYY-MM-DD', true);
          if (inicio.isValid() && fim.isValid()) {
            return inicio.isSameOrBefore(fim);
          }
          return true;
        };
      }
    }, {
      key: 'isIntervaloAte30Dias',
      value: function isIntervaloAte30Dias() {
        var _this9 = this;

        var TRINTA_DIAS_MS = 30 * 24 * 60 * 60 * 1000;
        return function () {
          var inicio = _this9.getDatahoraInicio(),
              fim = _this9.getDatahoraFim();
          if (inicio.isValid() && fim.isValid() && inicio.isSameOrBefore(fim)) {
            return fim.diff(inicio) < TRINTA_DIAS_MS;
          }
          return true;
        };
      }
    }, {
      key: 'isNotHoraInicioFuturo',
      value: function isNotHoraInicioFuturo() {
        var _this10 = this;

        return function () {
          return !_this10.getDatahoraInicio().isAfter(_this10.moment());
        };
      }
    }, {
      key: 'isNotHoraFimFuturo',
      value: function isNotHoraFimFuturo() {
        var _this11 = this;

        return function () {
          return !_this11.getDatahoraFim().isAfter(_this11.moment());
        };
      }
    }, {
      key: 'isHoraFimValida',
      value: function isHoraFimValida() {
        var _this12 = this;

        return function () {
          var inicio = _this12.getDatahoraInicio(),
              fim = _this12.getDatahoraFim();
          if (inicio.date() === fim.date() && inicio.month() === fim.month() && inicio.year() === fim.year()) {
            return inicio.isBefore(fim);
          }
          return true;
        };
      }
    }, {
      key: 'isValidJustificativa',
      value: function isValidJustificativa() {
        var _this13 = this;

        return function () {
          var justificativa = _this13.scope.expurgoForm.justificativa.$viewValue;
          if (angular.isDefined(justificativa)) {
            return justificativa.replace(/\s/g, '').length >= 5;
          }
          return true;
        };
      }
    }, {
      key: 'isEmpty',
      value: function isEmpty(field) {
        return this.flagSalvar && field.$error.required;
      }
    }, {
      key: 'isDataFinalInvalid',
      value: function isDataFinalInvalid() {
        var horaFim = this.scope.expurgoForm.horaFim;
        return horaFim.$dirty && horaFim.$invalid || this.isEmpty(horaFim);
      }
    }, {
      key: 'getDatahoraInicio',
      value: function getDatahoraInicio() {
        var horaNormalizada = this.normalizarHora(this.scope.expurgoForm.horaInicio.$viewValue);
        return this.moment(this.scope.expurgoForm.dataInicio.$viewValue + ' ' + horaNormalizada, 'YYYY-MM-DD HH:mm:ss', true);
      }
    }, {
      key: 'getDatahoraFim',
      value: function getDatahoraFim() {
        var horaNormalizada = this.normalizarHora(this.scope.expurgoForm.horaFim.$viewValue);
        return this.moment(this.scope.expurgoForm.dataFim.$viewValue + ' ' + horaNormalizada, 'YYYY-MM-DD HH:mm:ss', true);
      }
    }, {
      key: 'normalizarHora',
      value: function normalizarHora(horaStr) {
        if (horaStr) {
          var _horaStr$split = horaStr.split(':'),
              _horaStr$split2 = _slicedToArray(_horaStr$split, 3),
              hora = _horaStr$split2[0],
              minuto = _horaStr$split2[1],
              segundo = _horaStr$split2[2];

          if (hora && minuto && segundo) {
            return hora + ':' + minuto + ':' + segundo;
          } else if (hora && minuto) {
            return hora + ':' + minuto + ':00';
          }
        }
        return '00:00:00';
      }
    }, {
      key: 'hasError',
      value: function hasError(formField) {
        if (formField) {
          return !!formField.$dirty && !!formField.$invalid;
        }
      }
    }, {
      key: 'validarCamposDataHora',
      value: function validarCamposDataHora() {
        this.scope.expurgoForm.dataInicio.$validate();
        this.scope.expurgoForm.horaInicio.$validate();
        this.scope.expurgoForm.dataFim.$validate();
        this.scope.expurgoForm.horaFim.$validate();
      }
    }]);

    return ExpurgoCtrl;
  }();

  /**
   * @ngdoc object
   * @name expurgo.controller:ExpurgoCtrl
   *
   * @description
   *
   */


  angular.module('expurgo').controller('ExpurgoCtrl', ExpurgoCtrl);
})();
'use strict';

(function () {
  'use strict';

  function pageConfig($stateProvider) {
    return $stateProvider.state('unprotected.errorPage', {
      url: '/error',
      params: {
        lastPage: null
      },
      views: {
        'guest@': {
          templateUrl: 'components/error-page/error-page.tpl.html',
          controller: 'ErrorPageCtrl',
          controllerAs: 'ctrl'
        }
      }
    });
  }

  angular.module('errorPageModule').config(pageConfig);
})();
'use strict';

(function () {
  'use strict';

  angular.module('enumModule', []);
})();
'use strict';

(function () {
  'use strict';

  var segmentos = [{ key: 'ALIMENTOS_E_BEBIDAS', value: 'core-permissoes.organizacao.uos.segment.foodAndBeverage' }, { key: 'MINERACAO_SIDERURGIA', value: 'core-permissoes.organizacao.uos.segment.miningAndSteelmaking' }, { key: 'OLEO_GAS', value: 'core-permissoes.organizacao.uos.segment.oilAndGas' }, { key: 'OUTROS', value: 'core-permissoes.organizacao.uos.segment.others' }, { key: 'SUCROENERGETICO', value: 'core-permissoes.organizacao.uos.segment.sugarEnergy' }, { key: 'TRANSPORTE_E_LOGISTICA', value: 'core-permissoes.organizacao.uos.segment.transportAndLogistics' }],
      funcoes = {
    getSegmentoByKey: function getSegmentoByKey(key) {
      return segmentos.find(function (segmento) {
        return segmento.key === key;
      });
    },
    getAllSegmentos: function getAllSegmentos() {
      return segmentos;
    }
  };

  angular.module('enumModule').constant('SegmentosEnum', Object.assign({}, segmentos, funcoes));
})();
'use strict';

(function () {
  'use strict';

  /* global vfleetsConstants */

  angular.module('enumModule').constant('RolesEnum', vfleetsConstants.v3gRoles);
})();
'use strict';

(function () {
  'use strict';

  var systems = [{ key: 'METRIC', label: 'core-permissoes.organizacao.usuarios.popup.measurementSystemMetric' }, { key: 'IMPERIAL', label: 'core-permissoes.organizacao.usuarios.popup.measurementSystemImperial' }],
      functions = {
    getSystemByKey: function getSystemByKey(key) {
      return systems.find(function (system) {
        return system.key === key;
      });
    },
    getAllSystems: function getAllSystems() {
      return systems;
    },
    getDefaultKeyForLanguage: function getDefaultKeyForLanguage(languageKey) {
      return languageKey === 'EN_US' ? 'IMPERIAL' : 'METRIC';
    }
  };

  angular.module('enumModule').constant('MeasurementSystemEnum', Object.assign({}, systems, functions));
})();
'use strict';

(function () {
  'use strict';

  var FEATURE_FLAG_EU_LANGUAGES = 'SVP403_EU_LANGUAGE_ENABLED',
      idiomas = [{ key: 'PT_BR', value: 'Português' }, { key: 'ES_ES', value: 'Español' }, { key: 'EN_US', value: 'English' }, { key: 'EN_GB', value: 'English (UK)', euLanguage: true }, { key: 'DE_DE', value: 'Deutsch', euLanguage: true }, { key: 'FR_FR', value: 'Français', euLanguage: true }, { key: 'IT_IT', value: 'Italiano', euLanguage: true }, { key: 'NL_NL', value: 'Nederlands', euLanguage: true }, { key: 'PL_PL', value: 'Polski', euLanguage: true }],
      idiomasBase = idiomas.filter(function (idioma) {
    return !idioma.euLanguage;
  }),
      funcoes = {
    getIdiomaByKey: function getIdiomaByKey(key) {
      return idiomas.find(function (idioma) {
        return idioma.key === key;
      });
    },
    getAllIdiomas: function getAllIdiomas() {
      return featurehubJsSdk.isFeatureEnabled(FEATURE_FLAG_EU_LANGUAGES) ? idiomas : idiomasBase;
    }
  };

  angular.module('enumModule').constant('IdiomasEnum', Object.assign({}, idiomas, funcoes));
})();
'use strict';

(function () {
  'use strict';

  /* global featurehubJsSdk */

  angular.module('FeatureFlagModule', []).factory('FeaturehubJsSdk', function () {
    return featurehubJsSdk;
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('FeatureFlagModule').constant('FeatureHubConfigKeys', {
    MEASUREMENT_SYSTEM: 'PSVI_748_MEASUREMENT_SYSTEM'
  });
})();
'use strict';

(function () {
  'use strict';

  angular.module('corePermissoes').run(run);

  var MOMENT_LOCALE_BY_IDIOMA = {
    pt_br: 'pt-br',
    es_es: 'es',
    en_us: 'en',
    en_gb: 'en-gb',
    de_de: 'de',
    fr_fr: 'fr',
    it_it: 'it',
    nl_nl: 'nl',
    pl_pl: 'pl'
  };

  function run($rootScope, $translate, dateRangePickerConfig, moment) {
    dateRangePickerConfig.timePicker = true;
    dateRangePickerConfig.timePicker12Hour = false;

    function applyLocale(idioma) {
      moment.locale(MOMENT_LOCALE_BY_IDIOMA[idioma] || 'en');
      var localeData = moment.localeData(),
          ranges = {};

      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.today')] = [moment().startOf('day'), moment().endOf('day')];
      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.yesterday')] = [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')];
      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.last7Days')] = [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')];
      ranges[$translate.instant('core-permissoes.organizacao.common.dateRangePicker.last30Days')] = [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')];

      dateRangePickerConfig.ranges = ranges;
      dateRangePickerConfig.locale = {
        format: 'DD/MM/YYYY HH:mm',
        separator: ' - ',
        applyLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.applyLabel'),
        cancelLabel: $translate.instant('core-permissoes.organizacao.common.cancel'),
        fromLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.fromLabel'),
        toLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.toLabel'),
        weekLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.weekLabel'),
        customRangeLabel: $translate.instant('core-permissoes.organizacao.common.dateRangePicker.customRangeLabel'),
        daysOfWeek: localeData.weekdaysShort(),
        monthNames: localeData.months(),
        firstDay: localeData.firstDayOfWeek()
      };
    }

    applyLocale($translate.use());
    $rootScope.$on('$translateChangeSuccess', function (event, data) {
      return applyLocale(data.language);
    });
  }
})();
'use strict';

(function () {
  'use strict';

  /* global $ */

  $.AdminLTE.options.enableBSToppltip = false;

  angular.module('corePermissoes').run(setBlockUIMessage);

  function setBlockUIMessage($translate, blockUIConfig) {
    blockUIConfig.requestFilter = function (blockConfig) {
      if (blockConfig.url.match(/alertas\/quantidade/)) {
        return false;
      }
      return $translate.isReady() ? $translate.instant('ce.common.carregando') : 'Carregando...';
    };
  }
  setBlockUIMessage.$inject = ['$translate', 'blockUIConfig'];
})();
'use strict';

(function () {
  'use strict';

  angular.module('compartilhamentos').factory('Entidades', EntidadesService);

  function EntidadesService(Restangular) {
    var service = Restangular.service('entidades');

    service.getEntidades = function (enumTipo, uoId) {
      return Restangular.all('auth/entidades/' + enumTipo + '/dona/' + uoId).getList();
    };

    return service;
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('compartilhamentos').factory('Compartilhamentos', CompartilhamentosService);

  function CompartilhamentosService(Restangular) {
    return Restangular.service('auth/uo-compartilhamento');
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('compartilhamentos').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.compartilhamentos', {
      url: '/compartilhamentos?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'compartilhamentos/compartilhamentos.tpl.html',
          controller: 'CompartilhamentosCtrl',
          controllerAs: 'compartilhamentos'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.compartilhamentos.sharing',
        tituloDescricao: 'core-permissoes.organizacao.compartilhamentos.entitiesShared',
        role: 'COMPARTILHAMENTOS_VISUALIZAR'
      }
    }).state('root.cadastro', {
      url: '/compartilhamentos/cadastro/:id',
      views: {
        'content@': {
          templateUrl: 'compartilhamentos/cadastro.tpl.html',
          controller: 'CadastroCtrl',
          controllerAs: 'cadastro'
        }
      },
      data: {
        titulo: 'core-permissoes.organizacao.compartilhamentos.sharing',
        role: 'COMPARTILHAMENTOS_EDITAR'
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var CompartilhamentosCtrl = function () {
    function CompartilhamentosCtrl(AlertMessage, Compartilhamentos, Uos, $scope, UoArvoreNivel, $q, Keys, ServiceVfiltro, FactoryVfiltro, $location, $translate, VehiclesMap) {
      var _this = this;

      _classCallCheck(this, CompartilhamentosCtrl);

      this.q = $q;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.alertMessage = AlertMessage;
      this.location = $location;
      this.$scope = $scope;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.compartilhamentoService = Compartilhamentos;
      this.compartilhamentos = [];
      this.$translate = $translate;
      this.vehiclesMap = VehiclesMap;
      ServiceVfiltro.init(FactoryVfiltro.get([{
        key: this.keys.uo.name
      }])).then(function (filtro) {
        _this.carregarCompartilhamentos(filtro);
        _this.roleCadastrar = _this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('COMPARTILHAMENTOS_EDITAR');
      });

      this.$scope.translateTipoEntidade = function (nomeEntidade) {
        if (VehiclesMap[nomeEntidade]) {
          var translatedPath = $translate.instant('core-permissoes.organizacao.compartilhamentos.shareButton.' + VehiclesMap[nomeEntidade]);
          return translatedPath;
        }

        return nomeEntidade;
      };
    }

    _createClass(CompartilhamentosCtrl, [{
      key: 'carregarCompartilhamentos',
      value: function carregarCompartilhamentos(filtro) {
        var _this2 = this;

        this.compartilhamentoService.one('list').getList(filtro.find(function (x) {
          return x.key === _this2.keys.uo.name;
        }).value.id).then(function (data) {
          _this2.displayMessages();
          _this2.compartilhamentos = data.map(function (uoCompartilhamento) {
            uoCompartilhamento.compartilhamentoRecebidoLista = uoCompartilhamento.compartilhamentoRecebidoLista.filter(function (compartilhamentoRecebido) {
              return compartilhamentoRecebido.uo.id !== uoCompartilhamento.uo.id;
            });

            return uoCompartilhamento;
          });
        });
      }
    }, {
      key: 'displayMessages',
      value: function displayMessages() {
        if (this.location.search().saveSuccess && this.location.search().saveSuccess === 'true') {
          this.alertMessage.create({
            type: 'success',
            message: 'Compartilhamento salvo com sucesso.',
            appendTo: '.alerta-aqui'
          });
          this.location.search('saveSuccess', null);
        }

        if (this.location.search().deleteSuccess && this.location.search().deleteSuccess === 'true') {
          this.alertMessage.create({
            type: 'success',
            message: 'Compartilhamento excluído com sucesso.',
            appendTo: '.alerta-aqui'
          });
          this.location.search('deleteSuccess', null);
        }
      }
    }]);

    return CompartilhamentosCtrl;
  }();

  /**
   * @ngdoc object
   * @name compartilhamentos.controller:CompartilhamentosCtrl
   *
   * @description
   *
   */


  angular.module('compartilhamentos').controller('CompartilhamentosCtrl', CompartilhamentosCtrl);
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global _ */

  var CadastroCtrl = function () {
    function CadastroCtrl(AlertMessage, $location, $stateParams, moment, Compartilhamentos, Uos, $timeout, $translate, $scope, DiasDaSemana, TipoEntidades, Entidades, UoArvoreNivel, $q, $uibModal, ModalInfoConfirmService, EntidadeMap, VehiclesMap) {
      _classCallCheck(this, CadastroCtrl);

      this.alertMessage = AlertMessage;
      this.location = $location;
      this.stateParams = $stateParams;
      this.moment = moment;
      this.modalService = $uibModal;
      this.$scope = $scope;
      this.compartilhamentoService = Compartilhamentos;
      this.uoService = Uos;
      this.timeout = $timeout;
      this.$translate = $translate;
      this.entidadeMap = EntidadeMap;
      this.vehiclesMap = VehiclesMap;
      this.diasDaSemanaService = DiasDaSemana;
      this.tipoEntidadeService = TipoEntidades;
      this.entidadeService = Entidades;
      this.uoArvoreNivel = UoArvoreNivel;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.q = $q;
      this.isEdicao = false;
      this.compartilhamento = {};
      this.uos = null;
      this.uosCompartilhamento = [];
      this.tipoEntidades = null;
      this.entidades = null;
      this.diasDaSemana = null;
      this.todasAsEntidades = true;
      this.todasFilhas = false;
      this.periodoIndeterminado = true;
      this.todosOsDiasDaSemana = true;
      this.horarioIndeterminado = true;
      this.listFail = [];
      this.limit = 10;
      this.periodo = {
        startDate: this.moment({ hour: 0, minute: 0 }),
        endDate: this.moment({ hour: 23, minute: 59 })
      };
      this.enumEntidade = {
        TODOS: -1,
        USUARIOS: 6,
        PONTOS_DE_REFERENCIA: 7
      };
      this.horas = Array.apply(null, new Array(24)).map(function (_, i) {
        return i;
      });
      this.limitOrigem = 10;
      this.limitDestino = 10;
      this.ENTIDADES_PERMITIDAS_TODAS_FILHAS = ['PONTOS_DE_REFERENCIA', 'MOTORISTAS', 'GRUPOS_VEICULO', 'DEPARTAMENTOS_MOTORISTA', 'CERCAS_ELETRONICAS'];
      this.init();

      this.$scope.translateTipoEntidade = function (nomeEntidade) {
        if (EntidadeMap[nomeEntidade]) {
          var translatedPath = $translate.instant('core-permissoes.organizacao.compartilhamentos.shareButton.' + EntidadeMap[nomeEntidade]);
          return translatedPath;
        }

        return nomeEntidade;
      };
    }

    _createClass(CadastroCtrl, [{
      key: 'loadMoreOrigem',
      value: function loadMoreOrigem() {
        this.limitOrigem += 10;
      }
    }, {
      key: 'loadMoreDestino',
      value: function loadMoreDestino() {
        this.limitDestino += 10;
      }
    }, {
      key: 'tipoPermiteEdicao',
      value: function tipoPermiteEdicao() {
        return this.compartilhamento.tipoEntidade && this.compartilhamento.tipoEntidade.enumEntidade !== 'SERVICOS';
      }
    }, {
      key: 'init',
      value: function init() {
        var _this = this;

        this.carregarUos();
        this.carregarTipoEntidades();
        this.carregarDiasDaSemana();

        if (this.stateParams.id > 0) {
          this.isEdicao = true;
          this.compartilhamentoService.one(this.stateParams.id).get().then(function (data) {
            _this.compartilhamento = data;
            _this.periodoIndeterminado = data.periodoIndeterminado;
            _this.todosOsDiasDaSemana = data.todosOsDiasDaSemana;
            _this.horarioIndeterminado = data.horarioIndeterminado;
            if (!data.periodoIndeterminado) {
              _this.periodo.startDate = _this.moment(data.periodoInicio);
              _this.periodo.endDate = _this.moment(data.periodoFim);
            }
            if (angular.isUndefined(_this.compartilhamento.uoCompartilhada)) {
              _this.compartilhamento.uoCompartilhada = { id: -1, nome: 'TODAS AS FILHAS' };
            }
            if (angular.isUndefined(_this.compartilhamento.tipoEntidade)) {
              _this.compartilhamento.tipoEntidade = { id: -1, nome: 'TODAS AS ENTIDADES', enumEntidade: 'TODAS_ENTIDADES', todas: true };
            }
            if (angular.isDefined(data.entidades) && data.entidades.length > 0) {
              _this.todasAsEntidades = false;
              _this.carregarEntidades();
            }
            _this.carregarUoCompartilhamento();
          });
        }
      }
    }, {
      key: 'carregarUos',
      value: function carregarUos() {
        var _this2 = this;

        this.uoService.getFilhas().then(function (data) {
          _this2.uos = _this2.uoArvoreNivel.converterEmLista(data.plain());
        });
      }
    }, {
      key: 'carregarUoCompartilhamento',
      value: function carregarUoCompartilhamento() {
        this.uosCompartilhamento = [{ id: -1, nome: this.$translate.instant('core-permissoes.organizacao.compartilhamentos.allChildUos') }];
        if (this.compartilhamento.uo !== null) {
          this.carregarUosParceiras();
          this.carregarUosFilhas();
          this.carregarUosIrmas();
        }
      }
    }, {
      key: 'carregarUosParceiras',
      value: function carregarUosParceiras() {
        var _this3 = this;

        this.uoService.getParceiras(this.compartilhamento.uo.id).then(function (data) {
          var parceiras = _.map(data.plain(), function (element) {
            return _.extend({}, element, { tipo: _this3.$translate.instant('core-permissoes.organizacao.compartilhamentos.partnersUos') });
          });
          _this3.uosCompartilhamento = _this3.uosCompartilhamento.concat(parceiras);
        });
      }
    }, {
      key: 'carregarUosIrmas',
      value: function carregarUosIrmas() {
        var _this4 = this;

        this.uoService.getIrmas(this.compartilhamento.uo.id).then(function (data) {
          var irmas = _.map(data.plain(), function (element) {
            return _.extend({}, element, { tipo: _this4.$translate.instant('core-permissoes.organizacao.compartilhamentos.siblingUos') });
          });
          _this4.uosCompartilhamento = _this4.uosCompartilhamento.concat(irmas);
        });
      }
    }, {
      key: 'carregarUosFilhas',
      value: function carregarUosFilhas() {
        var _this5 = this;

        this.uoService.getFilhas(this.compartilhamento.uo.id).then(function (data) {
          var filhas = _this5.uoArvoreNivel.converterEmLista(data.plain());
          filhas = _.map(filhas, function (element) {
            return _.extend({}, element, { tipo: _this5.$translate.instant('core-permissoes.organizacao.compartilhamentos.childUos') });
          }).filter(function (u) {
            return u.id !== _this5.compartilhamento.uo.id;
          });
          _this5.uosCompartilhamento = _this5.uosCompartilhamento.concat(filhas);
        });
      }
    }, {
      key: 'carregarTipoEntidades',
      value: function carregarTipoEntidades() {
        var _this6 = this;

        this.tipoEntidadeService.getList().then(function (data) {
          if (_this6.todasFilhas) {
            _this6.tipoEntidades = data.plain().filter(function (e) {
              return _this6.ENTIDADES_PERMITIDAS_TODAS_FILHAS.includes(e.enumEntidade);
            });
            _this6.compartilhamento.tipoEntidade = _this6.tipoEntidades[0];
          } else {
            var todas = {
              id: -1,
              nome: 'TODAS AS ENTIDADES',
              enumEntidade: 'TODAS_ENTIDADES',
              todas: true };
            _this6.tipoEntidades = data.plain();
            _this6.tipoEntidades.push(todas);
            _this6.compartilhamento.tipoEntidade = todas;
          }
        });
      }
    }, {
      key: 'carregarDiasDaSemana',
      value: function carregarDiasDaSemana() {
        var _this7 = this;

        this.diasDaSemanaService.getList().then(function (data) {
          _this7.diasDaSemana = data.plain();
        });
      }
    }, {
      key: 'carregarEntidades',
      value: function carregarEntidades() {
        var _this8 = this;

        var enumEntidade = this.compartilhamento.tipoEntidade.enumEntidade,
            uoId = this.compartilhamento.uo.id;

        if (enumEntidade !== null && uoId !== null && this.todasAsEntidades === false) {
          if (!this.compartilhamento.entidades) {
            this.compartilhamento.entidades = [];
          }
          this.entidadeService.getEntidades(enumEntidade, uoId).then(function (data) {
            _this8.entidades = data.plain();
            _this8.compartilhamento.entidades = _this8.entidades.filter(function (entidade) {
              return _this8.compartilhamento.entidades.indexOf(entidade.id) !== -1;
            });
          });
        } else {
          this.entidades = null;
          this.listFail = [];
          this.compartilhamento.entidades = null;
        }
      }
    }, {
      key: 'limparDiasDaSemana',
      value: function limparDiasDaSemana() {
        this.compartilhamento.diasDaSemana = null;
      }
    }, {
      key: 'limparHorario',
      value: function limparHorario() {
        this.compartilhamento.horaInicio = null;
        this.compartilhamento.horaFim = null;
      }
    }, {
      key: 'salvar',
      value: function salvar() {
        var _this9 = this;

        this.setPeriodo();

        if (this.compartilhamento.tipoEntidade.id === -1) {
          this.compartilhamento.tipoEntidade = null;
        }
        if (this.compartilhamento.uoCompartilhada.id === -1) {
          this.compartilhamento.uoCompartilhada = null;
        }

        var compartilhamento = angular.copy(this.compartilhamento);

        if (compartilhamento.entidades && compartilhamento.entidades.length > 0) {
          compartilhamento.entidades = compartilhamento.entidades.map(function (item) {
            return item.id;
          });
        }

        this.compartilhamentoService.post(compartilhamento).then(function () {
          _this9.location.url('/compartilhamentos?saveSuccess=true');
        }).catch(function (responseError) {
          var msg = void 0;
          if (responseError.status === 409) {
            msg = 'Já existe um compartilhamento desse tipo entre as mesmas UOs.';
          }
          _this9.alertMessage.create({
            type: 'error',
            message: 'Erro. ' + (msg || responseError.data.erro),
            appendTo: '.alerta-aqui' });
        });
      }
    }, {
      key: 'setPeriodo',
      value: function setPeriodo() {
        if (this.periodoIndeterminado) {
          this.compartilhamento.periodoInicio = null;
          this.compartilhamento.periodoFim = null;
        } else {
          this.compartilhamento.periodoInicio = this.periodo.startDate.toDate();
          this.compartilhamento.periodoFim = this.periodo.endDate.toDate();
        }
      }
    }, {
      key: 'excluir',
      value: function excluir() {
        var _this10 = this;

        this.modalService.open({
          templateUrl: 'compartilhamentos/confirm-delete-modal/confirm-delete-modal.tpl.html',
          controller: 'ConfirmDeleteModalCtrl',
          controllerAs: 'ctrl',
          size: 'md',
          resolve: {
            compartilhamento: function compartilhamento() {
              return _this10.compartilhamento;
            }
          }
        }).result.then(function () {
          _this10.compartilhamento.remove().then(function () {
            _this10.location.url('/compartilhamentos?deleteSuccess=true');
          }).catch(function (data) {
            _this10.modalInfoConfirmService.confirmModal({
              title: 'Compartilhamento em uso',
              conteudo: data.data.message && data.data.status === 400 ? data.data.message : 'Algo de errado aconteceu.',
              btnPrimario: 'OK'
            });
          });
        });
      }
    }, {
      key: 'limparVariaveisControle',
      value: function limparVariaveisControle() {
        this.todasAsEntidades = true;
        this.compartilhamento.entidades = null;
        this.listFail = [];
        this.listSuccess = [];
      }
    }, {
      key: 'setItens',
      value: function setItens(e) {
        var _this11 = this;

        this.timeout(function () {
          var valueInput = angular.copy(e.search);
          _.uniq(_this11.buildItens(valueInput)).forEach(function (item) {
            e.select(item);
          });
          e.search = '';
        }, 100);
      }
    }, {
      key: 'buildItens',
      value: function buildItens(valueInput) {
        var _this12 = this;

        var regex = /(,|;)/;
        return valueInput.split(regex).filter(function (e) {
          return !regex.exec(e);
        }).filter(function (e) {
          return !!e;
        }).map(function (i) {
          var item = _this12.buildSearch(i),
              search = _this12.entidades.find(function (x) {
            return _this12.buildSearch(x.descricao).includes(item);
          }),
              repetido = !_this12.compartilhamento.entidades.some(function (x) {
            return _this12.buildSearch(x.descricao).includes(item);
          });
          if (search && repetido) {
            return search;
          }
          if (!_this12.listFail.some(function (x) {
            return _this12.buildSearch(x).includes(item);
          }) && repetido) {
            _this12.listFail.push(i);
          }
          return null;
        }).filter(function (e) {
          return !!e;
        });
      }
    }, {
      key: 'buildSearch',
      value: function buildSearch(item) {
        return item.replace(/(\s|-)/g, '').toLowerCase();
      }
    }, {
      key: 'removeInvalidItem',
      value: function removeInvalidItem(index) {
        this.listFail = this.listFail.filter(function (item, i) {
          return i !== index;
        });
      }
    }, {
      key: 'exibirEntidades',
      value: function exibirEntidades() {
        return this.compartilhamento.tipoEntidade && this.compartilhamento.tipoEntidade.id !== this.enumEntidade.TODOS && this.compartilhamento.tipoEntidade.id !== this.enumEntidade.USUARIOS && this.compartilhamento.tipoEntidade.id !== this.enumEntidade.PONTOS_DE_REFERENCIA;
      }
    }, {
      key: 'loadMore',
      value: function loadMore() {
        this.limit += 10;
      }
    }]);

    return CadastroCtrl;
  }();

  /**
   * @ngdoc object
   * @name compartilhamentos.controller:CadastroCtrl
   *
   * @description
   *
   */


  angular.module('compartilhamentos').factory('DiasDaSemana', function (Restangular) {
    return Restangular.service('auth/diasDaSemana');
  }).factory('TipoEntidades', function (Restangular) {
    return Restangular.service('auth/tipo-entidades');
  }).controller('CadastroCtrl', CadastroCtrl);
})();
'use strict';

(function () {
  'use strict';

  angular.module('camadaValor').config(config);

  function config($stateProvider) {
    $stateProvider.state('root.camadaValor', {
      url: '/camada-valor/home',
      views: {
        'content@': {
          templateUrl: 'camada-valor/home/camada-valor-home.tpl.html',
          controller: 'CamadaValorHomeCtrl',
          controllerAs: 'camadaValorHome'
        }
      },
      data: {
        role: 'CAMADA_VALOR_VISUALIZAR'
      }
    }).state('root.camadaValorCadastro', {
      url: '/camada-valor/cadastro',
      views: {
        'content@': {
          templateUrl: 'camada-valor/cadastro/camada-valor-cadastro.tpl.html',
          controller: 'CamadaValorCadastroCtrl',
          controllerAs: 'camadaValorCadastro'
        }
      },
      data: {
        role: 'CAMADA_VALOR_VISUALIZAR'
      }
    }).state('root.camadaValorCadastroHelpTassi', {
      url: '/camada-valor/cadastro/help-tassi',
      views: {
        'content@': {
          templateUrl: 'camada-valor/cadastro/camada-valor-cadastro.tpl.html',
          controller: 'CamadaValorCadastroCtrl',
          controllerAs: 'camadaValorCadastro'
        }
      },
      data: {
        role: 'CAMADA_VALOR_VISUALIZAR'
      }
    }).state('root.camadaValorGerenciar', {
      url: '/camada-valor/gerenciar',
      views: {
        'content@': {
          templateUrl: 'camada-valor/cadastro/camada-valor-cadastro.tpl.html',
          controller: 'CamadaValorCadastroCtrl',
          controllerAs: 'camadaValorCadastro'
        }
      },
      data: {
        role: 'CAMADA_VALOR_EDITAR'
      }
    }).state('root.informativoCamadaValor', {
      url: '/camada-valor/informativo?uo=',
      views: {
        'content@': {
          templateUrl: 'camada-valor/informativo/camada-valor-informativo.tpl.html',
          controller: 'CamadaValorInformativoCtrl',
          controllerAs: 'camadaValorInformativo'
        }
      }
    });
  }
})();
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  var StateUrlService = function () {
    function StateUrlService($location, $window, $rootScope, Authenticator, $state, InformativoKeys, GoogleTagManagerUtils) {
      _classCallCheck(this, StateUrlService);

      this.location = $location;
      this.window = $window;
      this.rootScope = $rootScope;
      this.authenticator = Authenticator;
      this.state = $state;
      this.informativoKeys = InformativoKeys;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
    }

    _createClass(StateUrlService, [{
      key: 'initInterceptBloqueioSolucao',
      value: function initInterceptBloqueioSolucao() {
        this.rootScope.$on('$stateChangeStart', this.interceptBloqueioSolucao.bind(this));
      }
    }, {
      key: 'onPageLoad',
      value: function onPageLoad() {
        var _this = this;

        this.authenticator.getUser().then(function (user) {
          var urlState = _this.location.url();
          if (!_this.state.previous || _this.state.current.name !== _this.state.previous.name) {
            _this.googleTagManagerUtils.sendEventClickGTM('page_view', user, { page: urlState });
          }
        });
      }
    }, {
      key: 'interceptBloqueioSolucao',
      value: function interceptBloqueioSolucao(event, toState) {
        var _this2 = this;

        var informativoState = this.informativoKeys[toState.name];

        this.authenticator.getUser().then(function (user) {
          if (informativoState && toState.data && toState.data.role && !_this2.checkPermissaoSolucaoUsuario(user, toState.data.role)) {
            event.preventDefault();
            _this2.state.go('root.informativo', {
              informativoKey: informativoState[0].key,
              uoId: _this2.rootScope.usuario.uo.id
            });
          }
        });
      }
    }, {
      key: 'checkPermissaoSolucaoUsuario',
      value: function checkPermissaoSolucaoUsuario(user, stateAllowedRoles) {
        var _this3 = this;

        var usuarioRolesSolucao = user.permissoesSolucao;
        if (angular.isString(stateAllowedRoles)) {
          return usuarioRolesSolucao.indexOf(stateAllowedRoles) !== -1;
        }
        if (angular.isArray(stateAllowedRoles)) {
          return stateAllowedRoles.some(function (allowedRole) {
            return _this3.checkPermissaoRole(allowedRole, usuarioRolesSolucao);
          });
        }

        return false;
      }
    }, {
      key: 'checkPermissaoRole',
      value: function checkPermissaoRole(role, permissoes) {
        var _this4 = this;

        if (angular.isString(role)) {
          return permissoes.indexOf(role) !== -1;
        }
        // must have all roles of this when it's an array
        return role.filter(function (roleVal) {
          return _this4.checkPermissaoRole(roleVal, permissoes);
        }).length === role.length;
      }
    }]);

    return StateUrlService;
  }();

  var INTELLIGENCE = 135,
      INTELLIGENCE_VIDEO = 150,
      VFLEETS = 136;
  angular.module('stateUrlModule', ['ui.router', 'v3gAuthenticatorModule', 'enumModule', 'SolucoesModule', 'ConstantModule']).constant('InformativoKeys', {
    'root.camadaValor': { solucoesId: [VFLEETS, INTELLIGENCE, INTELLIGENCE_VIDEO], redirectTo: 'root.informativoCamadaValor' }
  }).service('StateUrlService', StateUrlService);
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  'use strict';

  /* global $ */

  var HeaderCtrl = function HeaderCtrl(Uos, $timeout) {
    var _this = this;

    _classCallCheck(this, HeaderCtrl);

    this.sistema = 'core-permissoes';
    this.authserver = '/usuario';
    this.alertasserver = '/alertas/resources';

    this.uo = {
      id: -1,
      nome: 'Carregando UOs...'
    };
    Uos.getFilhas().then(function (data) {
      return angular.extend(_this.uo, data.plain());
    });
    $timeout(function () {
      $.AdminLTE.tree('.sidebar');
    });

    this.menu = [{ label: 'core-permissoes.organizacao.menuLabel', icon: 'fa-building-o',
      roles: ['UO_VISUALIZAR', 'USUARIO_VISUALIZAR', 'COMPARTILHAMENTOS_VISUALIZAR', 'VEICULO_PERMISSAO_VISUALIZAR', 'ADMIN_VELTEC'],
      submenu: [{ label: 'core-permissoes.organizacao.uos.menuLabel', state: 'root.uos', role: 'UO_VISUALIZAR' }, { label: 'core-permissoes.organizacao.usuarios.menuLabel', state: 'root.usuarios', role: 'USUARIO_VISUALIZAR' }, { label: 'core-permissoes.organizacao.compartilhamentos.menuLabel', state: 'root.compartilhamentos', role: 'COMPARTILHAMENTOS_VISUALIZAR' }, { label: 'core-permissoes.organizacao.transferenciaDeVeiculos.menuLabel', state: 'root.veiculos', role: 'VEICULO_PERMISSAO_VISUALIZAR' }, { label: 'core-permissoes.organizacao.abonoDeImprocedencias.menuLabel', state: 'root.expurgo', role: 'ABONO_VISUALIZAR' }]
    }, { label: 'core-permissoes.configuracoes.menuLabel', icon: 'fa-gears',
      roles: ['ADMIN_VELTEC', 'PERFIL_USUARIO_VISUALIZAR'],
      submenu: [{ label: 'core-permissoes.configuracoes.perfisDeUsuario.menuLabel', state: 'root.perfis', role: 'PERFIL_USUARIO_VISUALIZAR' }]
    }];

    this.menu[0].submenu.push({ label: 'core-permissoes.organizacao.camadaValor.menuLabel', state: 'root.camadaValor', role: 'CAMADA_VALOR_VISUALIZAR' });
  };

  /**
   * @ngdoc object
   * @name corePermissoes.controller:HeaderCtrl
   *
   * @description
   *
   */


  angular.module('headerModule', ['ui.router', 'uoModule', 'enumModule']).controller('HeaderCtrl', HeaderCtrl);
})();
'use strict';

/* global localStorage */
(function () {
  'use strict';

  angular.module('corePermissoes').value('routeOnAuthFail', 'root.uos').config(config);

  function config($urlRouterProvider, $stateProvider, $httpProvider, $locationProvider) {
    $urlRouterProvider.otherwise('/uos');

    $stateProvider.state('root', {
      url: '',
      abstract: true,
      views: {
        header: {
          template: '<v3g-header mostrar-menu-vfleets="true" gerenciar-permissoes="false" mostrar-filtro-uo="false"></v3g-header>',
          controller: 'HeaderCtrl',
          controllerAs: 'headerCtrl'
        }
      },
      resolve: {
        auth: function auth(Authenticator, FeaturehubJsSdk) {
          return Authenticator.init().then(function () {
            return Authenticator.getUser();
          }).then(function (usuario) {
            return addFeatureHubAttributes(FeaturehubJsSdk, usuario).catch(function () {
              return undefined;
            }).then(function () {
              return usuario;
            });
          });
        },
        translateReady: ['$translate', function ($translate) {
          return $translate.onReady();
        }]
      }
    }).state('unprotected', {
      abstract: true,
      views: {
        header: {
          template: '<div data-ui-view="guest@" class="view-content"></div>'
        }
      }
    });

    $locationProvider.html5Mode(true);

    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.headers.common.Accept = 'application/json';
    $httpProvider.interceptors.push(['$rootScope', '$q', 'Flash', '$window', '$injector', '$translate', function ($rootScope, $q, Flash, $window, $injector, $translate) {
      return {
        responseError: function responseError(rejection) {
          var authenticator = $injector.get('Authenticator'),
              user = $rootScope.usuario;
          if (rejection.status === 401) {
            if (user) {
              var keysLocalStorage = Object.keys(angular.fromJson(angular.toJson(localStorage)));
              keysLocalStorage.forEach(function (key) {
                if (key.endsWith('-' + user.id)) {
                  localStorage.removeItem(key);
                }
              });
            }

            localStorage.removeItem('vfleets-oauth2-authorization');
            authenticator.init();
          } else if (rejection.status === 403) {
            Flash.create('danger', 'Erro! Usuário sem permissão para acessar este recurso.');
          } else if (rejection.status === 404) {
            Flash.create('danger', 'Erro! Serviço não encontrado.');
          } else if (rejection.data && rejection.data.message) {
            Flash.create('danger', rejection.data.message);
          } else {
            $translate('core-permissoes.organizacao.usuarios.popup.requestingTheServerMessageError').then(function (translatedMessage) {
              Flash.create('danger', translatedMessage);
            });
          }
          return $q.reject(rejection);
        }
      };
    }]);
  }

  function addFeatureHubAttributes(FeaturehubJsSdk, user) {
    if (!FeaturehubJsSdk || !user) {
      return Promise.resolve();
    }

    var uoId = user.uo && user.uo.id,
        role = user.perfil && user.perfil.nome;

    return FeaturehubJsSdk.setUserKey(user.id).then(function () {
      return FeaturehubJsSdk.setAttributeValue('uo', uoId);
    }).then(function () {
      return FeaturehubJsSdk.setAttributeValue('uoId', uoId);
    }).then(function () {
      return FeaturehubJsSdk.setAttributeValue('email', user.email);
    }).then(function () {
      return FeaturehubJsSdk.setAttributeValue('role', role);
    });
  }
})();